// import "./App.css";
import '../../assets/css/myproject/AppLeftSection.css';
import '../../assets/css/myproject/AppRightSection.css';
import '../../assets/css/myproject/AppTopSection.css';
import '../../assets/css/myproject/AppSubRightSection.css';
import {
  hasMaterialModifications,
  hasSkinnedMeshInHierarchy,
  hasThreeMaterialEditsInHierarchy,
  hasWireframeInHierarchy,
  isDuplicateSceneAsset,
  resolvePublishGlbSource,
  SKIP_GLB_FILE_UPLOAD,
  cacheGlbFileOnSceneObject,
  hasEditorAssignedMapsInHierarchy,
} from '../Training/utils/gridpageUtils.js';
import {
  buildMaterialSettingsPayload,
  mergeMaterialSettingsForPublish,
  sanitizeMaterialSettingsForApi,
  pickObjectLevelMaterialSettingsForApi,
} from '../../components/gridpagefunction/materialFunction.js';
import * as Three from 'three';
import toast from 'react-hot-toast';
import { TransformControls } from '../../utils/ThreeJsUtils/TransformControls.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import {
  disposeSelectionOutline,
  initSelectionOutline,
  registerOutlineUiLayerObjects,
  registerOutlineTransformControls,
  renderViewportWithSelectionOutline,
  resizeSelectionOutline,
  setSelectionOutlineEnabled,
  syncSelectionOutlineFromStore,
  clearSelectionOutline,
} from '../../utils/ThreeJsUtils/selectionOutline.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
// import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader';
import { updateSplatViewer } from '../../components/gridpagefunction/MeshPly';
import { handleLibraryAssetImport } from '../../components/gridpagefunction/LibraryAsset';
import { registerLibraryIdentity } from '../../components/gridpagefunction/Mesh';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import ReferenceObject, {
  getReferenceObject,
} from '../../components/gridpagefunction/referenceobject.jsx';
import axios from 'axios';
import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from 'react';
import {
  LoadContent,
  LoadContentPreview,
} from '../../utils/ThreeJsUtils/Content.js';
import { useParams, useLocation } from 'react-router';
import AppRightSection from '../../components/layout/gridpage/AppRightSection.jsx';
import AppLeftSection from '../../components/layout/gridpage/AppLeftSection.jsx';
import AppSubRightSection from '../../components/layout/gridpage/AppSubRightSection.jsx';
import PreviewControls from '../../components/layout/gridpage/PreviewControls.jsx';
import { ViewHelper } from 'three/examples/jsm/helpers/ViewHelper.js';
// import Stats from 'three/addons/libs/stats.module.js';
import {
  removeHotspot,
  setHotspotBillboardEnabled,
  toggleHotspotMessage,
  setHotspotRegistryPreviewMode,
  prepareHotspotsForDesignMode,
  syncHotspotDesignQuaternion,
  refreshHotspotMessageLayouts,
  handleHotspotClick,
  handleHotspotHover,
  syncHotspotsForPreviewMode,
} from '../../components/gridpagefunction/HotSpot.js';
import PublishData from '../../components/gridpagefunction/PublishData.jsx';
import ConfirmationModel from '../../components/ConfirmationModel.jsx';
import store from '../../redux/store.js';
import useParticleSync from '../../Hooks/useParticleSync.js';
import usePhysics from '../../Hooks/usePhysics.js';
import { transformPhysicsDataForBackend } from '../../utils/Physics/PhysicsUtils.js';
import { set_delete_objects } from '../../redux/Slice/gridDeleteSlice.js';
import { useSelector } from 'react-redux';
import {
  setIsConfirmationOpen,
  setLoading,
  setLoadingMessage,
  updateActiveComponent,
  setIdToDelete,
  setPolyCount,
  setSceneScreenshot,
  setIsPublishing,
  setSelectedLightId,
} from '../../redux/Slice/globalStates.js';
import {
  cleanAllAnimationObjects,
  removeAnimationObject,
} from '../../redux/Slice/animationSlice.js';
import {
  lightDataUpdate,
  remove_assets_by_id,
  removeIntersectedObject,
  removeSceneObject,
  selected_object,
  setSceneMeshes,
  setMaterialHighlightMeshes,
  updateOpenModals,
  clearAssets,
  setPushIntersectedObject,
  removeLight,
  removeCamera,
  cameraPropertiesUpdate,
} from '../../redux/Slice/gridSlice.js';
import {
  toDegrees,
  UnauthorizedFunction,
  UpdateOpenModalState,
  updatePreviewDimention,
  syncDesignViewportSize,
} from '../../utils/UtilsFunction.js';
import { update_full_window_size } from '../../redux/Slice/windowTypeSlice.js';
import { CameraSwitcher, ViewHelperComponent } from '../../utils/gridUtils.js';
import useTransformControlsHotkeys from '../../Hooks/useTransformControlsHotkeys.js';
import {
  clearMultiSelection,
  getMultiSelection,
  selectAllObjects,
} from '../../utils/selectAllObjects.js';
import { createGridViewportMouseDownHandler, pickViewportObject, resolveEditorSelectableObject } from '../../utils/ThreeJsUtils/gridViewportSelection.js';
import {
  canEditPivot,
  startPivotEdit,
  confirmPivotEdit,
  cancelPivotEdit,
  hasActivePivotSession,
  getPivotPublishFields,
  nestPivotFieldsInSettings,
  embedPivotInEvents,
  cachePivotRestoreData,
  movePivotToMeshCenter,
} from '../../utils/ThreeJsUtils/pivotEditor.js';
import { setMultiSelectionContext } from '../../utils/multiSelectionTransform.js';
import useLightHook from '../../Hooks/useLight.js';
import {
  exportTextMeshToGLB,
  getTextPublishPanelScale,
} from '../../components/gridpagefunction/Text.js';
import { exportShapeAsGLB } from '../../components/GridAssets/AssetsLibrary.jsx';
import { syncAllMeshHierarchyFromRedux } from '../../components/GridAssets/shapeAssetUtils.js';
import { cleanupParticleSystem } from '../../utils/particles/particleCleanupUtils.js';
import AppTopNew from '../../components/layout/gridpage/AppTopNew.jsx';
import UploadSection from '../../components/layout/NewGridComponent/UploadSection.jsx';
import LibrarySection from '../../components/layout/NewGridComponent/LibrarySection.jsx';
import { LightInitialData } from '../../utils/constant.js';
import usePreviewResize from '../../Hooks/usePreviewResize.js';
import { startAllSceneAnimations, stopAllSceneAnimations, registerPreviewAnimationRefs } from '../../utils/preview/startAllSceneAnimations.js';
import { prepareSceneTransformsForPublish } from '../../utils/preview/prepareSceneForPublish.js';
import { stopAllSceneMedia } from '../../utils/preview/stopAllSceneMedia.js';
import ArVrExperience from '../../components/ArVrExperience.jsx';
import {
  clearParticles,
  removeParticle,
  setSelectedParticle,
} from '../../redux/Slice/particleSlice.js';
import AnimationComponentNew from '../../components/AddComponents/AnimationComponentNew.jsx';
import ParticleAnimationTest from '../../components/AddComponents/ParticleAnimationTest.jsx';
import {
  applyAnimationsToSceneObjects,
  resetAnimationsToOriginalState,
} from '../../utils/ThreeJsUtils/applyAnimations.js';
import { sceneStateHelper } from '../../utils/ThreeJsUtils/SceneStateHelper';
import { applyGridTransformUpdate } from '../../utils/ThreeJsUtils/syncObjectTransform';
import { createCameraFreeMotion } from '../../utils/ThreeJsUtils/cameraFreeMotion.js';
import {
  getPublishAssetVisible,
  getPublishVisibleForAsset,
  isLiveSceneObject3D,
  mapParticlesForPublish,
  resolveLiveSceneObject,
  syncSceneVisibilityFromStore,
} from '../../utils/ThreeJsUtils/assetVisibilityUtils.js';
import {
  clearSceneLightsAndHelpers,
  resolveLightTransformTarget,
  sanitizeLightPayloadForApi,
  syncAllLightHelpersVisibility,
  syncDescendantLightHelpers,
  syncLightHelperForSceneObject,
  isPendingLightSelectionId,
} from '../../utils/ThreeJsUtils/lightHelperUtils.js';
import { videoMeshScaleToSavedScale } from '../../utils/videoScaleUtils.js';
import {
  findSceneObjectByEventAssetId,
  getPreviewInteractableObjects,
  remapEventsForPublish,
  remapSceneEventAssetIds,
  syncPreviewAssetEvents,
  normalizeEventTrigger,
} from '../../utils/eventAssetUtils.js';
import {
  getCameraHelperVisible,
  getCameraStableId,
  isDescendantOfSceneCamera,
  isSceneCamera,
  isSceneCameraOrPoint,
  isSceneCameraPoint,
  resolveSceneCameraFromPoint,
  resolveSceneCameraObject,
  syncCameraHelperVisibility,
} from '../../utils/ThreeJsUtils/sceneCameraUtils.js';
import {
  disableTransformControlsShadows,
  SCENE_LIGHTS_CLEARED_EVENT,
} from '../../utils/ThreeJsUtils/lightShadowUtils.js';
import { syncParticlePointSizesForCamera } from '../../utils/particles/syncParticlePointSizesForCamera.js';
import { applyAnimationsToObject } from '../../components/layout/gridpage/AppLeftSection/utils/animationFunctions.js';
import { findObjectInScene, safeRemoveFromParent } from '../../components/layout/gridpage/AppLeftSection/utils/hierarchyUtils.js';
import {
  getAnimatableObject,
  ensureGlbMixer,
} from '../../components/AddComponents/AnimationComponent/handlers/animationEffectHandlers';
import {
  CancelBtnImage,
  CancelBtnModel,
  CancelBtnVideo,
  clearSceneAssets,
  debounce,
  debouncedLightUpdate,
  debouncedParticleUpdate,
  debouncedGridTransformUpdate,
  getPolyCount,
  getUIElements,
  handleHdriSelected,
  UpdateUI,
  uploadOptions,
} from '../../components/layout/gridpage/GridPageFunctions.js';
import {
  syncHdriBackgroundForCamera,
  getOrthoFarForHdriBackground,
} from '../../utils/ThreeJsUtils/hdriSceneBackground.js';
import {
  updateCameraHelperFrustum,
  snapshotSceneCameraTransforms,
  restoreSceneCameraTransforms,
  syncSceneCamerasFromReduxProperties,
  getCameraLookupId,
} from '../../components/gridpagefunction/Camera.js';
import { clampSelectionForChildMode } from '../../components/gridpagefunction/MeshExtractation.js';
import {
  applyViewportCameraDefaults,
  perspectiveToOrthographicZoom,
  syncViewportCameraSwitch,
  updateOrthographicFrustum,
  VIEWPORT_CAMERA_FOV,
} from '../../utils/ThreeJsUtils/viewportCameraSync.js';
import undoRedoManager from '../../utils/UndoRedoManager.js';
import {
  beginGridHistoryEdit,
  flushGridHistoryEdit,
  cancelPendingGridHistoryCommit,
} from '../../utils/gridHistoryMiddleware.js';
import {
  captureGridHistoryState,
  isApplyingGridHistorySelection,
  registerDetachedObjectsForUndo,
  setGridHistoryScene,
  setGridHistoryEditorContext,
  setGridHistorySelectionHandler,
} from '../../utils/gridHistory.js';
import {
  captureDiscreteHistoryBefore,
  recordDiscreteHistoryAfter,
} from '../../utils/gridHistoryDiscrete.js';
import { suppressGridHistory } from '../../utils/gridHistorySuppress.js';
import { startFreshGridHistory } from '../../utils/gridHistorySession.js';
import { enableDragDrop } from '../../components/gridpagefunction/Drag-Drop.js';
import { SplatLoader } from '@sparkjsdev/spark';
import CannonDebugRenderer from '../../utils/ThreeJsUtils/CannonDebugRenderer';
import {
  isUnderParticleAnimationSystem,
  resumeSceneParticleAnimations,
  reviveParticleOnSelect,
  isParticleAnimationRoot,
  resolveParticleAnimationRoot,
} from '../../utils/particles/particleAnimationUtils';
import { clearSceneParticleLifeTimeouts } from '../../utils/particles/lifeUtils';
import {
  playMeshAudio,
  pauseMeshAudio,
  stopMeshAudio,
  stopAllSceneAudio,
  playPreviewAudioOnAwake,
  resumeAudioContext,
  isAudioMesh,
} from '../../utils/audioPlaybackUtils.js';
// import {
//   redoStack,
//   undoStack,
// } from '../../components/gridpagefunction/UndoReedo.js';
// import { removeCamera } from '../../redux/Slice/cameraSlice.js';

var isTransformActive = false;

let projectId;
let currentProjectName = '';

var transformControls;
var controlsOrbit, camera;
const scene = new Three.Scene();
let cannonDebugRenderer = null;
let cachedUIElements = null;
export const rendererRef = { current: null };
var selectedObject;
var helper = null;
var helperRenderer = null;
var mixer;
var gridAssets = {};
let globalShowCameraHelper = null;
let globalSyncCameraHelperVisibility = null;
let globalShowLightHelpers = null;
let onPrimarySelectionChanged = null;
let toRemove = [];
let initialTransform = null;
let isPublishing = false;

// ═══════ CHILD SELECTION MODE STATE ═══════
// When a parent asset is double-clicked in the left panel, enable child selection for that parent
let activeParentForChildSelection = null; // Tracks which parent is in "child selection mode"

// Export function to enable/disable child selection mode
export const setChildSelectionMode = (parentObject, options = {}) => {
  const { silent = false } = options;
  // Safety check: verify parent object still exists in scene
  if (parentObject && !scene.getObjectByName(parentObject.name)) {
    console.warn(
      '[Child Selection] Parent object no longer in scene:',
      parentObject.name
    );
    activeParentForChildSelection = null;
    if (!silent) {
      toast.success(
        'Parent object was deleted. Child Selection Mode disabled.'
      );
    }
    return;
  }

  activeParentForChildSelection = parentObject;
  if (silent) return;

  if (parentObject) {
    toast.success(
      `Child Selection Mode: Enabled for "${parentObject.name || 'Parent Object'}". Press ESC to disable.`
    );
  } else {
    toast.success('Child Selection Mode: Disabled');
  }
};

// Export function to check if child selection is enabled
export const isChildSelectionEnabled = () =>
  activeParentForChildSelection !== null;

// Export function to get active parent
export const getActiveParentForChildSelection = () =>
  activeParentForChildSelection;

export const isChildSelectionActiveFor = (object) =>
  !!object && activeParentForChildSelection === object;

/** Double-click toggle: enable child mode for this GLB, or disable if already active. */
export const toggleChildSelectionMode = (parentObject) => {
  if (!parentObject) {
    setChildSelectionMode(null);
    return false;
  }
  if (activeParentForChildSelection === parentObject) {
    setChildSelectionMode(null);
    return false;
  }
  setChildSelectionMode(parentObject);
  return true;
};

// Function to create sprite materials for ViewHelper
function getSpriteMaterialForViewHelper(colorHex) {
  const size = 256; // higher resolution
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = size;
  const ctx = canvas.getContext('2d');

  // Clear with full transparency
  ctx.clearRect(0, 0, size, size);

  // Draw solid circle — no transparency bleed
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size * 0.25, 0, Math.PI * 2);
  ctx.fillStyle = colorHex;
  ctx.fill();

  const texture = new Three.CanvasTexture(canvas);

  // Force accurate pixel representation
  texture.minFilter = Three.NearestFilter;
  texture.magFilter = Three.NearestFilter;
  texture.generateMipmaps = false;
  texture.anisotropy = 1;
  texture.needsUpdate = true;
  texture.colorSpace = Three.LinearSRGBColorSpace;

  return new Three.SpriteMaterial({
    map: texture,
    transparent: true,
    depthTest: false,
    depthWrite: false,
    sizeAttenuation: false,
  });
}

// Function to apply styling to ViewHelper
window.applyViewHelperStyling = (helperToStyle) => {
  if (!helperToStyle) return;

  const spriteMats = {
    posX: getSpriteMaterialForViewHelper('#f9535d'), // red
    posY: getSpriteMaterialForViewHelper('#29ffcd'), // green
    posZ: getSpriteMaterialForViewHelper('#348ccb'), // blue
    default: getSpriteMaterialForViewHelper('#404040'), // gray
  };

  helperToStyle.children.forEach((child, i) => {
    // 1. Axis lines (Meshes 0, 1, 2 for X, Y, Z)
    if (child.type === 'Mesh') {
      const axisColors = ['#efa9ac', '#7ebce8', '#29ffcd']; // X,Z,Y
      if (axisColors[i]) {
        child.material.color.set(axisColors[i]);
        child.material.needsUpdate = true;
      }
    }

    // 2. Dots (Sprites with userData.type)
    if (child.type === 'Sprite') {
      const type = child.userData?.type;
      if (spriteMats[type]) {
        child.material = spriteMats[type];
      } else {
        child.material = spriteMats.default; // gray for negX/Y/Z or others
      }
    }
  });
};

// Function to update ViewHelper scale based on animation state
window.updateViewHelperScale = (helperToScale, isAnimMin) => {
  if (!helperToScale) return;

  if (isAnimMin) {
    helperToScale.scale.set(0.6, 0.6, 0.6); // bigger
    // helperToScale.position.set(0.6, -0.6, 0);
  } else {
    helperToScale.scale.set(0.5, 0.5, 0.5); // smaller
    helperToScale.position.set(0.6, -0.6, 0);
  }
};

const notify = (message) => toast.error(message, { id: message });

// Utility function to clean up invalid materials from the scene
const cleanupInvalidMaterials = (sceneToClean) => {
  if (!sceneToClean || typeof sceneToClean.traverse !== 'function') {
    console.warn('Invalid scene provided to cleanupInvalidMaterials');
    return 0;
  }

  const invalidObjects = [];

  try {
    sceneToClean.traverse((obj) => {
      if (!obj) return;
      // Skip audio/video icon meshes - their materials are valid and should not be stripped
      if (obj.deleteType === 'audio' || obj.deleteType === 'video') return;

      try {
        if (obj.isMesh && obj.material) {
          const materials = Array.isArray(obj.material)
            ? obj.material
            : [obj.material];

          for (const mat of materials) {
            if (!mat) {
              invalidObjects.push(obj);
              break;
            }

            try {
              // Check if material has been disposed or has invalid uniforms
              if (typeof mat.uuid === 'undefined' || !mat.type) {
                console.warn(
                  'Found object with invalid material:',
                  obj.name || 'unnamed'
                );
                invalidObjects.push(obj);
                break;
              }

              // Check and fix invalid textures
              const textureProps = [
                'map',
                'normalMap',
                'emissiveMap',
                'metalnessMap',
                'roughnessMap',
                'alphaMap',
                'aoMap',
                'bumpMap',
                'displacementMap',
                'lightMap',
                'specularMap',
              ];

              for (const prop of textureProps) {
                if (mat[prop]) {
                  try {
                    // Try to access texture properties to verify it's valid
                    const texture = mat[prop];
                    if (!texture || typeof texture.uuid === 'undefined') {
                      console.warn(
                        `Removing invalid ${prop} texture from object:`,
                        obj.name || 'unnamed'
                      );
                      mat[prop] = null;
                      if (mat.needsUpdate !== undefined) {
                        mat.needsUpdate = true;
                      }
                    }
                  } catch (e) {
                    // Texture is invalid, remove it
                    console.warn(
                      `Caught error accessing ${prop} texture, removing:`,
                      obj.name || 'unnamed',
                      e
                    );
                    try {
                      mat[prop] = null;
                      if (mat.needsUpdate !== undefined) {
                        mat.needsUpdate = true;
                      }
                    } catch (setError) {
                      console.error('Failed to remove texture:', setError);
                    }
                  }
                }
              }
            } catch (matError) {
              console.warn('Error processing material:', matError);
              invalidObjects.push(obj);
              break;
            }
          }
        }
      } catch (objError) {
        console.warn('Error checking object:', obj.name || 'unnamed', objError);
        if (obj.isMesh) {
          invalidObjects.push(obj);
        }
      }
    });
  } catch (traverseError) {
    console.error('Error traversing scene:', traverseError);
    return 0;
  }

  // Remove objects with completely invalid materials
  let removedCount = 0;
  invalidObjects.forEach((obj) => {
    try {
      if (!obj || !sceneToClean) return;

      console.warn(
        'Removing object with invalid material from scene:',
        obj.name || 'unnamed'
      );

      // Remove from scene
      if (typeof sceneToClean.remove === 'function') {
        sceneToClean.remove(obj);
      }

      // Cleanup resources
      try {
        if (obj.geometry && typeof obj.geometry.dispose === 'function') {
          obj.geometry.dispose();
        }
      } catch (geoError) {
        console.warn('Error disposing geometry:', geoError);
      }

      try {
        if (obj.material) {
          const mats = Array.isArray(obj.material)
            ? obj.material
            : [obj.material];
          mats.forEach((m) => {
            try {
              if (m && typeof m.dispose === 'function') {
                m.dispose();
              }
            } catch (matDisposeError) {
              console.warn('Error disposing material:', matDisposeError);
            }
          });
        }
      } catch (matError) {
        console.warn('Error disposing materials:', matError);
      }

      removedCount++;
    } catch (removeError) {
      console.error('Error removing object:', removeError);
    }
  });

  return removedCount;
};

function serializeSceneState() {
  const getObjectData = (obj) => ({
    name: obj.name,
    events: obj.events,
    position: [obj.position.x, obj.position.y, obj.position.z],
    rotation: [obj.rotation.x, obj.rotation.y, obj.rotation.z],
    scale: [obj.scale.x, obj.scale.y, obj.scale.z],
    userData: obj.userData,
    type: obj.type,
    url: obj.url || obj.name,
    parent: obj.parent
      ? obj.parent.name || obj.parent.url || obj.parent._id
      : null,
  });

  const state = store.getState();
  const {
    sceneMeshes,
    sceneHotspots = [],
    sceneImages,
    sceneVideos,
    sceneAudios,
  } = state.assets_object;

  const sceneText = scene.children.filter((val) => val?.deleteType === 'text');
  const sceneLight = scene.children.filter(
    (val) => val?.deleteType === 'Light'
  );
  const particles = state.particles?.particles || [];

  return {
    meshes: sceneMeshes?.map(getObjectData),
    hotspots: sceneHotspots?.map(getObjectData),
    images: sceneImages?.map(getObjectData),
    videos: sceneVideos?.map(getObjectData),
    audios: sceneAudios?.map(getObjectData),
    text: sceneText?.map(getObjectData),
    Light: sceneLight?.map(getObjectData),
    particles, // ← now included
  };
}
function LoadPly(url) {
  const loader = new SplatLoader();
  loader.load(
    url,
    function (ply) {
      scene.add(ply.scene);
    },
    (xhr) => {},
    (error) => {}
  );
}

function makerGlb(url) {
  const loader = new GLTFLoader();

  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath(
    'https://www.gstatic.com/draco/versioned/decoders/1.5.6/'
  );
  loader.setDRACOLoader(dracoLoader);

  loader.load(
    url,
    function (gltf) {
      scene.add(gltf.scene);
    },
    function (xhr) {},
    function (error) {}
  );
}

let videoPlaying = false;
var video;

var audio;

// Add these variables at the top with other camera-related variables

let orthographicCamera;
let perspectiveCamera;
let currentCamera;

// Helper to always update both currentCamera and camera
function setCurrentCamera(newCamera) {
  currentCamera = newCamera;
  camera = newCamera;
  window.currentCamera = newCamera;
  window.camera = newCamera;
  if (controlsOrbit) {
    controlsOrbit.object = newCamera;
    controlsOrbit.update();
  }
  // Update transform controls camera reference
  if (transformControls) {
    transformControls.camera = newCamera;
  }
  if (rendererRef.current) {
    rendererRef.current.render(scene, newCamera);
  }

  syncHdriBackgroundForCamera(scene, newCamera);

  // PointsMaterial sizeAttenuation is perspective-only — keep particles visible in ortho.
  if (scene && newCamera) {
    const h =
      rendererRef.current?.domElement?.clientHeight ||
      rendererRef.current?.domElement?.height ||
      window.innerHeight;
    syncParticlePointSizesForCamera(scene, newCamera, h);
  }

  // Update ViewHelper with new camera
  if (helper && helperRenderer) {
    try {
      // Recreate the ViewHelper with the new camera
      helper = new ViewHelper(newCamera, helperRenderer.domElement);
      if (controlsOrbit) {
        helper.controls = controlsOrbit;
        helper.controls.center = controlsOrbit.target;
      }
      helper.position.set(0.6, -0.6, 0);

      // Reapply scale based on animation minimized state
      if (
        window.updateViewHelperScale &&
        typeof window.updateViewHelperScale === 'function'
      ) {
        window.updateViewHelperScale(helper, window.currentHelperScale);
      }

      // Reapply styling to the recreated helper
      if (
        window.applyViewHelperStyling &&
        typeof window.applyViewHelperStyling === 'function'
      ) {
        window.applyViewHelperStyling(helper);
      }
    } catch (e) {
      console.warn('Error updating ViewHelper camera:', e);
    }
  }
}

export const updateCameraPreview = (addData) => {
  if (rendererRef.current && camera) {
    rendererRef.current.setSize(addData.width, addData.height);
    camera.aspect = addData.width / addData.height;
    camera.updateProjectionMatrix();
  }
};

function resolveAssetDeleteType(object) {
  if (!object) return null;
  if (object.deleteType) return object.deleteType;
  switch (object.type) {
    case 'Image':
      return 'image';
    case 'Video':
      return 'video';
    case 'Audio':
      return 'audio';
    case 'Text':
      return 'text';
    case 'Mesh':
      return 'mesh';
    default:
      return null;
  }
}

function isInternalThreeChild(child) {
  return (
    child?.type === 'PositionalAudio' ||
    child?.type === 'Audio' ||
    child?.type === 'AudioListener'
  );
}

/** Asset id for API/Redux — never use Three.js Object3D's numeric `.id`. */
function getSceneAssetId(object) {
  if (!object) return null;
  if (object.isObject3D === true) {
    return (
      object._id ||
      object.url ||
      object.name ||
      object.temp_file_name ||
      object.userData?.text_material?.id ||
      object.userData?.text_material?._id ||
      null
    );
  }
  return (
    object._id ||
    object.id ||
    object.url ||
    object.name ||
    object.temp_file_name ||
    object.text_material?.id ||
    null
  );
}

function formatDeleteItemForApi(val) {
  const id = getSceneAssetId(val);
  return {
    url:
      val?.url ||
      val?._id ||
      val?.name ||
      val?.temp_file_name ||
      val?.userData?.text_material?.id ||
      val?.text_material?.id,
    deleteType: val?.deleteType,
    id,
  };
}

function getAllAssetIdAliases(object) {
  const ids = new Set();
  if (!object) return ids;
  [
    object._id,
    object.url,
    object.name,
    object.temp_file_name,
    object.userData?.text_material?.id,
    object.userData?.text_material?._id,
    object.text_material?.id,
    object.text_material?._id,
  ]
    .filter(Boolean)
    .forEach((id) => ids.add(String(id)));
  return ids;
}

function collectHierarchyDescendantsForDeletion(parentObject, scene) {
  const deletedIds = new Set();
  const targets = [];

  const addTarget = (target) => {
    const assetId = getSceneAssetId(target);
    if (!assetId || deletedIds.has(assetId)) return;
    deletedIds.add(assetId);
    targets.push(target);
  };

  const collectSceneDescendants = (obj) => {
    obj.children?.forEach((child) => {
      if (isInternalThreeChild(child)) return;
      if (resolveAssetDeleteType(child)) {
        addTarget(child);
      }
      collectSceneDescendants(child);
    });
  };
  collectSceneDescendants(parentObject);

  const queue = [...getAllAssetIdAliases(parentObject)];
  const visitedParents = new Set();
  while (queue.length > 0) {
    const currentParentId = queue.shift();
    if (!currentParentId || visitedParents.has(currentParentId)) continue;
    visitedParents.add(currentParentId);

    const state = store.getState();
    ['image', 'mesh', 'video', 'audio', 'text', 'hotspot'].forEach((type) => {
      (state.assets_object.assets_data?.[type] || []).forEach((asset) => {
        const assetId =
          getSceneAssetId(asset) ||
          asset.text_material?.id ||
          asset.text_material?._id;
        if (!assetId || deletedIds.has(String(assetId))) return;

        const parentRef = asset.parent;
        const assetParentId =
          typeof parentRef === 'object'
            ? getSceneAssetId(parentRef) ||
              parentRef?.text_material?.id ||
              parentRef?.text_material?._id
            : parentRef;

        if (
          assetParentId &&
          String(assetParentId) === String(currentParentId)
        ) {
          const sceneObj = findObjectInScene(scene, assetId);
          addTarget(sceneObj || { ...asset, deleteType: type });
          queue.push(String(assetId));
        }
      });
    });
  }

  return targets;
}

function deleteHierarchyDescendants(parentObject, scene) {
  collectHierarchyDescendantsForDeletion(parentObject, scene).forEach(
    (target) => {
      const deleteType = target.deleteType || resolveAssetDeleteType(target);
      const assetId = getSceneAssetId(target);

      if (target?.isObject3D) {
        if (deleteType === 'particle') {
          cleanupParticleSystem(target);
        }
        removeObjectRecursively(target, scene);
      }

      if (!deleteType || !assetId) return;

      if (deleteType === 'particle') {
        store.dispatch(removeParticle(assetId));
      } else {
        store.dispatch(
          remove_assets_by_id({
            type: deleteType,
            id: assetId,
            url: assetId,
          })
        );
        store.dispatch(
          set_delete_objects({
            type: 'add',
            data: formatDeleteItemForApi({ ...target, deleteType }),
          })
        );
      }
    }
  );
}

/**
 * Detach a Three.js object from the scene graph.
 * Hierarchy can leave parent.children frozen — never call .remove bare.
 */
function detachObjectFromSceneGraph(object) {
  if (!object?.isObject3D) return;

  const parent = object.parent;
  if (parent && typeof parent.remove === 'function') {
    try {
      safeRemoveFromParent(object);
      return;
    } catch (_) {
      /* fall through to scene.remove */
    }
  }

  // Corrupted parent (string id, Redux asset, etc.)
  if (parent && typeof parent.remove !== 'function') {
    try {
      object.parent = null;
    } catch (_) {
      /* ignore */
    }
  }

  if (scene && typeof scene.remove === 'function') {
    try {
      scene.remove(object);
    } catch (_) {
      if (Array.isArray(scene.children) && scene.children.includes(object)) {
        scene.children = scene.children.filter((c) => c !== object);
      }
      try {
        object.parent = null;
      } catch (_) {
        /* ignore */
      }
    }
  }
}

function removeObjectRecursively(object, scene) {
  if (!object) return;

  if (object.children?.length > 0) {
    [...object.children].forEach((child) => {
      if (isInternalThreeChild(child)) return;
      removeObjectRecursively(child, scene);
    });
  }

  const objectId = getSceneAssetId(object);
  const assetDeleteType = resolveAssetDeleteType(object);

  if (assetDeleteType === 'audio') {
    stopMeshAudio(object);
  }

  if (assetDeleteType && assetDeleteType !== 'particle') {
    store.dispatch(
      remove_assets_by_id({
        type: assetDeleteType,
        id: objectId,
        url:
          object.url ||
          object._id ||
          object.name ||
          object.temp_file_name ||
          object.userData?.text_material?.id,
      })
    );
  }

  if (
    object.type === 'AmbientLight' ||
    object.type === 'DirectionalLight' ||
    object.type === 'PointLight' ||
    object.type === 'SpotLight' ||
    object.type === 'RectAreaLight'
  ) {
    store.dispatch(removeLight(object.name));
  }
  if (object.type === 'particle' || object.deleteType === 'particle') {
    store.dispatch(removeParticle(object.name));
  }

  if (assetDeleteType && assetDeleteType !== 'particle') {
    store.dispatch(
      set_delete_objects({
        type: 'add',
        data: {
          url:
            object.url ||
            object._id ||
            object.name ||
            object.temp_file_name ||
            object.userData?.text_material?.id,
          id: objectId,
          _id: object._id || objectId,
          name: object.name,
          deleteType: assetDeleteType,
        },
      })
    );
  }

  store.dispatch(removeSceneObject(object));
  detachObjectFromSceneGraph(object);
}

function recursiveDeletionOfAnimationObjects(
  animationObjects,
  objectId,
  visited = new Set(),
  depth = 0,
  MAX_DEPTH = 20
) {
  if (
    !animationObjects ||
    animationObjects.length === 0 ||
    !objectId ||
    visited.has(objectId) ||
    depth > MAX_DEPTH
  ) {
    return;
  }

  visited.add(objectId);

  for (const obj of animationObjects) {
    if (obj.objectId === objectId || obj.id === objectId) {
      store.dispatch(removeAnimationObject(obj.id));
    }
  }

  const originalObject = scene.getObjectByName(objectId);
  if (!originalObject || !originalObject.children) return;

  for (const child of originalObject.children) {
    recursiveDeletionOfAnimationObjects(
      animationObjects,
      child.name,
      visited,
      depth + 1,
      MAX_DEPTH
    );
  }
}

function clearSelectionAfterDelete() {
  if (transformControls && typeof transformControls.detach === 'function') {
    transformControls.detach();
  }
  selectedObject = null;
  store.dispatch(selected_object(null));
  store.dispatch(setSelectedLightId(null));
  clearMultiSelection();
  if (onPrimarySelectionChanged) {
    onPrimarySelectionChanged(null);
  }
  if (globalSyncCameraHelperVisibility) {
    globalSyncCameraHelperVisibility(null, true);
  } else if (globalShowCameraHelper) {
    globalShowCameraHelper(false);
  }
  UpdateUI(null, cachedUIElements);
  store.dispatch(
    updateOpenModals({
      name: 'text',
      isOpen: false,
    })
  );
}

function DeleteMesh(setPolyCount, polyCount, objectt, options = {}) {
  const { bulkMode = false } = options;
  const recordUndo = !bulkMode && options.recordUndo !== false;
  const beforeSnapshot =
    recordUndo && selectedObject ? captureDiscreteHistoryBefore(scene) : null;
  const skipDispose = !!beforeSnapshot;
  const endHistorySuppress = suppressGridHistory();

  try {
    if (skipDispose && selectedObject) {
      registerDetachedObjectsForUndo(selectedObject);
    }

    const state = store.getState();
    const { allIntersectedObjects } = state.assets_object;
    const { camera_properties } = state.assets_object;
    const { animationObjects } = state.animation;

    const objectId = selectedObject?.name;

    // ═══════ CHILD SELECTION MODE CLEANUP ═══════
    // If the deleted object is the active parent for child selection, disable child selection mode
    if (selectedObject === activeParentForChildSelection) {
      console.log(
        '[Child Selection] Disabled - Active parent deleted:',
        selectedObject.name
      );
      activeParentForChildSelection = null;
    }

    // ═══════ GIZMO FIX: Detach transform controls immediately so gizmo is hidden ═══════
    if (transformControls && typeof transformControls.detach === 'function') {
      transformControls.detach();
    }

    // ═══════ GIZMO FIX: Collect ALL descendants (nested children) before removal ═══════
    // Remove ALL descendants from allIntersectedObjects so the raycaster never hits orphaned objects.
    const collectAllDescendants = (obj, result = []) => {
      if (!obj) return result;
      result.push(obj);
      obj.children?.forEach((child) => collectAllDescendants(child, result));
      return result;
    };
    const allDescendants = collectAllDescendants(selectedObject);
    allDescendants.forEach((obj) => {
      if (isAudioMesh(obj)) {
        stopMeshAudio(obj);
      }
      store.dispatch(removeIntersectedObject(obj));
    });

    // Dispatch custom event to clear selectedEffects in animation components
    window.dispatchEvent(new CustomEvent('deleteMesh'));

    // Recursively remove associated animation objects
    recursiveDeletionOfAnimationObjects(animationObjects, objectId);

    // Remove animation objects that match the deleted object's ID
    animationObjects.forEach((obj) => {
      if (obj.objectId === objectId || obj.id === objectId) {
        store.dispatch(removeAnimationObject(obj.id));
      }
    });
    deleteHierarchyDescendants(selectedObject, scene);
    if (selectedObject && selectedObject.deleteType === 'mesh-extracted') {
      // Handle GLB mesh deletion
      const meshToDelete = selectedObject;
      const meshName = meshToDelete.name;
      const meshUuid = meshToDelete.uuid;

      // Find the parent GLB object by traversing up the hierarchy
      let parentGLB = meshToDelete.parent;
      let glbId = null;

      // Traverse up to find the GLB root object
      while (parentGLB && parentGLB.type !== 'Scene') {
        // Check if this is the GLB root object (it should have the GLB asset ID as name)
        const possibleGLBId =
          parentGLB.name || parentGLB._id || parentGLB.userData?.glbId;
        if (possibleGLBId) {
          // Check if this matches a GLB asset ID from Redux
          const state = store.getState();
          const meshAssets = state.assets_object?.assets_data?.mesh || [];
          const isGLBRoot = meshAssets.some(
            (asset) =>
              (asset._id === possibleGLBId || asset.name === possibleGLBId) &&
              (asset.file_name?.toLowerCase().includes('.glb') ||
                asset.url?.toLowerCase().includes('.glb'))
          );

          if (isGLBRoot) {
            glbId = possibleGLBId;
            break;
          }
        }
        parentGLB = parentGLB.parent;
      }

      // Remove the mesh from its parent
      detachObjectFromSceneGraph(meshToDelete);

      // Dispose of geometry and materials to prevent memory leaks
      if (!skipDispose) {
        if (meshToDelete.geometry) {
          meshToDelete.geometry.dispose();
        }
        if (meshToDelete.material) {
          const materials = Array.isArray(meshToDelete.material)
            ? meshToDelete.material
            : [meshToDelete.material];
          materials.forEach((material) => {
            if (material.map) material.map.dispose();
            if (material.lightMap) material.lightMap.dispose();
            if (material.normalMap) material.normalMap.dispose();
            if (material.bumpMap) material.bumpMap.dispose();
            if (material.specularMap) material.specularMap.dispose();
            if (material.envMap) material.envMap.dispose();
            if (material.alphaMap) material.alphaMap.dispose();
            if (material.aoMap) material.aoMap.dispose();
            if (material.displacementMap) material.displacementMap.dispose();
            if (material.emissiveMap) material.emissiveMap.dispose();
            if (material.gradientMap) material.gradientMap.dispose();
            if (material.metalnessMap) material.metalnessMap.dispose();
            if (material.roughnessMap) material.roughnessMap.dispose();
            material.dispose();
          });
        }
      } else {
        registerDetachedObjectsForUndo(meshToDelete);
      }

      // Remove from Redux state
      store.dispatch(removeIntersectedObject(meshToDelete));
      store.dispatch(removeSceneObject(meshToDelete));

      // Detach transform controls
      if (transformControls && typeof transformControls.detach === 'function') {
        transformControls.detach();
      }

      // Clear selection
      if (!bulkMode) {
        clearSelectionAfterDelete();
      }

      // Dispatch event to trigger glbMeshes state update in AppLeftSection
      if (glbId) {
        window.dispatchEvent(
          new CustomEvent('glbMeshDeleted', {
            detail: {
              meshName: meshName,
              meshUuid: meshUuid,
              glbId: glbId,
            },
          })
        );
      }

      // Update UI
      if (!bulkMode) {
        UpdateUI(null, cachedUIElements);
      }

      if (beforeSnapshot) {
        recordDiscreteHistoryAfter(beforeSnapshot, scene, 'delete');
      }

      return;
    }
    if (setPolyCount) {
      setPolyCount(polyCount + 1);
    }

    const itemtoremove = document.getElementById(selectedObject?.url);
    if (itemtoremove) {
      itemtoremove.remove();
    }

    if (selectedObject && transformControls) {
      // ========== Camera deletion handling with safeguard ==========
      if (
        selectedObject.type === 'PerspectiveCamera' ||
        selectedObject.type === 'OrthographicCamera'
      ) {
        // Check if this is the last camera
        if (camera_properties.length === 1) {
          notify(
            'Cannot delete the last camera. At least one camera must remain in the scene.'
          );
          return; // Exit early, don't delete
        }

        // Remove camera from Redux state
        store.dispatch(removeCamera(selectedObject.name));

        // Hide camera helper if visible
        if (globalSyncCameraHelperVisibility) {
          globalSyncCameraHelperVisibility(null, true);
        }

        // Remove camera-specific cleanup
        const cameraHelper = scene.getObjectByName(
          selectedObject.name + 'Helper'
        );
        if (cameraHelper) {
          detachObjectFromSceneGraph(cameraHelper);
          store.dispatch(removeIntersectedObject(cameraHelper));
        }
      }

      detachObjectFromSceneGraph(selectedObject);

      if (selectedObject.name == 'directionalLight') {
        const helper = scene.getObjectByName('directionalLightHelper');
        store.dispatch(
          lightDataUpdate({
            ...LightInitialData,
            isLight: false,
          })
        );
        detachObjectFromSceneGraph(helper);
        store.dispatch(removeIntersectedObject(helper));
      }

      // ========== by prasann for ambient light =========
      if (
        selectedObject.type === 'DirectionalLight' ||
        selectedObject.type === 'DirectionalLightHelper' ||
        selectedObject.type === 'PointLight' ||
        selectedObject.type === 'PointLightHelper' ||
        selectedObject.type === 'SpotLight' ||
        selectedObject.type === 'SpotLightHelper' ||
        selectedObject.type === 'AmbientLight' ||
        selectedObject.type === 'AmbientLightHelper' ||
        selectedObject.type === 'RectAreaLight' ||
        selectedObject.type === 'AreaLightHelper'
      ) {
        store.dispatch(removeLight(selectedObject.name.replace('-helper', '')));
      }

      if (selectedObject.deleteType === 'particle') {
        cleanupParticleSystem(selectedObject);
        store.dispatch(removeParticle(selectedObject.name));

        // Special handling for terrain particles - remove associated rock objects
        if (selectedObject.objType === 'terrain') {
          // Find and remove all rock objects associated with this terrain
          const rocksToRemove = scene.children.filter(
            (child) =>
              child.objType === 'rock' &&
              child.userData &&
              child.userData.parentTerrainId === selectedObject.name
          );

          rocksToRemove.forEach((rock) => {
            scene.remove(rock);
            store.dispatch(removeIntersectedObject(rock));
            store.dispatch(removeSceneObject(rock));

            // Clean up rock resources
            if (rock.userData && rock.userData.cleanup) {
              rock.userData.cleanup();
            }
          });

          // Clean up terrain resources
          if (selectedObject.userData && selectedObject.userData.cleanup) {
            selectedObject.userData.cleanup();
          }
        }
      }
      // ========== end by prasann for ambient light =========

      // *** CRITICAL: Dispose of geometries, materials, and textures to prevent memory leaks ***
      const disposeObject = (obj) => {
        if (obj.geometry) {
          obj.geometry.dispose();
        }
        if (obj.material) {
          const materials = Array.isArray(obj.material)
            ? obj.material
            : [obj.material];
          materials.forEach((material) => {
            // Dispose all textures in the material
            if (material.map) material.map.dispose();
            if (material.lightMap) material.lightMap.dispose();
            if (material.bumpMap) material.bumpMap.dispose();
            if (material.normalMap) material.normalMap.dispose();
            if (material.specularMap) material.specularMap.dispose();
            if (material.envMap) material.envMap.dispose();
            if (material.alphaMap) material.alphaMap.dispose();
            if (material.aoMap) material.aoMap.dispose();
            if (material.displacementMap) material.displacementMap.dispose();
            if (material.emissiveMap) material.emissiveMap.dispose();
            if (material.gradientMap) material.gradientMap.dispose();
            if (material.metalnessMap) material.metalnessMap.dispose();
            if (material.roughnessMap) material.roughnessMap.dispose();

            // Dispose the material itself
            material.dispose();
          });
        }
      };

      // Traverse and dispose all children
      if (selectedObject) {
        if (selectedObject.userData && selectedObject.userData.isHotspot) {
          removeHotspot(scene, selectedObject);
        }

        if (skipDispose) {
          registerDetachedObjectsForUndo(selectedObject);
        } else {
          selectedObject.traverse((child) => {
            disposeObject(child);
          });
          disposeObject(selectedObject);
        }
      }

      if (transformControls && typeof transformControls.detach === 'function') {
        transformControls.detach();
      }
      store.dispatch(removeIntersectedObject(selectedObject));
      store.dispatch(removeSceneObject(selectedObject));

      const element = document.getElementById(selectedObject.name);

      // *** KEY FIX: Remove from assets arrays immediately ***
      const deletedAssetId = getSceneAssetId(selectedObject);
      store.dispatch(
        remove_assets_by_id({
          type: selectedObject?.deleteType,
          id: deletedAssetId,
          url:
            selectedObject?.url ||
            selectedObject?._id ||
            selectedObject?.name ||
            selectedObject?.temp_file_name ||
            selectedObject?.userData?.text_material?.id,
        })
      );
      store.dispatch(
        updateActiveComponent({
          option:
            selectedObject?.deleteType === 'hotspot'
              ? 'HotSpot'
              : selectedObject?.deleteType,
          type: 'remove',
        })
      );

      // *** CRITICAL FIX: Remove from sceneMeshes if it's a mesh/shape ***
      if (
        selectedObject?.deleteType === 'mesh' ||
        selectedObject?.userData?.type === 'shape'
      ) {
        // Quick fix - directly filter out the deleted mesh
        const currentState = store.getState();
        const updatedSceneMeshes =
          currentState.assets_object.sceneMeshes.filter(
            (mesh) =>
              mesh._id !== selectedObject?._id &&
              mesh.id !== selectedObject?.id &&
              mesh.url !== selectedObject?.url
          );

        // Dispatch updated array
        store.dispatch(setSceneMeshes(updatedSceneMeshes));

        // Also remove from assets_data.mesh array
        store.dispatch(
          remove_assets_by_id({
            type: 'mesh',
            id: selectedObject?._id || selectedObject?.id,
            url: selectedObject?.url,
          })
        );
      }

      // *** Clean up shape-specific data ***
      if (selectedObject?.userData?.type === 'shape') {
        // Clean up object URL to prevent memory leaks
        if (selectedObject?.objectURL) {
          URL.revokeObjectURL(selectedObject.objectURL);
        }

        // Optionally recalibrate shape counters
        // initializeCountersFromScene(scene);
      }

      if (element) element.remove();

      // *** Add to deletion tracking (for server sync) ***
      store.dispatch(
        set_delete_objects({
          type: 'add',
          data: {
            url:
              selectedObject.url ||
              selectedObject._id ||
              selectedObject.name ||
              selectedObject.temp_file_name ||
              selectedObject.userData?.text_material?.id,
            id: deletedAssetId,
            _id: selectedObject._id || deletedAssetId,
            name: selectedObject.name,
            deleteType: resolveAssetDeleteType(selectedObject),
          },
        })
      );

      const UpdatedAllIntersectedObjects = allIntersectedObjects.filter(
        (val) => val?._id !== selectedObject?._id
      );

      UpdateOpenModalState(UpdatedAllIntersectedObjects, 'text');
    } else if (!bulkMode) {
      toast('No object is currently selected.', {
        id: 'selection-warning',
        duration: 1500,
      });
    }
    if (!bulkMode) {
      if (beforeSnapshot) {
        recordDiscreteHistoryAfter(beforeSnapshot, scene, 'delete');
      }
      clearSelectionAfterDelete();
    }
  } finally {
    endHistorySuppress();
  }
}

function resolveLightFromSceneObject(object) {
  if (!object) return null;

  if (
    object.type === 'DirectionalLightHelper' ||
    object.type === 'PointLightHelper' ||
    object.type === 'SpotLightHelper' ||
    object.type === 'AreaLightHelper'
  ) {
    const lightId = object.name?.replace(/-helper$/, '');
    return scene.getObjectByName(lightId) || object;
  }

  const isLight =
    object.type === 'DirectionalLight' ||
    object.type === 'PointLight' ||
    object.type === 'SpotLight' ||
    object.type === 'AmbientLight' ||
    object.type === 'RectAreaLight';

  return isLight ? object : null;
}

function selectObjectInScene(objectNameOrObject, options = {}) {
  const keepMaterialHighlight = options?.keepMaterialHighlight === true;
  const isPreviewMode = store.getState()?.window?.window_type === 'preview';
  let object;
  if (typeof objectNameOrObject === 'object' && objectNameOrObject !== null) {
    object = isLiveSceneObject3D(objectNameOrObject)
      ? objectNameOrObject
      : resolveLiveSceneObject(
          scene,
          objectNameOrObject,
          objectNameOrObject?.deleteType || 'mesh'
        );
  } else {
    object = scene.getObjectByName(objectNameOrObject);

    if (!object && isPendingLightSelectionId(objectNameOrObject)) {
      object = resolveLiveSceneObject(
        scene,
        {
          _id: objectNameOrObject,
          id: objectNameOrObject,
          temp_file_name: objectNameOrObject,
        },
        'light'
      );
      if (!object) {
        store.dispatch(setSelectedLightId(objectNameOrObject));
        store.dispatch(updateActiveComponent({ option: 'Light', type: 'add' }));
        return;
      }
    }

    if (!object) {
      object =
        resolveLiveSceneObject(
          scene,
          {
            _id: objectNameOrObject,
            id: objectNameOrObject,
            temp_file_name: objectNameOrObject,
          },
          'camera'
        ) ||
        resolveLiveSceneObject(
          scene,
          {
            _id: objectNameOrObject,
            id: objectNameOrObject,
            name: objectNameOrObject,
            url: objectNameOrObject,
            glb_type: 'ply',
          },
          'mesh'
        );
    }
  }
  console.log('Selecting object:', object);

  const particleRoot = resolveParticleAnimationRoot(object);
  if (particleRoot) {
    object = particleRoot;
  } else {
    object = clampSelectionForChildMode(
      scene,
      object,
      activeParentForChildSelection
    );
  }

  if (object) {
    if (isParticleAnimationRoot(object)) {
      reviveParticleOnSelect(object);
    }

    if (!keepMaterialHighlight) {
      store.dispatch(setMaterialHighlightMeshes([]));
    }

    clearMultiSelection();
    const sceneLight = resolveLightFromSceneObject(object);
    const sceneCamera = isSceneCamera(object)
      ? object
      : isSceneCameraPoint(object)
        ? resolveSceneCameraFromPoint(scene, object)
        : null;
    const isCameraSelection =
      sceneCamera ||
      isSceneCameraPoint(object) ||
      isDescendantOfSceneCamera(object);

    if (!isCameraSelection) {
      if (globalSyncCameraHelperVisibility) {
        globalSyncCameraHelperVisibility(null, true);
      } else if (globalShowCameraHelper) {
        globalShowCameraHelper(false);
      }
    }

    if (sceneLight) {
      store.dispatch(setSelectedLightId(sceneLight.name));
      store.dispatch(updateActiveComponent({ option: 'Light', type: 'add' }));
    } else {
      store.dispatch(setSelectedLightId(null));
    }

    // Handle light helpers
    if (globalShowLightHelpers) {
      if (sceneLight) {
        globalShowLightHelpers();

        const currentLightData =
          store.getState().assets_object.light_data || [];
        const transformTarget = resolveLightTransformTarget(
          scene,
          sceneLight.name,
          currentLightData
        );
        if (transformTarget) {
          if (!isPreviewMode && transformControls?.attach) {
            transformControls.attach(transformTarget);
          }
          selectedObject = transformTarget;
        } else {
          if (!isPreviewMode && transformControls?.attach) {
            transformControls.attach(sceneLight);
          }
          selectedObject = sceneLight;
        }
      } else {
        globalShowLightHelpers();
        const attachTarget = sceneCamera || object;
        if (!isPreviewMode && transformControls?.attach) {
          transformControls.attach(attachTarget);
        }
        selectedObject = attachTarget;
      }
    } else {
      const attachTarget = sceneLight || sceneCamera || object;
      selectedObject = attachTarget;
      if (
        !isPreviewMode &&
        attachTarget &&
        !sceneLight &&
        transformControls?.attach
      ) {
        transformControls.attach(attachTarget);
      }
    }

    store.dispatch(selected_object(sceneLight || sceneCamera || object));
    UpdateUI(sceneLight || sceneCamera || object, cachedUIElements);
    store.dispatch(
      updateOpenModals({
        name: 'text',
        isOpen: object.deleteType == 'text',
      })
    );

    if (sceneCamera) {
      store.dispatch(updateActiveComponent({ option: 'Camera', type: 'add' }));
      // Undo/redo: only show helper when camera.helperVisible is true (not always on select).
      if (isApplyingGridHistorySelection()) {
        if (globalSyncCameraHelperVisibility) {
          globalSyncCameraHelperVisibility(null, true);
        } else if (globalShowCameraHelper) {
          globalShowCameraHelper(false);
        }
      } else if (globalSyncCameraHelperVisibility) {
        globalSyncCameraHelperVisibility(sceneCamera.name);
      } else if (globalShowCameraHelper) {
        globalShowCameraHelper(true, sceneCamera, sceneCamera.name);
      }
    }

    const selectionForUi =
      selectedObject || sceneLight || sceneCamera || object;
    if (onPrimarySelectionChanged) {
      onPrimarySelectionChanged(selectionForUi);
    }

    if (isParticleAnimationRoot(object)) {
      const particleId = object.name || object.url;
      if (particleId) {
        store.dispatch(setSelectedParticle(particleId));
      }
      object.visible = true;
      if (transformControls?.attach && !sceneLight && !sceneCamera) {
        transformControls.attach(object);
        transformControls.visible = true;
        selectedObject = object;
        if (currentCamera) {
          transformControls.camera = currentCamera;
        }
      }
    }
  }
}

/** Fit zoom for OrthographicCamera from a world-space bounding box. */
function computeOrthographicFitZoom(camera, box, fitOffset = 1.5) {
  const size = new Three.Vector3();
  box.getSize(size);
  const frustumHeight = camera.top - camera.bottom;
  const frustumWidth = camera.right - camera.left;
  const zoomForHeight =
    frustumHeight / (Math.max(size.y, size.z, 0.001) * fitOffset);
  const zoomForWidth =
    frustumWidth / (Math.max(size.x, size.z, 0.001) * fitOffset);
  return Three.MathUtils.clamp(Math.min(zoomForHeight, zoomForWidth), 1, 500);
}

/** Smooth camera travel when focusing hotspot to hotspot in preview. */
const HOTSPOT_FOCUS_DURATION_MS = 800;
let hotspotFocusAnimationId = 0;

function easeInOutSmoothstep(t) {
  const x = Math.min(1, Math.max(0, t));
  return x * x * (3 - 2 * x);
}

// Focus camera on a given object (or current selectedObject if none passed)
function focusCameraOnObject(obj = null, hotspotFocusDistance = null) {
  try {
    const targetObj = obj || selectedObject;
    if (!targetObj || !currentCamera || !controlsOrbit) return;

    const isHotspot =
      targetObj.userData?.isHotspot || targetObj.deleteType === 'hotspot';
    const focusDuration = isHotspot ? HOTSPOT_FOCUS_DURATION_MS : 400;
    const focusAnimId = isHotspot ? ++hotspotFocusAnimationId : 0;

    let center = new Three.Vector3();
    const fitOffset = 1.5;

    if (currentCamera.isOrthographicCamera) {
      if (isHotspot) {
        targetObj.getWorldPosition(center);
        const focusDist =
          hotspotFocusDistance !== null ? hotspotFocusDistance : 10;

        // Resolve design-time facing direction (same logic as perspective path)
        let designQuaternion = targetObj.quaternion.clone();
        if (sceneStateHelper && sceneStateHelper.initialStates) {
          const savedState = sceneStateHelper.initialStates.get(targetObj.uuid);
          if (savedState && savedState.quaternion) {
            designQuaternion.copy(savedState.quaternion);
          }
        }
        // Hotspot forward = local +Z rotated by design quaternion
        const dir = new Three.Vector3(0, 0, 1)
          .applyQuaternion(designQuaternion)
          .normalize();

        // For ortho, position doesn't affect apparent size — keep the same
        // orbit arm length so the camera just rotates to face the hotspot
        const currentDist = currentCamera.position.distanceTo(
          controlsOrbit.target
        );
        const safeDist = currentDist > 0.1 ? currentDist : focusDist;
        const endCamPos = new Three.Vector3().addVectors(
          center,
          dir.clone().multiplyScalar(safeDist)
        );

        const endZoom = Three.MathUtils.clamp(
          500 / Math.max(focusDist, 0.5),
          1,
          500
        );
        const startZoom = currentCamera.zoom;
        const startPos = currentCamera.position.clone();
        const startTarget = controlsOrbit.target.clone();
        const endTarget = center.clone();
        let start = null;

        function animateOrthoHotspotFocus(ts) {
          if (focusAnimId !== hotspotFocusAnimationId) return;
          if (!start) start = ts;
          const t = easeInOutSmoothstep((ts - start) / focusDuration);
          currentCamera.zoom = Three.MathUtils.lerp(startZoom, endZoom, t);
          currentCamera.updateProjectionMatrix();
          currentCamera.position.lerpVectors(startPos, endCamPos, t);
          controlsOrbit.target.lerpVectors(startTarget, endTarget, t);
          if (controlsOrbit.update) controlsOrbit.update();
          if (rendererRef.current) {
            rendererRef.current.render(scene, currentCamera);
          }
          if (t < 1) requestAnimationFrame(animateOrthoHotspotFocus);
        }
        requestAnimationFrame(animateOrthoHotspotFocus);
        return;
      }

      const box = new Three.Box3().setFromObject(targetObj);
      if (box.isEmpty()) return;
      box.getCenter(center);
      const endZoom = computeOrthographicFitZoom(currentCamera, box, fitOffset);
      const startZoom = currentCamera.zoom;
      const startTarget = controlsOrbit.target.clone();
      const endTarget = center.clone();
      const duration = 400;
      let start = null;

      function animateOrthoFocus(ts) {
        if (!start) start = ts;
        const t = Math.min(1, (ts - start) / duration);
        currentCamera.zoom = Three.MathUtils.lerp(startZoom, endZoom, t);
        currentCamera.updateProjectionMatrix();
        controlsOrbit.target.lerpVectors(startTarget, endTarget, t);
        if (controlsOrbit.update) controlsOrbit.update();
        if (rendererRef.current) {
          rendererRef.current.render(scene, currentCamera);
        }
        if (t < 1) requestAnimationFrame(animateOrthoFocus);
      }
      requestAnimationFrame(animateOrthoFocus);
      return;
    }

    let distance;

    if (isHotspot) {
      targetObj.getWorldPosition(center);
      distance = hotspotFocusDistance !== null ? hotspotFocusDistance : 10;
    } else {
      const box = new Three.Box3().setFromObject(targetObj);
      box.getCenter(center);
      const size = new Three.Vector3();
      box.getSize(size);
      const maxSize = Math.max(size.x, size.y, size.z, 0.001);
      const fov = currentCamera.fov;
      distance =
        (maxSize / (2 * Math.tan((Math.PI * fov) / 360))) * fitOffset * 2;
    }

    let dir;
    if (isHotspot) {
      let designQuaternion = targetObj.quaternion.clone();
      if (sceneStateHelper && sceneStateHelper.initialStates) {
        const savedState = sceneStateHelper.initialStates.get(targetObj.uuid);
        if (savedState && savedState.quaternion) {
          designQuaternion.copy(savedState.quaternion);
        }
      }
      dir = new Three.Vector3(0, 0, 1)
        .applyQuaternion(designQuaternion)
        .normalize();
    } else {
      dir = new Three.Vector3()
        .subVectors(currentCamera.position, controlsOrbit.target)
        .normalize();
      if (dir.length() === 0) dir.set(0, 0, 1);
    }

    const endPos = new Three.Vector3().addVectors(
      center,
      dir.multiplyScalar(distance)
    );
    const startPos = currentCamera.position.clone();
    const startTarget = controlsOrbit.target.clone();
    const endTarget = center.clone();

    let start = null;

    function animateFocus(ts) {
      if (isHotspot && focusAnimId !== hotspotFocusAnimationId) return;
      if (!start) start = ts;
      const t = easeInOutSmoothstep((ts - start) / focusDuration);
      currentCamera.position.lerpVectors(startPos, endPos, t);
      controlsOrbit.target.lerpVectors(startTarget, endTarget, t);
      if (controlsOrbit.update) controlsOrbit.update();
      if (rendererRef.current) rendererRef.current.render(scene, currentCamera);
      if (t < 1) requestAnimationFrame(animateFocus);
    }

    requestAnimationFrame(animateFocus);
  } catch (e) {
    console.warn('focusCameraOnObject error', e);
  }
}
function clearGridHistoryAfterSaveOrPublish() {
  // New empty history session — next edits are step 0, 1, 2, …
  startFreshGridHistory({ ready: true });
}

/** Remap events and embed pivot restore payload (survives API field stripping). */
function publishEventsWithPivot(events, object, assetsData) {
  const pivotFields = getPivotPublishFields(object);
  if (
    pivotFields.pivot_edited ||
    pivotFields.pivot_mode === 'file' ||
    pivotFields.native_pivot
  ) {
    cachePivotRestoreData(
      projectId,
      [
        object?.name,
        object?._id,
        object?.url,
        object?.temp_file_name,
        object?.file_name,
      ],
      pivotFields
    );
  }
  return embedPivotInEvents(
    remapEventsForPublish(
      events,
      scene,
      assetsData,
      object?.name || object?._id
    ),
    pivotFields
  );
}

async function Publish(
  setPublished,
  isSave = true,
  setName,
  completeObject,
  animationObjectsArg,
  cleanallanimation,
  setCategory,
  setRedirectionCode
) {
  // Use passed animationObjects or fallback to store state
  const animationObjects = Array.isArray(animationObjectsArg)
    ? animationObjectsArg
    : store.getState().animation?.animationObjects || [];

  // Derive timelineEffects from animationObjects for backward compatibility and robustness
  const timelineEffects = animationObjects.flatMap(
    (obj) => obj.timelineEffects || []
  );

  if (isPublishing) {
    return;
  }
  isPublishing = true;
  store.dispatch(setIsPublishing(true));

  // Stop timeline/preview playback and restore design transforms before
  // reading scene poses into the publish payload.
  prepareSceneTransformsForPublish({
    scene,
    animationObjects,
    completeObject,
  });

  const savingToast = toast.loading('Saving project...');
  const token = localStorage.getItem('token') || '';

  let uploadPromises = [];
  let successCount = 0;
  let failCount = 0;
  const savedCamera = currentCamera
    ? {
        position: currentCamera.position.clone(),
        quaternion: currentCamera.quaternion.clone(),
        zoom: currentCamera.zoom,
        target: controlsOrbit ? controlsOrbit.target.clone() : null,
        left: currentCamera.left,
        right: currentCamera.right,
        top: currentCamera.top,
        bottom: currentCamera.bottom,
      }
    : null;

  // Helper function to convert radians to degrees
  const radToDeg = (rad) => rad * (180 / Math.PI);

  const state = store.getState();
  const { delete_items } = state.delete_object;
  const {
    sceneMeshes,
    sceneHotspots = [],
    sceneImages,
    sceneVideos,
    sceneAudios,
    sceneText,
    assets_data = {},
    imageScales,
    videoScales,
    audioScales,
    light_data,
  } = state.assets_object;
  const { particles } = state.particles;

  const extractMaterialProps = (material) => {
    if (!material) return {};
    let props = {};
    // If it's a THREE.Material instance
    Object.getOwnPropertyNames(material).forEach((prop) => {
      if (
        typeof material[prop] !== 'function' &&
        prop !== 'userData' &&
        prop !== 'uuid'
      ) {
        props[prop] = material[prop];
      }
    });
    // Optionally include userData
    if (material.userData) {
      props.userData = { ...material.userData };
    }
    return props;
  };

  // Helper function to get current position from scene
  const getCurrentTransformFromScene = (primaryId, meshCodeFallback) => {
    try {
      const lookupIds = [primaryId].filter(Boolean);
      let sceneObject = null;

      for (const id of lookupIds) {
        sceneObject = scene.getObjectByName(id);
        if (sceneObject) break;
      }

      if (!sceneObject && lookupIds.length) {
        scene.traverse((child) => {
          if (sceneObject) return;
          const fileStem = child.file_name
            ? child.file_name.replace(/\.[^/.]+$/, '')
            : null;
          if (
            lookupIds.some(
              (id) =>
                child.name === id ||
                child._id === id ||
                child.url === id ||
                child.temp_file_name === id ||
                child.file_name === id ||
                (fileStem && fileStem === id) ||
                child.userData?._id === id ||
                child.userData?.id === id
            )
          ) {
            sceneObject = child;
          }
        });
      }

      if (!sceneObject && meshCodeFallback) {
        scene.traverse((child) => {
          if (sceneObject) return;
          if (child.userData?.mesh_code === meshCodeFallback) {
            sceneObject = child;
          }
        });
      }
      if (sceneObject) {
        const hasNonSceneParent =
          sceneObject.parent && sceneObject.parent !== scene;

        // Always store LOCAL position/rotation/scale
        // reconstructParentChildRelationships will restore world transform on load
        return {
          position: {
            x: sceneObject.position.x,
            y: sceneObject.position.y,
            z: sceneObject.position.z,
          },
          rotation: {
            x: sceneObject.rotation.x,
            y: sceneObject.rotation.y,
            z: sceneObject.rotation.z,
          },
          scale: {
            x: sceneObject.scale.x,
            y: sceneObject.scale.y,
            z: sceneObject.scale.z,
          },
          parent: hasNonSceneParent ? sceneObject.parent : null,
          material: sceneObject.material,
        };
      }
    } catch (error) {
      console.warn(
        'Could not get current transform from scene for:',
        meshName,
        error
      );
    }
    return null;
  };
  const isValidMongoObjectId = (value) =>
    typeof value === 'string' && /^[a-fA-F0-9]{24}$/.test(value);

  const buildMeshPublishIdentity = (mesh, groupp) => {
    const rawId = mesh._id || groupp?._id;
    const temp_file_name =
      mesh.temp_file_name ||
      groupp?.temp_file_name ||
      (!isValidMongoObjectId(rawId) ? rawId : null) ||
      mesh.name ||
      mesh.url;

    return {
      ...(isValidMongoObjectId(rawId) ? { _id: rawId } : {}),
      temp_file_name,
    };
  };

  //helper function to get parent identifier
  const getParentIdentifier = (parentObj) => {
    if (!parentObj) return null;
    if (parentObj === scene) return null;

    return (
      parentObj._id ||
      parentObj.url ||
      parentObj.name ||
      parentObj.userData?.id ||
      parentObj.userData?._id ||
      parentObj.userData?.temp_file_name ||
      parentObj.temp_file_name ||
      null
    );
  };

  const BULK_UPLOAD_BATCH_SIZE = 5;

  // Helper function for making bulk upload API calls (batched, max 5 items per request)
  const makeAssetUpload = async (
    assets,
    files,
    assetType,
    filesToDelete = []
  ) => {
    const data =
      assetType == 'text' || assetType == 'mesh'
        ? [
            ...assets.filter(
              (val) =>
                val?.deleteType == 'text' ||
                (val?.glb_type == 'shapes' && assetType == 'mesh')
            ),
            ...delete_items,
          ]
        : delete_items;

    let formattedDeleteItems = [];
    if (
      data?.filter(
        (val) =>
          val.deleteType == assetType ||
          (val?.glb_type == 'shapes' && assetType == 'mesh')
      )?.length > 0
    ) {
      formattedDeleteItems = data
        ?.filter(
          (val) =>
            val.deleteType == assetType ||
            (val?.glb_type == 'shapes' && assetType == 'mesh')
        )
        .map((val) => formatDeleteItemForApi(val));
    }

    const allResponseData = [];
    const hasDeleteInfo =
      formattedDeleteItems.length > 0 || filesToDelete.length > 0;
    let totalBatches = Math.ceil(assets.length / BULK_UPLOAD_BATCH_SIZE);
    if (totalBatches === 0 && hasDeleteInfo) {
      totalBatches = 1;
    }

    for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
      const start = batchIndex * BULK_UPLOAD_BATCH_SIZE;
      const end = Math.min(start + BULK_UPLOAD_BATCH_SIZE, assets.length);
      const batchAssets = assets.slice(start, end);
      const batchFiles = files.slice(start, end);
      const isFirstBatch = batchIndex === 0;

      const formData = new FormData();
      formData.append('projectId', projectId);
      formData.append('assets', JSON.stringify(batchAssets));
      batchFiles.forEach((file) => {
        formData.append('files', file);
      });

      if (formattedDeleteItems.length > 0 && isFirstBatch) {
        formData.append('toDelete', JSON.stringify(formattedDeleteItems));
      }
      if (isFirstBatch && filesToDelete.length > 0) {
        if (formData.has('toDelete')) {
          const existing = JSON.parse(formData.get('toDelete'));
          const updated = [...existing, ...filesToDelete];
          formData.set('toDelete', JSON.stringify(updated));
        } else {
          formData.append('toDelete', JSON.stringify(filesToDelete));
        }
      }

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}assets/${assetType}/bulk`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        successCount += batchAssets.length;
        allResponseData.push(...(response.data?.data ?? []));

        const batchResponseData = response.data?.data ?? [];
        if (assetType == 'text') {
          batchResponseData.forEach((val) => {
            const object =
              scene.getObjectByName(val?.text_material?.id) ||
              scene.getObjectByName(val?.temp_file_name) ||
              (() => {
                let found = null;
                scene.traverse((child) => {
                  if (found) return;
                  if (
                    child.deleteType === 'text' &&
                    (child.temp_file_name === val?.temp_file_name ||
                      child.file_name === val?.file_name)
                  ) {
                    found = child;
                  }
                });
                return found;
              })();
            if (object) {
              const oldId = object.name || object._id;
              const newId = val.id || val._id;

              object._id = newId;
              object.url = newId;
              object.name = newId;
              if (val.asset_file_path || val.asset_file_pathh) {
                object.asset_file_path =
                  val.asset_file_path || val.asset_file_pathh;
              }
              const prevTm = object.userData?.text_material || {};
              object.userData = {
                ...object.userData,
                text_material: {
                  ...prevTm,
                  id: newId,
                  _id: newId,
                  ...(object.userData?.pivotEdited || object.pivotEdited
                    ? {
                        pivot_edited: true,
                        ...(object.userData?.pivotContentMatrix
                          ? {
                              pivot_content_matrix:
                                object.userData.pivotContentMatrix,
                            }
                          : {}),
                        ...(object.userData?.pivotOffset
                          ? { pivot_offset: object.userData.pivotOffset }
                          : {}),
                      }
                    : {}),
                },
              };

              if (oldId && newId && oldId !== newId) {
                remapSceneEventAssetIds(scene, oldId, newId);
              }
            }
          });
        } else if (assetType == 'mesh') {
          batchResponseData.forEach((val) => {
            if (val?.glb_type == 'shapes') {
              const object =
                scene.getObjectByName(val?.temp_file_name) ||
                scene.getObjectByName(val?.id) ||
                scene.getObjectByName(val?._id) ||
                scene.getObjectByName(val?.material_settings?.id) ||
                (() => {
                  let found = null;
                  scene.traverse((child) => {
                    if (found) return;
                    if (
                      child.temp_file_name === val?.temp_file_name ||
                      child.file_name === val?.file_name
                    ) {
                      found = child;
                    }
                  });
                  return found;
                })();
              if (object) {
                const oldId = object.name;

                const preservedMeshCode = object.mesh_code || val.mesh_code;
                const preservedFileName = object.file_name || val.file_name;
                const preservedAssetFileName =
                  object.asset_file_name || val.asset_file_name;

                object._id = val.id;
                object.url = val.id;
                object.name = val.id;

                object.glb_type = 'shapes';
                object.mesh_code = preservedMeshCode;
                object.file_name = preservedFileName;
                object.asset_file_name = preservedAssetFileName;

                const existingUserData = object.userData || {};
                object.userData = {
                  ...existingUserData,
                  glb_type: 'shapes',
                  mesh_code: preservedMeshCode,
                  file_name: preservedFileName,
                  ...(existingUserData.material_settings
                    ? {
                        material_settings: {
                          ...existingUserData.material_settings,
                          id: val.id,
                        },
                      }
                    : {}),
                };

                scene.traverse((child) => {
                  if (
                    child.parent &&
                    (child.parent.name === oldId || child.parent._id === oldId)
                  ) {
                    child.parent = object;
                    if (child.userData) {
                      child.userData = {
                        ...child.userData,
                        parentId: val.id,
                      };
                    }
                  }
                });
              }
            }
          });
          batchResponseData.forEach((val) => {
            if (val?.glb_type == 'ply') {
              const object = scene.getObjectByName(val?.material_settings?.id);
              if (object) {
                object._id = val.id;
                object.url = val.id;
                object.name = val.id;
              }
            }
          });
          // Handle library and regular mesh assets (including sketchfab)
          // Collect ID remaps so we can sync Redux sceneMeshes in one shot after the loop.
          const meshIdRemaps = []; // [{ oldId, newId, preservedUrl, preservedSource, preservedLibraryAssetId, preservedMaterialSettings }]

          batchResponseData.forEach((val) => {
            // Skip shapes and ply as they're already handled above
            if (val?.glb_type === 'shapes' || val?.glb_type === 'ply') {
              return;
            }
            
            // Find the scene object by temp_file_name, _id, or name
            const object =
              scene.getObjectByName(val?.temp_file_name) ||
              scene.getObjectByName(val?._id) ||
              scene.getObjectByName(val?.id) ||
              (() => {
                let found = null;
                scene.traverse((child) => {
                  if (found) return;
                  if (
                    child.temp_file_name === val?.temp_file_name ||
                    child._id === val?._id ||
                    child._id === val?.id ||
                    (val?.from_library && child.source === 'library' && child.libraryAssetId === val?.libraryAssetId) ||
                    (val?.source === 'sketchfab' && child.source === 'sketchfab' && child.userData?.sketchfabUid === val?.sketchfabUid)
                  ) {
                    found = child;
                  }
                });
                return found;
              })();

            if (object) {
              const oldId = object.name || object._id;
              const newId = val.id || val._id;

              // Preserve important metadata
              const preservedSource = object.source || val.source;
              const preservedLibraryAssetId = object.libraryAssetId || val.libraryAssetId;
              const preservedFileName = object.file_name || val.file_name;
              const preservedAssetFilePath = object.asset_file_path || val.asset_file_path;
              const preservedUrl = val.asset_file_path || object.url;

              // Capture material_settings from the live Three.js object BEFORE renaming it,
              // so the Redux record can be updated with the correct settings.
              const preservedMaterialSettings = object.userData?.material_settings || null;

              // Update the scene object's identity with server-assigned ID
              object._id = newId;
              object.name = newId;
              object.url = preservedUrl;

              // Preserve source metadata for library/sketchfab assets
              if (preservedSource) {
                object.source = preservedSource;
              }
              if (preservedLibraryAssetId) {
                object.libraryAssetId = preservedLibraryAssetId;
              }
              if (preservedFileName) {
                object.file_name = preservedFileName;
              }
              if (preservedAssetFilePath) {
                object.asset_file_path = preservedAssetFilePath;
              }

              // Update userData — preserve material_settings that were already on the object
              const existingUserData = object.userData || {};
              object.userData = {
                ...existingUserData,
                ...(val.from_library ? { from_library: true } : {}),
                ...(preservedSource ? { source: preservedSource } : {}),
                // Keep material_settings intact so future publishes read from it correctly
                material_settings: preservedMaterialSettings || existingUserData.material_settings || {},
              };

              // Update event references if the ID changed
              if (oldId && newId && oldId !== newId) {
                remapSceneEventAssetIds(scene, oldId, newId);
              }

              // Update parent references
              scene.traverse((child) => {
                if (
                  child.parent &&
                  (child.parent.name === oldId || child.parent._id === oldId)
                ) {
                  child.parent = object;
                  if (child.userData) {
                    child.userData = {
                      ...child.userData,
                      parentId: newId,
                    };
                  }
                }
              });

              // Record the remap so Redux can be updated after the loop
              if (oldId && newId && oldId !== newId) {
                meshIdRemaps.push({
                  oldId,
                  newId,
                  preservedUrl,
                  preservedSource,
                  preservedLibraryAssetId,
                  preservedFileName,
                  preservedAssetFilePath,
                  preservedMaterialSettings,
                  tempFileName: val?.temp_file_name,
                });

                // Register library/sketchfab identity so DownloadMesh can
                // restore source/from_library after the scene reload — the API
                // does not echo these fields back in its response.
                if (preservedSource === 'library' || preservedSource === 'sketchfab' || val?.from_library) {
                  registerLibraryIdentity(newId, {
                    source: preservedSource || 'library',
                    libraryAssetId: preservedLibraryAssetId || null,
                    from_library: preservedSource === 'library' || !!val?.from_library,
                  });
                }
              }
            }
          });

          // Sync Redux sceneMeshes: replace temp IDs with the real Mongo IDs returned by the server.
          // Without this, the next publish reads stale temp IDs from Redux and can't find the
          // scene object by name, forcing a libraryAssetId fallback — which causes material
          // settings to be lost on the first publish for library/sketchfab assets.
          if (meshIdRemaps.length > 0) {
            const currentSceneMeshes = store.getState().assets_object?.sceneMeshes ?? [];
            const updatedSceneMeshes = currentSceneMeshes.map((m) => {
              const remap = meshIdRemaps.find(
                (r) =>
                  r.oldId === m._id ||
                  r.oldId === m.name ||
                  r.oldId === m.temp_file_name ||
                  (r.tempFileName && r.tempFileName === m.temp_file_name)
              );
              if (!remap) return m;
              return {
                ...m,
                _id: remap.newId,
                name: remap.newId,
                url: remap.preservedUrl ?? m.url,
                asset_file_path: remap.preservedAssetFilePath ?? remap.preservedUrl ?? m.asset_file_path,
                file_name: remap.preservedFileName ?? m.file_name,
                ...(remap.preservedSource ? { source: remap.preservedSource } : {}),
                ...(remap.preservedLibraryAssetId ? { libraryAssetId: remap.preservedLibraryAssetId } : {}),
                // Persist the live material_settings into Redux so the next publish reads them correctly
                ...(remap.preservedMaterialSettings
                  ? { material_settings: remap.preservedMaterialSettings }
                  : {}),
              };
            });
            store.dispatch(setSceneMeshes(updatedSceneMeshes));
          }
        }
      } catch (error) {
        console.error(
          `${assetType} upload error (batch ${batchIndex + 1}/${totalBatches}):`,
          error
        );
        UnauthorizedFunction(error?.response?.data);
        failCount += batchAssets.length;
        throw error;
      }
    }

    return { data: allResponseData };
  };

  // helper: transform frontend animationObjects into backend schema-compliant animation_effects
  function transformAnimationObjectsForBackend(objects) {
    return (objects || []).map((obj) => {
      // Resolve the best ID for the backend
      const objectId = obj.id || obj._id || obj.name;

      // Map timeline effects
      const transformedTimelineEffects = (obj.timelineEffects || []).map(
        (effect) => ({
          ...effect,
          // Ensure objectId within effects is consistent
          objectId: effect.objectId || objectId,
        })
      );

      return {
        id: objectId,
        name: obj.name || 'Animation Object',
        animationEffect: obj.animationEffect || obj.effectType || 'move',
        animationObjectName: obj.name || 'Animation Object Name',
        duration: obj.duration || 1000,
        startTime: obj.startTime || 0,
        easing: obj.easing?.toLowerCase() || 'ease-in',
        timelineEffects: transformedTimelineEffects,
        activeAxes: {
          x: String(obj.activeAxes?.x ?? true),
          y: String(obj.activeAxes?.y ?? false),
          z: String(obj.activeAxes?.z ?? true),
        },
        startPos: {
          x: obj.startPosition?.x || obj.startPos?.x || 0,
          y: obj.startPosition?.y || obj.startPos?.y || 0,
          z: obj.startPosition?.z || obj.startPos?.z || 0,
        },
        endPos: {
          x: obj.endPosition?.x || obj.endPos?.x || 0,
          y: obj.endPosition?.y || obj.endPos?.y || 0,
          z: obj.endPosition?.z || obj.endPos?.z || 0,
        },
        loop: obj.loop ?? false,
        isActive: obj.isActive ?? true,
        objectId: objectId,
      };
    });
  }

  const lightDataUpdateApi = async (lightData) => {
    try {
      // Get camera properties from global variable (set by CameraComponent)
      let cameraProperties = window.cameraProperties;
      if (!Array.isArray(cameraProperties) || !cameraProperties.length) {
        // Fallback: try to get from scene or set blank
        cameraProperties = [{}];
      }
      let environmentData = store.getState().environment.environmentData;
      // Get current asset objects from state
      const assetState = store.getState().assets_object;
      // Collect all asset objects (meshes, images, videos, audios, text, lights)

      const collectAssets = (arr) =>
        (arr || []).map((obj) => {
          // Identify a safe ID - avoid using large base64 URLs as IDs
          const safeId =
            obj._id ||
            obj.id ||
            obj.name ||
            (typeof obj.url === 'string' && obj.url.length < 200
              ? obj.url
              : 'Asset-' + Math.random().toString(36).substr(2, 5));

          // Identify a safe filename/temp label
          let safeFileName =
            obj.file_name ||
            obj.asset_file_name ||
            obj.asset_file_path ||
            obj.name ||
            obj.temp_file_name ||
            '';
          if (typeof safeFileName !== 'string' || safeFileName.length > 500) {
            safeFileName = obj.name || 'Asset';
          }

          return {
            id: safeId,
            parent:
              obj.parent?.id ||
              obj.parent?._id ||
              obj.parent?.url ||
              obj.parent?.name ||
              obj.parent ||
              null,
            temp_file_name:
              typeof safeFileName === 'string' && safeFileName.length < 500
                ? safeFileName
                : obj.name || 'Asset',
            type: obj.deleteType || obj.type,
            name: obj.name,
            visible: getPublishVisibleForAsset(
              scene,
              obj,
              assetState.assets_data
            ),
          };
        });
      // Map parent and temp_file_name for lights
      const mapLights = (arr) =>
        (arr || []).map((obj) => {
          let parentId = null;
          if (obj.parent && typeof obj.parent === 'object') {
            parentId =
              obj.parent._id ||
              obj.parent.id ||
              obj.parent.temp_file_name ||
              obj.parent.name ||
              null;
          } else if (typeof obj.parent === 'string') {
            parentId = obj.parent;
          }
          return {
            ...obj,
            parent: parentId,
            temp_file_name:
              obj.temp_file_name || obj.file_name || obj.name || '',
          };
        });
      // Map parent and temp_file_name for camera_properties
      const mapCameras = (arr) =>
        (arr || []).map((obj) => {
          let parentId = null;
          if (obj.parent && typeof obj.parent === 'object') {
            parentId =
              obj.parent._id ||
              obj.parent.id ||
              obj.parent.temp_file_name ||
              obj.parent.name ||
              null;
          } else if (typeof obj.parent === 'string') {
            parentId = obj.parent;
          }
          const label =
            obj.name || obj.file_name || obj.temp_file_name || 'Camera';

          // Get latest position/rotation from actual scene camera if available
          let pos = obj.position;
          let rot = obj.rotation;

          if (scene) {
            const actualCam = scene.getObjectByName(obj._id || obj.name);
            if (actualCam) {
              pos = {
                x: actualCam.position.x,
                y: actualCam.position.y,
                z: actualCam.position.z,
              };
              rot = {
                x: actualCam.rotation.x,
                y: actualCam.rotation.y,
                z: actualCam.rotation.z,
              };
            } else if (
              window.currentCamera &&
              (window.currentCamera.name === obj._id ||
                window.currentCamera.name === obj.name)
            ) {
              pos = {
                x: window.currentCamera.position.x,
                y: window.currentCamera.position.y,
                z: window.currentCamera.position.z,
              };
              rot = {
                x: window.currentCamera.rotation.x,
                y: window.currentCamera.rotation.y,
                z: window.currentCamera.rotation.z,
              };
            }
          }

          return {
            ...obj,
            parent: parentId,
            visible: getPublishAssetVisible(
              scene.getObjectByName(obj._id || obj.name),
              obj
            ),
            helperVisible: obj.helperVisible === true,
            position: pos || { x: 0, y: 0, z: 0 },
            rotation: rot || { x: 0, y: 0, z: 0 },
            // Persist the human-readable label so it round-trips from/to the API
            name: label,
            temp_file_name: label,
            file_name: label,
          };
        });
      const assetsArray = [
        ...collectAssets(assetState.sceneMeshes),
        ...collectAssets(assetState.sceneHotspots || []),
        ...collectAssets(assetState.sceneImages),
        ...collectAssets(assetState.sceneVideos),
        ...collectAssets(assetState.sceneAudios),
        ...collectAssets(assetState.sceneText),
        ...collectAssets(assetState.sceneLight),
      ];

      // --- Transform environmentData to match backend requirements ---
      let transformedEnv = { ...environmentData };
      // Helper: convert File to base64
      function fileToBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      }
      if (environmentData.skybox === 'HDRI') {
        let hdriValue = environmentData.hdriFile;
        if (environmentData.hdriFile instanceof File) {
          // Convert file to base64
          hdriValue = await fileToBase64(environmentData.hdriFile);
        }
        transformedEnv = {
          skybox: {
            name: environmentData.hdriFile?.name || 'hdri',
            url: hdriValue,
          },
          // Removed redundant hdriFile field to reduce payload size
          color_config: {
            color_type: environmentData.color_config?.color_type || 'Gradient',
            color: environmentData.color_config?.color || '#ffffff',
            top_color: environmentData.color_config?.top_color || '#aabbcc',
            bottom_color:
              environmentData.color_config?.bottom_color || '#112233',
          },
          fog_checked: !!environmentData.fog_checked,
          fogType: environmentData.fogType || 'Exponential',
          fogColor: environmentData.fogColor || '#ffffff',
          fogStart: environmentData.fogStart
            ? Number(environmentData.fogStart)
            : 10,
          fogEnd: environmentData.fogEnd ? Number(environmentData.fogEnd) : 20,
          fog_density: environmentData.fog_density
            ? Number(environmentData.fog_density)
            : 0.03,
          hdriRotation: environmentData.hdriRotation
            ? String(environmentData.hdriRotation)
            : '45',
          hdriVisible: environmentData.hdriVisible ?? true,
          hdriLightIntensity: environmentData.hdriLightIntensity
            ? Number(environmentData.hdriLightIntensity)
            : 1,
        };
      } else {
        // If not HDRI, you may want to keep the structure or adapt as needed
        // Example: ensure fog values are numbers
        transformedEnv = {
          ...environmentData,
          fogStart: environmentData.fogStart
            ? Number(environmentData.fogStart)
            : undefined,
          fogEnd: environmentData.fogEnd
            ? Number(environmentData.fogEnd)
            : undefined,
          fog_density: environmentData.fog_density
            ? Number(environmentData.fog_density)
            : undefined,
        };
      }
      // --- End transformation ---

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}experience/update/experience-name/${projectId}`,
        JSON.stringify({
          project_name: (currentProjectName || '').trim() || 'Untitled Project',
          light_data: lightData,
          // Ensure cameras are serialised with updated name/temp_file_name
          camera_properties: mapCameras(
            store.getState().assets_object.camera_properties
          ),
          particle_properties: (
            store.getState().particles?.particles || []
          ).map((particle) => ({
            ...particle,
            events: remapEventsForPublish(
              particle.events,
              scene,
              store.getState().assets_object?.assets_data,
              particle.id || particle._id
            ),
          })),
          environment: transformedEnv, // <-- use transformed
          assets: assetsArray, // <-- include assets with parent/child info
          animation_effects:
            transformAnimationObjectsForBackend(animationObjects) || [],
          // Include physics data so the backend stores object physics and world settings
          // Transform data to match MongoDB schema format
          physics_data: transformPhysicsDataForBackend(
            store.getState().physics?.physicsObjects || []
          ),
          physics_world_settings: store.getState().physics?.worldSettings || {},
          reference_object_visible: (() => {
            const refObj = getReferenceObject(scene);
            if (refObj) {
              return refObj.visible !== false;
            }
            // If the reference object is not in the scene yet (e.g. during conversion),
            // check the target category and default to true for VR/MR/Foot projects
            const targetCategory = completeObject?.category;
            if (targetCategory && ['vr', 'mr', 'foot'].includes(String(targetCategory).toLowerCase())) {
              return true;
            }
            return false;
          })(),
        }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      // cleanallanimation();
      return response.data;
    } catch (error) {
      console.error(
        'Light data update error:',
        error?.response?.data || error?.message || error
      );
      UnauthorizedFunction(error?.response?.data);
      throw error;
    }
  };

  // Light Data Update
  // Send all lights in required structure
  // if (Array.isArray(light_data) && light_data.length > 0) {
  const formattedLights = light_data?.map((light) => {
    // Get the actual light object from the scene for rotation synchronization
    const lightObj =
      scene.getObjectByName(light.id) ||
      scene.getObjectByName(light.name) ||
      scene.children.find(
        (child) =>
          child.isLight &&
          (child.userData?.lightId === light.id || child.name === light.name)
      );

    // For spotLight and areaLight, get the current rotation from the scene
    let rotationData = {
      x: light.rotation?.x ?? (light.light_type === 'Area Light' ? -1.57 : 0),
      y: light.rotation?.y ?? 0,
      z: light.rotation?.z ?? 0,
    };

    if (
      lightObj &&
      (light.light_type === 'Spot Light' || light.light_type === 'Area Light')
    ) {
      rotationData = {
        x: lightObj.rotation.x,
        y: lightObj.rotation.y,
        z: lightObj.rotation.z,
      };
    }

    return sanitizeLightPayloadForApi({
      isLight: light.isLight ?? false,
      intensity: light.intensity ?? 1,
      visible: getPublishVisibleForAsset(scene, light, assets_data, {
        type: 'light',
      }),
      helperVisible: light.helperVisible === true,
      temp_file_name: light.temp_file_name ?? '',
      hall: light.hall ?? false,
      ...(light._id && light._id.length > 0 ? { _id: light._id } : {}),
      light_type: light.light_type ?? 'Directional Light',
      color: light.color ?? '#ffffff',
      shadow: light.shadow ?? 'Soft Shadow',
      getShadow: light.getShadow ?? true,
      shadowRadius: light.shadowRadius ?? 4,
      shadowBlur: light.shadowBlur ?? 3.5,
      shadowDarkness: light.shadowDarkness ?? 1,
      shadowOpacity: light.shadowOpacity ?? 1,
      name: light.name ?? 'Light Name',
      angle: light.angle ?? undefined,
      position: {
        x: light.position?.x ?? 0,
        y: light.position?.y ?? 10,
        z: light.position?.z ?? 0,
      },
      rotation: rotationData,
      width: light.width ?? undefined,
      height: light.height ?? undefined,
      range: light.range ?? undefined,
      parent: (() => {
        if (lightObj && lightObj.parent && lightObj.parent !== scene) {
          return getParentIdentifier(lightObj.parent);
        }
        return light.parent ? getParentIdentifier(light.parent) : null;
      })(),
    });
  });

  uploadPromises.push(lightDataUpdateApi(formattedLights ?? []));
  // }

  // ========== by prasann for ambient light =========

  if (light_data) {
    const isDirectional = light_data.type === 'DirectionalLight';
    const isAmbient = light_data.type === 'AmbientLight';
    const isPoint = light_data.type === 'PointLight';
    const isSpot = light_data.type === 'SpotLight';

    let lightDataScene = null;

    if (isDirectional) {
      lightDataScene = scene.getObjectByName('directionalLight');
    } else if (isAmbient) {
      lightDataScene = scene.getObjectByName('ambientLight');
    } else if (isPoint) {
      lightDataScene = scene.getObjectByName('pointLight');
    } else if (isSpot) {
      lightDataScene = scene.getObjectByName('spotLight');
    }

    // uploadPromises.push(lightDataUpdateApi(obj));
  }
  // ========== end by prasann for ambient light =========

  // Process mesh assets
  // if (
  //   sceneMeshes.length > 0 ||
  //   delete_items.some((val) => val.deleteType === 'mesh')
  // ) {
  const meshAssets = [];
  const meshFiles = [];
  const filesToDelete = [];
  const publishedMeshKeys = new Set();
  syncAllMeshHierarchyFromRedux(scene);
  for (const mesh of sceneMeshes) {
    const meshKey =
      mesh._id || mesh.name || mesh.url || mesh.temp_file_name || null;
    if (meshKey && publishedMeshKeys.has(meshKey)) {
      continue;
    }
    if (meshKey) {
      publishedMeshKeys.add(meshKey);
    }
    const currentTransform = getCurrentTransformFromScene(
      mesh._id || mesh.name,
      mesh.mesh_code
    );
    let groupp =
      scene.getObjectByName(mesh.name) || scene.getObjectByName(mesh._id);

    if (!groupp) {
      // Fallback: deep search for the object by various possible identifiers
      scene.traverse((obj) => {
        if (groupp) return;
        if (
          obj.name === mesh.name ||
          obj._id === mesh._id ||
          obj.userData?._id === mesh._id ||
          obj.userData?.id === mesh._id ||
          // Library asset fallback: match by libraryAssetId when temp IDs have drifted
          (mesh.source === 'library' && mesh.libraryAssetId && obj.libraryAssetId === mesh.libraryAssetId) ||
          // Sketchfab asset fallback: match by sketchfabUid
          (mesh.source === 'sketchfab' && mesh.userData?.sketchfabUid && obj.userData?.sketchfabUid === mesh.userData?.sketchfabUid)
        ) {
          groupp = obj;
        }
      });
    }

    // Resolve inner GLB node → this asset's editor pivot.
    // Do NOT climb into a hierarchy parent mesh — that would publish the
    // parent's local TRS (and bake) as if it were the child.
    if (groupp && !(groupp.deleteType === 'mesh' && groupp.objType === '3d')) {
      let node = groupp.parent;
      while (node && node !== scene) {
        if (node.deleteType === 'mesh' && node.objType === '3d') {
          groupp = node;
          break;
        }
        node = node.parent;
      }
    }

    if (!groupp) {
      console.warn(
        `[Publish] GLB object not found in scene hierarchy for mesh:`,
        mesh.name || mesh._id
      );
      failCount++;
      continue;
    }

    const meshIsDuplicate = isDuplicateSceneAsset(mesh, groupp);

    let material_settings = {};
    if (groupp?.userData && groupp?.userData.material_settings) {
      const data = groupp?.userData.material_settings;
      material_settings = data;
    }
    // Fallback: for library/sketchfab assets the pivot userData may not be populated
    // on first publish (before onAfterPublish reloads and restores it via UpdateMaterial).
    // Read material_settings from the Redux mesh record so they are never lost.
    if (
      (!material_settings || Object.keys(material_settings).length === 0) &&
      mesh.material_settings &&
      Object.keys(mesh.material_settings).length > 0
    ) {
      material_settings = mesh.material_settings;
    }

    // Mesh material_settings are object-level only (Render View / Side / Shadow).
    // Strip stale albedo/maps from older panel writes so they don't force a GLB re-bake.
    const prevMs = material_settings || {};
    material_settings = {
      ...pickObjectLevelMaterialSettingsForApi(prevMs),
      ...(prevMs.pivot_mode ? { pivot_mode: prevMs.pivot_mode } : {}),
      ...(prevMs.native_pivot ? { native_pivot: prevMs.native_pivot } : {}),
      ...(prevMs.pivot_edited ? { pivot_edited: prevMs.pivot_edited } : {}),
    };
    if (groupp) {
      groupp.userData = {
        ...(groupp.userData || {}),
        material_settings,
      };
    }

    // After stripping to object-level settings, only live Three.js material edits
    // should force a GLB re-bake — not Render View / Side / Shadow metadata.
    const materialModified = !!(
      (groupp && hasMaterialModifications(groupp)) ||
      meshIsDuplicate
    );

    // Mark hierarchy edited so publish can bake live materials into the GLB.
    // Do not put childOverrides on the API payload — they are stripped in sanitize.
    if (
      groupp &&
      (hasSkinnedMeshInHierarchy(groupp) ||
        hasThreeMaterialEditsInHierarchy(groupp) ||
        hasWireframeInHierarchy(groupp) ||
        hasEditorAssignedMapsInHierarchy(groupp))
    ) {
      if (
        groupp.userData?.threeMaterialEdited ||
        hasThreeMaterialEditsInHierarchy(groupp) ||
        hasWireframeInHierarchy(groupp) ||
        hasEditorAssignedMapsInHierarchy(groupp)
      ) {
        // Replace userData with a fresh (unfrozen) object so Immer-frozen
        // Three.js objects don't throw "Cannot assign to read only property".
        groupp.userData = { ...(groupp.userData || {}), threeMaterialEdited: true };
      }
    }

    const publishGlb = await resolvePublishGlbSource({
      mesh,
      groupp,
      materialModified:
        materialModified ||
        !!groupp?.userData?.threeMaterialEdited ||
        (groupp && hasThreeMaterialEditsInHierarchy(groupp)) ||
        (groupp && hasWireframeInHierarchy(groupp)) ||
        (groupp && hasEditorAssignedMapsInHierarchy(groupp)),
    });

    if (publishGlb.error) {
      console.warn(
        '[Publish] GLB skipped:',
        mesh.file_name || mesh.name,
        publishGlb.error
      );
      toast.error(publishGlb.error);
      failCount++;
      continue;
    }

    const groupToGlb = publishGlb.source;
    const skipGlbFileUpload =
      publishGlb.skipUpload || groupToGlb === SKIP_GLB_FILE_UPLOAD;

    if (
      groupp &&
      groupToGlb instanceof Blob &&
      !skipGlbFileUpload &&
      !(groupToGlb instanceof File)
    ) {
      cacheGlbFileOnSceneObject(
        groupp,
        groupToGlb,
        mesh.file_name || `${mesh.name || 'model'}.glb`,
        {
          allowSkinned:
            !!publishGlb.materialBaked || !!publishGlb.pivotBaked,
        }
      );
    }
    const position = currentTransform?.position || {
      x: groupp?.position?.x ?? mesh.position?.x ?? mesh.position?.[0] ?? 0,
      y: groupp?.position?.y ?? mesh.position?.y ?? mesh.position?.[1] ?? 0,
      z: groupp?.position?.z ?? mesh.position?.z ?? mesh.position?.[2] ?? 0,
    };
    const rotation = currentTransform?.rotation || {
      x: groupp?.rotation?.x ?? mesh.rotation?.x ?? mesh.rotation?.[0] ?? 0,
      y: groupp?.rotation?.y ?? mesh.rotation?.y ?? mesh.rotation?.[1] ?? 0,
      z: groupp?.rotation?.z ?? mesh.rotation?.z ?? mesh.rotation?.[2] ?? 0,
    };
    const scale = currentTransform?.scale || {
      x: groupp?.scale?.x ?? mesh.scale?.x ?? mesh.scale?.[0] ?? 1,
      y: groupp?.scale?.y ?? mesh.scale?.y ?? mesh.scale?.[1] ?? 1,
      z: groupp?.scale?.z ?? mesh.scale?.z ?? mesh.scale?.[2] ?? 1,
    };
    // Merge mesh.userData into live settings — never replace.
    if (mesh.userData && mesh.userData.material_settings) {
      material_settings = {
        ...mesh.userData.material_settings,
        ...(material_settings || {}),
      };
    }

    const fullMaterialSettings = mergeMaterialSettingsForPublish(
      material_settings || {},
      groupp
    );

    // Mesh material_settings payload: object-level Render View / Side / Shadow only.
    // Albedo, maps, and per-slot material data are baked into the GLB.
    const normalizedMaterialSettings =
      pickObjectLevelMaterialSettingsForApi(fullMaterialSettings);

    // Extract animation checkbox status from Redux
    const state = store.getState();
    const { animationObjects } = state.animation;
    const animObj = animationObjects?.find(
      (a) =>
        a.objectId === mesh.name || a.id === mesh.name || a.name === mesh.name
    );
    const isAnimationActive = animObj ? (animObj.isActive ?? true) : false;

    const meshPublishIdentity = buildMeshPublishIdentity(mesh, groupp);
    const pivotFields = getPivotPublishFields(groupp || mesh);
    const asset = {
      ...meshPublishIdentity,
      name: mesh.name || mesh.file_name || `Mesh ${i + 1}`,
      description:
        mesh.glb_type === 'shapes'
          ? `Shape asset (${mesh.mesh_code}) created in scene editor`
          : `Mesh asset uploaded from scene editor`,
      isAnimationActive: isAnimationActive,
      visible: getPublishVisibleForAsset(scene, mesh, assets_data, {
        type: 'mesh',
        arrKey: 'mesh',
      }),
      position_x: position.x,
      position_y: position.y,
      position_z: position.z,
      rotation_x: radToDeg(rotation.x),
      rotation_y: radToDeg(rotation.y),
      rotation_z: radToDeg(rotation.z),
      scale_x: scale.x,
      scale_y: scale.y,
      scale_z: scale.z,
      ...pivotFields,
      glb_type: mesh.glb_type || 'normal',
      deleteType: 'mesh',
      material_settings: nestPivotFieldsInSettings(
        normalizedMaterialSettings,
        pivotFields
      ),
      events: publishEventsWithPivot(
        mesh?.events,
        groupp || mesh,
        assets_data
      ),
      parent: (() => {
        const parentRef =
          getCurrentTransformFromScene(mesh._id || mesh.name, mesh.mesh_code)
            ?.parent || mesh.parent;
        if (!parentRef) return null;
        if (typeof parentRef === 'string') {
          return isValidMongoObjectId(parentRef) ? parentRef : parentRef;
        }
        const parentId = getParentIdentifier(parentRef);
        if (isValidMongoObjectId(parentId)) return parentId;
        return parentRef.temp_file_name || parentId;
      })(),
      Events: mesh?.userData?.Events,
      ...(mesh.glb_type === 'shapes' && {
        glb_type: 'shapes',
        mesh_code: groupp?.mesh_code || mesh.mesh_code,
        shape_type: groupp?.mesh_code || mesh.mesh_code,
        created_at: groupp?.createdAt || mesh.createdAt,
      }),
    };

    // Handle different types of meshes
    // Keep PLY assets as .ply (do not convert to .glb on publish)
    if (mesh.glb_type === 'ply') {
      const plyFile =
        mesh.objPath instanceof File
          ? mesh.objPath
          : mesh.originalFile instanceof File
            ? mesh.originalFile
            : null;

      if (plyFile) {
        meshFiles.push(plyFile);
        asset.asset_file_name = plyFile.name || mesh.file_name;
        asset.file_name = plyFile.name || mesh.file_name;
        asset.file_size = plyFile.size;
        asset.file_type = plyFile.type || 'application/octet-stream';
      } else if (
        !meshIsDuplicate &&
        (mesh.asset_file_pathh || mesh.asset_file_path)
      ) {
        // Existing PLY already on server/cloud path; keep path and metadata as PLY
        asset.asset_file_path = mesh.asset_file_pathh || mesh.asset_file_path;
        const inferredName =
          mesh.file_name ||
          (typeof asset.asset_file_path === 'string'
            ? asset.asset_file_path.split(/[\\/]/).pop()
            : '');
        if (inferredName) {
          asset.asset_file_name = inferredName;
          asset.file_name = inferredName;
        }
      }

      meshAssets.push(asset);
      continue;
    }

    if (mesh.asset_file_pathh && !meshIsDuplicate) {
      if (!skipGlbFileUpload) {
        // Delete previous file when uploading a new GLB binary
        if (mesh.name) {
          filesToDelete.push({
            id: mesh.name,
            url:
              mesh.asset_file_pathh ||
              mesh.asset_file_path ||
              mesh.url ||
              mesh.name,
            deleteType: 'mesh',
          });
        }
        if (groupToGlb) {
          const file = new File([groupToGlb], mesh.file_name, {
            type: 'model/gltf-binary',
            lastModified: Date.now(),
          });
          meshFiles.push(file);
          asset.file_size = file.size;
        }
      }
      asset.asset_file_path = mesh.asset_file_pathh;
      asset.asset_file_name = mesh.file_name;
      asset.file_name = mesh.file_name;
      asset.file_type = 'model/gltf-binary';
      meshAssets.push(asset);
    } else if (mesh.glb_type === 'shapes') {
      // Export shape as GLB at publish time
      try {
        const glbData = await exportShapeAsGLB(
          groupp || mesh,
          mesh.file_name,
          scene
        );
        const file = new File([glbData.blob], `${mesh.file_name}.glb`, {
          type: 'model/gltf-binary',
          lastModified: Date.now(),
        });
        meshFiles.push(file);
        // asset.asset_file_path = `${mesh.file_name}.glb`;
        asset.asset_file_name = mesh.file_name;
        asset.file_name = mesh.file_name;

        asset.file_size = file.size;
        asset.file_type = 'model/gltf-binary';
        meshAssets.push(asset);
      } catch (error) {
        console.error('Failed to export shape as GLB:', error);
        failCount++;
        continue;
      }
    } else if (mesh.glb_file instanceof File) {
      meshFiles.push(mesh.glb_file);
      meshAssets.push(asset);
    } else if (mesh.glb_blob && mesh.file_name) {
      const file = new File([mesh.glb_blob], mesh.file_name, {
        type: 'model/gltf-binary',
        lastModified: Date.now(),
      });
      meshFiles.push(file);
      meshAssets.push(asset);
    } else if (mesh.glb_type === 'obj' || mesh.glb_type === 'fbx') {
      // Convert OBJ/FBX to GLB at publish (scene object already has textures applied)
      if (!groupToGlb || skipGlbFileUpload) {
        console.error(
          'Cannot convert OBJ/FBX to GLB: no group blob',
          mesh.name
        );
        failCount++;
        continue;
      }
      const baseName = (mesh.file_name || mesh.name || 'model').replace(
        /\.(obj|fbx)$/i,
        ''
      );
      const glbFileName = `${baseName}.glb`;
      if (mesh.name) {
        filesToDelete.push({
          id: mesh.name,
          url:
            mesh.asset_file_pathh ||
            mesh.asset_file_path ||
            mesh.url ||
            mesh.name,
          deleteType: 'mesh',
        });
      }
      const file = new File([groupToGlb], glbFileName, {
        type: 'model/gltf-binary',
        lastModified: Date.now(),
      });
      meshFiles.push(file);
      asset.glb_type = 'normal';
      asset.asset_file_name = glbFileName;
      asset.file_name = glbFileName;
      asset.file_size = file.size;
      asset.file_type = 'model/gltf-binary';
      meshAssets.push(asset);
    } else if (
      mesh.objPath instanceof File &&
      mesh.glb_type !== 'obj' &&
      mesh.glb_type !== 'fbx'
    ) {
      if (!groupToGlb || skipGlbFileUpload) {
        failCount++;
        continue;
      }
      const baseName = (mesh.file_name || mesh.name || 'model').replace(
        /\.(obj|fbx)$/i,
        ''
      );
      const glbFileName = `${baseName}.glb`;
      const file = new File([groupToGlb], glbFileName, {
        type: 'model/gltf-binary',
        lastModified: Date.now(),
      });
      meshFiles.push(file);
      meshAssets.push(asset);
    } else if (mesh.glb_array_buffer && mesh.file_name) {
      const file = new File([mesh.glb_array_buffer], mesh.file_name, {
        type: 'model/gltf-binary',
        lastModified: Date.now(),
      });
      meshFiles.push(file);
      meshAssets.push(asset);
    } else if (
      (mesh.source === 'sketchfab' || (mesh.userData && mesh.userData.type === 'sketchfab')) &&
      (mesh.objPath instanceof File || (groupp && groupp.objPath instanceof File)) &&
      !meshIsDuplicate &&
      skipGlbFileUpload
    ) {
      // Handle Sketchfab models - they now have the actual downloaded file
      const sketchfabFile = mesh.objPath instanceof File ? mesh.objPath : groupp.objPath;
      const sketchfabUid = mesh.userData?.sketchfabUid || groupp?.userData?.sketchfabUid || mesh.sketchfabUid;
      meshFiles.push(sketchfabFile);
      // Upload blob keeps unique sketchfab_<uid>.glb identity
      asset.asset_file_name =
        (sketchfabFile && sketchfabFile.name) ||
        (sketchfabUid ? `sketchfab_${sketchfabUid}.glb` : 'sketchfab_model.glb');
      // Keep human-readable title for left panel / API file_name when available
      const displayName =
        mesh.file_name ||
        mesh.asset_file_name ||
        mesh.userData?.displayName ||
        groupp?.file_name ||
        groupp?.userData?.displayName;
      const looksLikeUidLabel =
        !displayName ||
        /^sketchfab_[a-z0-9_-]+(\.glb)?$/i.test(String(displayName).trim());
      asset.file_name = looksLikeUidLabel
        ? asset.asset_file_name
        : displayName;
      asset.file_size = sketchfabFile.size;
      asset.file_type = 'model/gltf-binary';
      asset.source = 'sketchfab';
      if (sketchfabUid) asset.sketchfabUid = sketchfabUid;
      meshAssets.push(asset);
    } else if (
      mesh.source === 'library' &&
      mesh.url &&
      !meshIsDuplicate &&
      skipGlbFileUpload
    ) {
      // Handle library assets - reference by URL without re-exporting
      asset.asset_file_path = mesh.url;
      asset.asset_file_name = mesh.file_name || mesh.name;
      asset.file_name = mesh.file_name || mesh.name;
      asset.file_type = 'model/gltf-binary';
      asset.from_library = true;
      // Persist source/libraryAssetId so the API stores and returns them,
      // allowing DownloadMesh to restore library identity after reload.
      asset.source = 'library';
      if (mesh.libraryAssetId || groupp?.libraryAssetId) {
        asset.libraryAssetId = mesh.libraryAssetId || groupp?.libraryAssetId;
      }
      meshAssets.push(asset);
      // No file to push - library assets are referenced by URL only
    } else if (mesh.name) {
      // Duplicates and material-edited assets always upload the baked GLB here
      // (including library/sketchfab copies that must not reuse the source URL).
      if (!skipGlbFileUpload) {
        filesToDelete.push({
          id: mesh.name,
          url:
            mesh.asset_file_pathh ||
            mesh.asset_file_path ||
            mesh.url ||
            mesh.name,
          deleteType: 'mesh',
        });
        if (groupToGlb) {
          const glbName = String(mesh.file_name || mesh.name || 'model').replace(
            /\.glb$/i,
            ''
          );
          const file = new File([groupToGlb], `${glbName}.glb`, {
            type: 'model/gltf-binary',
            lastModified: Date.now(),
          });
          meshFiles.push(file);
          asset.file_size = file.size;
        }
      }
      asset.asset_file_name = mesh.file_name;
      asset.file_name = mesh.file_name;
      asset.temp_file_name = mesh.temp_file_name;
      asset.file_type = 'model/gltf-binary';
      if (meshIsDuplicate) {
        asset.isDuplicate = true;
      }

      meshAssets.push(asset);
    }
  }

  uploadPromises.push(
    makeAssetUpload(meshAssets, meshFiles, 'mesh', filesToDelete)
  );
  // }

  // Process image assets
  if (
    sceneImages?.length > 0 ||
    delete_items.some((val) => val.deleteType === 'image')
  ) {
    const imageAssets = [];
    const imageFiles = [];
    sceneImages?.forEach((image, i) => {
      const currentTransform = getCurrentTransformFromScene(
        image.name,
        image._id
      );
      const position = currentTransform?.position || image.position;
      const rotation = currentTransform?.rotation || image.rotation;
      const scale = currentTransform?.scale || image.scale;

      let imageObj =
        scene.getObjectByName(image.name) || scene.getObjectByName(image._id);
      if (!imageObj) {
        scene.traverse((obj) => {
          if (imageObj) return;
          if (
            obj.name === image.name ||
            obj._id === image._id ||
            obj.userData?._id === image._id
          ) {
            imageObj = obj;
          }
        });
      }

      const storedSettings =
        imageObj?.userData?.material_settings ||
        image.userData?.material_settings ||
        {};
      const material_settings = sanitizeMaterialSettingsForApi(
        mergeMaterialSettingsForPublish(storedSettings, imageObj || image)
      );

      const animObj = animationObjects?.find(
        (a) =>
          a.objectId === image.name ||
          a.id === image.name ||
          a.name === image.name
      );
      const isAnimationActive = animObj ? (animObj.isActive ?? true) : false;
      const pivotFields = getPivotPublishFields(imageObj || image);

      const planeW = imageObj?.geometry?.parameters?.width ?? imageScales[i]?.x ?? 1;
      const planeH = imageObj?.geometry?.parameters?.height ?? imageScales[i]?.y ?? 1;

      const asset = {
        name: image.file_name || image.name,
        file_name: image.file_name || image.name,
        temp_file_name: image.temp_file_name || image.name,
        description: `Image asset uploaded from scene editor`,
        isAnimationActive: isAnimationActive,
        visible: getPublishVisibleForAsset(scene, image, assets_data, {
          type: 'image',
          arrKey: 'image',
        }),
        position_x: position.x,
        position_y: position.y,
        position_z: position.z,
        rotation_x: radToDeg(rotation.x),
        rotation_y: radToDeg(rotation.y),
        rotation_z: radToDeg(rotation.z),
        scale_x: planeW * scale.x,
        scale_y: planeH * scale.y,
        scale_z: scale.z,
        material_settings: nestPivotFieldsInSettings(
          material_settings,
          pivotFields
        ),
        events: publishEventsWithPivot(
          image?.events,
          imageObj || image,
          assets_data
        ),
        parent: getParentIdentifier(
          getCurrentTransformFromScene(image.name, image._id)?.parent ||
            image.parent
        ),
        ...pivotFields,
      };

      if (image.asset_file_pathh || image.asset_file_path) {
        asset.asset_file_path = image.asset_file_pathh || image.asset_file_path;
        imageAssets.push(asset);
      } else if (image.source === 'library' && image.url) {
        // Handle library images - reference by URL without uploading
        asset.asset_file_path = image.url;
        asset.from_library = true;
        imageAssets.push(asset);
      } else if (image.objPath instanceof File) {
        imageFiles.push(image.objPath);
        imageAssets.push(asset);
      } else if (typeof image.name === 'string') {
        asset.asset_file_path = image.name;
        imageAssets.push(asset);
      } else {
        imageAssets.push(asset);
      }
    });
    uploadPromises.push(makeAssetUpload(imageAssets, imageFiles, 'image'));
  }

  // Process video assets
  if (
    sceneVideos?.length > 0 ||
    delete_items.some((val) => val.deleteType === 'video')
  ) {
    const videoAssets = [];
    const videoFiles = [];
    sceneVideos?.forEach((video, i) => {
      const currentTransform = getCurrentTransformFromScene(
        video.name,
        video._id
      );
      const position = currentTransform?.position || video.position;
      const rotation = currentTransform?.rotation || video.rotation;
      const scale = currentTransform?.scale || video.scale;
      let sceneVideoObj =
        scene.getObjectByName(video.name) ||
        (video._id ? scene.getObjectByName(video._id) : null);
      if (!sceneVideoObj) {
        scene.traverse((obj) => {
          if (sceneVideoObj) return;
          if (
            obj.deleteType === 'video' &&
            (obj.name === video.name ||
              obj._id === video._id ||
              obj.url === video._id ||
              obj.url === video.url)
          ) {
            sceneVideoObj = obj;
          }
        });
      }
      if (!sceneVideoObj && video?.deleteType === 'video') {
        sceneVideoObj = video;
      }
      const planeW =
        sceneVideoObj?.geometry?.parameters?.width ?? videoScales[i]?.x ?? 1;
      const planeH =
        sceneVideoObj?.geometry?.parameters?.height ?? videoScales[i]?.y ?? 1;
      const meshScale = {
        x: scale?.x ?? scale?.[0] ?? 1,
        y: scale?.y ?? scale?.[1] ?? 1,
        z: scale?.z ?? scale?.[2] ?? 1,
      };
      const bakedVideoScale = videoMeshScaleToSavedScale(
        meshScale,
        planeW,
        planeH
      );
      let allMaterialProps = {};
      if (currentTransform?.material) {
        allMaterialProps = extractMaterialProps(currentTransform.material);
      } else if (video.material) {
        allMaterialProps = extractMaterialProps(video.material);
      } else if (video.userData?.material_settings) {
        allMaterialProps = { ...video.userData.material_settings };
      }
      const animObj = animationObjects?.find(
        (a) =>
          a.objectId === video.name ||
          a.id === video.name ||
          a.name === video.name
      );
      const isAnimationActive = animObj ? (animObj.isActive ?? true) : false;

      const publishedVideoSettings = {
        ...(video?.userData?.video_settings || {}),
        base_plane_width: planeW,
        base_plane_height: planeH,
      };
      const pivotFields = getPivotPublishFields(sceneVideoObj || video);
      const nestedVideoSettings = nestPivotFieldsInSettings(
        publishedVideoSettings,
        pivotFields
      );

      const asset = {
        name: video.name || `Video ${i + 1}`,
        file_name: video.file_name || video.name,
        description: `Video asset uploaded from scene editor`,
        isAnimationActive: isAnimationActive,
        visible: getPublishVisibleForAsset(scene, video, assets_data, {
          type: 'video',
          arrKey: 'video',
        }),
        position_x: position.x,
        position_y: position.y,
        position_z: position.z,
        rotation_x: radToDeg(rotation.x),
        rotation_y: radToDeg(rotation.y),
        rotation_z: radToDeg(rotation.z),
        scale_x: bakedVideoScale.scale_x,
        scale_y: bakedVideoScale.scale_y,
        scale_z: bakedVideoScale.scale_z,
        material_settings: nestPivotFieldsInSettings(
          allMaterialProps,
          pivotFields
        ),
        userData: {
          video_settings: nestedVideoSettings,
        },
        video_settings: nestedVideoSettings,
        events: publishEventsWithPivot(
          video?.events,
          sceneVideoObj || video,
          assets_data
        ),
        // parent:
        //   video.parent?.name || video.parent?._id || video.parent?.url || null,
        parent: getParentIdentifier(
          getCurrentTransformFromScene(video.name, video._id)?.parent ||
            video.parent
        ),
        ...pivotFields,
      };
      // Normalize video_settings.source to valid backend enum
      if (asset.video_settings && asset.video_settings.source === 'URL') {
        asset.video_settings.source = 'URL';
        if (asset.userData && asset.userData.video_settings) {
          asset.userData.video_settings.source = 'URL';
        }
      }
      if (video.asset_file_pathh) {
        asset.asset_file_path = video.asset_file_pathh;
        videoAssets.push(asset);
      } else if (video.source === 'library' && video.url) {
        // Handle library videos - reference by URL without uploading
        asset.asset_file_path = video.url;
        asset.from_library = true;
        videoAssets.push(asset);
      } else if (video.objPath instanceof File) {
        videoFiles.push(video.objPath);
        // video.objPath = null;
        videoAssets.push(asset);
      } else if (typeof video.name === 'string') {
        asset.asset_file_path = video.name;
        videoAssets.push(asset);
      } else if (video.asset_file_path) {
        // Fallback for URL-based videos created at runtime
        asset.asset_file_path = video.asset_file_path;
        videoAssets.push(asset);
      }
    });
    uploadPromises.push(makeAssetUpload(videoAssets, videoFiles, 'video'));
  }

  // Process audio assets
  if (
    sceneAudios?.length > 0 ||
    delete_items.some((val) => val.deleteType === 'audio')
  ) {
    const audioAssets = [];
    const audioFiles = [];
    sceneAudios?.forEach((audio, i) => {
      if (!audio.url && !audio.file) return;
      const currentTransform = getCurrentTransformFromScene(
        audio.name,
        audio._id
      );
      const position = currentTransform?.position || audio.position;
      const rotation = currentTransform?.rotation || audio.rotation;
      const scale = currentTransform?.scale || audio.scale;
      let allMaterialProps = {};
      if (currentTransform?.material) {
        allMaterialProps = extractMaterialProps(currentTransform.material);
      } else if (audio.material) {
        allMaterialProps = extractMaterialProps(audio.material);
      } else if (audio.userData?.material_settings) {
        allMaterialProps = { ...audio.userData.material_settings };
      }
      const audioPathOrName =
        audio.asset_file_pathh ||
        audio.asset_file_path ||
        audio.file_name ||
        audio.userData?.file_name ||
        audio.name ||
        '';
      const audioExt = (audioPathOrName.toString().match(/\.(mp3|wav|ogg)$/i) ||
        [])[1];
      const asset_file_type = audioExt
        ? audioExt.toLowerCase()
        : audio.asset_file_type &&
            /^(mp3|wav|ogg)$/i.test(audio.asset_file_type)
          ? audio.asset_file_type.toLowerCase()
          : 'mp3';

      const sceneAudio =
        scene.getObjectByName(audio.name) ||
        (audio._id && scene.getObjectByName(audio._id)) ||
        audio;
      const rawSettings = {
        ...(sceneAudio?.userData?.audio_settings || {}),
        ...(sceneAudio?.audio_settings || {}),
      };
      const audioSettings = {
        ...rawSettings,
        pitch:
          rawSettings.pitch !== undefined && rawSettings.pitch !== null
            ? Number(rawSettings.pitch)
            : 1,
        priority:
          rawSettings.priority !== undefined && rawSettings.priority !== null
            ? Number(rawSettings.priority)
            : 128,
      };

      const animObj = animationObjects?.find(
        (a) =>
          a.objectId === audio.name ||
          a.id === audio.name ||
          a.name === audio.name
      );
      const isAnimationActive = animObj ? (animObj.isActive ?? true) : false;
      const pivotFields = getPivotPublishFields(sceneAudio || audio);

      const asset = {
        name: audio.name || `Audio ${i + 1}`,
        file_name: audio.file_name || audio.name,
        description: `Audio asset uploaded from scene editor`,
        isAnimationActive: isAnimationActive,
        visible: getPublishVisibleForAsset(scene, audio, assets_data, {
          type: 'audio',
          arrKey: 'audio',
        }),
        position_x: position.x,
        position_y: position.y,
        position_z: position.z,
        rotation_x: radToDeg(rotation.x),
        rotation_y: radToDeg(rotation.y),
        rotation_z: radToDeg(rotation.z),
        scale_x: audioScales[i]?.x * scale.x,
        scale_y: audioScales[i]?.y * scale.y,
        scale_z: scale.z,
        material_settings: nestPivotFieldsInSettings(
          allMaterialProps,
          pivotFields
        ),
        audio_settings: nestPivotFieldsInSettings(audioSettings, pivotFields),
        events: publishEventsWithPivot(
          audio?.events,
          sceneAudio || audio,
          assets_data
        ),
        asset_file_type,
        parent: getParentIdentifier(
          getCurrentTransformFromScene(audio.name, audio._id)?.parent ||
            audio.parent
        ),
        ...pivotFields,
      };
      if (audio.objPath instanceof File) {
        audioFiles.push(audio.objPath);
        audioAssets.push(asset);
      } else if (audio.source === 'library' && audio.url) {
        // Handle library audio - reference by URL without uploading
        asset.asset_file_path = audio.url;
        asset.from_library = true;
        audioAssets.push(asset);
      } else if (
        audio.asset_file_pathh &&
        !String(audio.asset_file_pathh).startsWith('blob:')
      ) {
        asset.asset_file_path = audio.asset_file_pathh;
        audioAssets.push(asset);
      } else if (typeof audio.name === 'string') {
        asset.asset_file_path = audio.name;
        audioAssets.push(asset);
      }
    });
    uploadPromises.push(makeAssetUpload(audioAssets, audioFiles, 'audio'));
  }

  // Process text assets
  const textData = (Array.isArray(sceneText) ? sceneText : []).filter(
    (text) => text && text.deleteType === 'text'
  );

  if (
    textData.length > 0 ||
    delete_items.some((val) => val.deleteType === 'text')
  ) {
    const textAssets = [];
    const textFiles = [];
    for (const [i, text] of textData.entries()) {
      const textBlob = await exportTextMeshToGLB(text);
      // exportTextMeshToGLB returns a plain Blob (no filename) — wrap it in a File
      // with a .glb name so the upload isn't sent as a generic, extension-less "blob".
      const textFile = new File(
        [textBlob],
        `${text.file_name || text.temp_file_name || text.name || 'text'}.glb`,
        { type: 'model/gltf-binary' }
      );
      textFiles.push(textFile);
      const currentTransform = getCurrentTransformFromScene(
        text.name,
        text._id
      );
      const position = currentTransform?.position || text.position;
      const rotation = currentTransform?.rotation || text.rotation;
      const scale = currentTransform?.scale || text.scale;
      const panelScale = getTextPublishPanelScale(text, scale);
      const tm = text.userData.text_material || {};
      let allMaterialProps = {};
      if (currentTransform?.material) {
        allMaterialProps = extractMaterialProps(currentTransform.material);
      } else if (text.material) {
        allMaterialProps = extractMaterialProps(text.material);
      } else if (text.userData?.text_material) {
        allMaterialProps = { ...text.userData.text_material };
      }
      const animObj = animationObjects?.find(
        (a) =>
          a.objectId === text.name || a.id === text.name || a.name === text.name
      );
      const isAnimationActive = animObj ? (animObj.isActive ?? true) : false;

      const asset = {
        // name: text.name || `Text ${i + 1}`,
        name:
          text?.name &&
          !text?.name.startsWith('temp') &&
          !text?.name.startsWith('text')
            ? text?.name
            : null,
        description: `Text asset uploaded from scene editor`,
        isAnimationActive: isAnimationActive,
        visible: getPublishVisibleForAsset(scene, text, assets_data, {
          type: 'text',
          arrKey: 'text',
        }),
        position_x: position.x,
        position_y: position.y,
        position_z: position.z,
        rotation_x: radToDeg(rotation.x),
        rotation_y: radToDeg(rotation.y),
        rotation_z: radToDeg(rotation.z),
        scale_x: panelScale.x,
        scale_y: panelScale.y,
        scale_z: panelScale.z,
        text_material: {
          ...tm,
          bakedTextScale: {
            x: panelScale.x,
            y: panelScale.y,
            z: panelScale.z,
          },
          ...((text.userData?.pivotEdited || text.pivotEdited) &&
          (Array.isArray(text.userData?.pivotContentMatrix) &&
            text.userData.pivotContentMatrix.length === 16 ||
            text.userData?.pivotOffset)
            ? {
                pivot_edited: true,
                ...(Array.isArray(text.userData?.pivotContentMatrix) &&
                text.userData.pivotContentMatrix.length === 16
                  ? {
                      pivot_content_matrix: text.userData.pivotContentMatrix,
                    }
                  : {}),
                ...(text.userData?.pivotOffset
                  ? { pivot_offset: text.userData.pivotOffset }
                  : {}),
              }
            : {}),
        },
        // parent: text.userData?.parentId || text.parent?.name || text.parent?._id || text.parent?.url || null,
        textType: tm.textType,
        content: tm.content,
        // parent:
        //   text.parent?.name || text.parent?._id || text.parent?.url || null,
        parent: getParentIdentifier(
          getCurrentTransformFromScene(text.name, text._id)?.parent ||
            text.parent
        ),
        fontSize: tm.fontSize,
        color: tm.color,
        horizontal: tm.horizontal,
        vertical: tm.vertical,
        extrusion: tm.extrusion,
        bevelSize: tm.bevelSize,
        curveSegments: tm.curveSegments,
        metalness: tm.metalness,
        roughness: tm.roughness,
        fontFamily: tm.fontFamily,
        fontWeight: tm.fontWeight,
        temp_file_name: text.temp_file_name ? text.temp_file_name : text.name,
        text_code: Date.now(),
        url:
          text?._id &&
          !text?._id.startsWith('temp') &&
          !text?._id.startsWith('text')
            ? text?._id
            : null,
        id:
          text?._id &&
          !text?._id.startsWith('temp') &&
          !text?._id.startsWith('text')
            ? text?._id
            : null,
        deleteType: 'text',
        file_name: text.file_name,
        events: publishEventsWithPivot(text?.events, text, assets_data),
        ...getPivotPublishFields(text),
      };
      if (text.asset_file_pathh) {
        asset.asset_file_path = text.asset_file_pathh;
      } else if (text.objPath instanceof File) {
        textFiles.push(text.objPath);
        // text.objPath = null;
      }
      textAssets.push(asset);
    }
    console.log('textAssets', textAssets);
    uploadPromises.push(makeAssetUpload(textAssets, textFiles, 'text'));
  }

  // Hotspot bulk upload (no files)
  if (
    sceneHotspots?.length > 0 ||
    delete_items?.some((val) => val.deleteType === 'hotspot')
  ) {
    const hotspotAssets = [];
    for (const hp of sceneHotspots || []) {
      const currentTransform = getCurrentTransformFromScene(
        hp.name || hp._id,
        hp._id
      );
      let position = currentTransform?.position || {
        x: hp.position?.x ?? 0,
        y: hp.position?.y ?? 0,
        z: hp.position?.z ?? 0,
      };
      let rotation = currentTransform?.rotation || {
        x: hp.rotation?.x ?? 0,
        y: hp.rotation?.y ?? 0,
        z: hp.rotation?.z ?? 0,
      };
      let scale = currentTransform?.scale || {
        x: hp.scale?.x ?? 1,
        y: hp.scale?.y ?? 1,
        z: hp.scale?.z ?? 1,
      };

      if (sceneStateHelper && sceneStateHelper.initialStates) {
        const savedState = sceneStateHelper.initialStates.get(hp.uuid);
        if (savedState) {
          if (savedState.position) {
            position = {
              x: savedState.position.x,
              y: savedState.position.y,
              z: savedState.position.z,
            };
          }
          if (savedState.quaternion) {
            const euler = new Three.Euler().setFromQuaternion(
              savedState.quaternion,
              'XYZ'
            );
            rotation = {
              x: euler.x,
              y: euler.y,
              z: euler.z,
            };
          }
          if (savedState.scale) {
            scale = {
              x: savedState.scale.x,
              y: savedState.scale.y,
              z: savedState.scale.z,
            };
          }
        }
      }
      const ud = hp.userData?.hotspot || hp.userData || {};
      const hotspotReduxAsset = (assets_data?.hotspot || []).find(
        (a) =>
          a._id === hp._id ||
          a.id === hp._id ||
          a.url === hp._id ||
          (a.name && hp.name && a.name === hp.name)
      );
      const parentId = null;
      const hotspotPivotFields = getPivotPublishFields(hp);
      if (hotspotPivotFields.pivot_edited) {
        cachePivotRestoreData(
          projectId,
          [hp.name, hp._id, hp.url, hp.temp_file_name, hp.file_name],
          hotspotPivotFields
        );
      }
      hotspotAssets.push({
        _id: hp._id,
        id: hp.id,
        temp_file_name: hp.name || hp._id,
        visible: getPublishVisibleForAsset(scene, hp, assets_data, {
          type: 'hotspot',
          arrKey: 'hotspot',
        }),
        name:
          hotspotReduxAsset?.file_name || hp.name || hp.file_name || 'Hotspot',
        file_name: hotspotReduxAsset?.file_name || hp.file_name || 'Hotspot',
        parent: parentId,
        position_x: position.x,
        position_y: position.y,
        position_z: position.z,
        rotation_x: radToDeg(rotation.x),
        rotation_y: radToDeg(rotation.y),
        rotation_z: radToDeg(rotation.z),
        scale_x: scale.x,
        scale_y: scale.y,
        scale_z: scale.z,
        buttonShape: ud.buttonShape || 'Circle',
        buttonText: ud.buttonText || '1',
        buttonColor: ud.buttonColor || '#484848',
        buttonTextColor: ud.buttonTextColor || '#000000',
        buttonOpacity: ud.buttonOpacity ?? 0.5,
        autoFocus: !!ud.autoFocus,
        focusDistance: ud.focusDistance ?? 10,
        functionType: ud.functionType || 'Click',
        messageShape: ud.messageShape || 'Plane',
        messageText: ud.messageText || 'Welcome to spatialgrid',
        messageBgColor: ud.messageBgColor || '#000000',
        messageTextColor: ud.messageTextColor || '#ffffff',
        messageOpacity: ud.messageOpacity ?? 0.5,
        messagePopupType: ud.messagePopupType || 'normal',
        ...hotspotPivotFields,
      });
    }
    const hotspotToDelete = (delete_items || [])
      .filter((item) => item.deleteType === 'hotspot')
      .map((item) => ({
        ...formatDeleteItemForApi(item),
        deleteType: 'hotspot',
      }));
    const hotspotPayload = new FormData();
    hotspotPayload.append('projectId', projectId);
    hotspotPayload.append('assets', JSON.stringify(hotspotAssets));
    hotspotPayload.append('toDelete', JSON.stringify(hotspotToDelete));
    uploadPromises.push(
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}assets/hotspot/bulk`,
          hotspotPayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then((res) => {
          const data = res.data?.data ?? [];
          data.forEach((saved) => {
            const obj = scene.getObjectByName(
              saved.temp_file_name || saved._id
            );
            if (obj) {
              obj._id = saved._id;
              obj.id = saved._id;
              obj.url = saved._id;
              obj.name = saved._id;
              if (obj.userData?.hotspot) obj.userData.hotspot.id = saved._id;
            }
          });
          return res;
        })
    );
  }

  let thumbnailImg;

  try {
    if (rendererRef.current) {
      // === Temporarily remove helpers ===
      const removedObjects = [];

      // 1. Remove TransformControls if added to scene
      if (transformControls && transformControls.parent === scene) {
        scene.remove(transformControls);
        removedObjects.push(transformControls);
      }

      const obj = scene.getObjectByName('directionalLightHelper');
      if (obj) {
        scene.remove(obj);
        removedObjects.push(obj);
      }
      // 3. Remove viewHelper canvas (if exists in DOM)
      const viewHelperEl = document.getElementById('GridHelper');
      const helperCanvas = viewHelperEl?.querySelector('canvas');
      if (helperCanvas) {
        helperCanvas.style.display = 'none';
      }

      // === Render & Capture Thumbnail ===
      syncHdriBackgroundForCamera(scene, currentCamera);
      rendererRef.current.render(scene, currentCamera);
      thumbnailImg = rendererRef.current.domElement.toDataURL('image/png');

      // === Re-add removed helpers ===
      for (const obj of removedObjects) {
        scene.add(obj);
      }

      // Restore viewHelper canvas
      if (helperCanvas) {
        helperCanvas.style.display = '';
      }
    } else {
      console.warn('Renderer not available for thumbnail generation');
    }
  } catch (error) {
    console.error('Failed to create thumbnail:', error);
  }
  // Execute all upload promises
  await Promise.all(uploadPromises.map((p) => p.catch((e) => e)))
    .then(() => {
      store.dispatch(set_delete_objects({ type: 'clearAll' }));
      // Update project with thumbnail if available
      if (thumbnailImg && projectId) {
        return axios
          .patch(
            `${process.env.REACT_APP_BASE_URL}experience/project/${projectId}/thumbnail/img`,
            { thumbnailImg: thumbnailImg },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(() => {
            toast.success('Project saved successfully!', { id: savingToast });
            if (isSave) setPublished(true);
            clearGridHistoryAfterSaveOrPublish();
            isPublishing = false;
            store.dispatch(setIsPublishing(false));
          });
      } else {
        toast.success('Project saved successfully!', { id: savingToast });
        if (isSave) setPublished(true);
        clearGridHistoryAfterSaveOrPublish();
        isPublishing = false;
        store.dispatch(setIsPublishing(false));
      }
    })
    .then(() => {
      if (failCount > 0) {
        toast(`${failCount} assets failed to upload.`, {
          style: {
            background: '#222',
            color: '#fff',
          },
        });
      }
    })
    .catch((error) => {
      console.error('Publish failed:', error);
      toast.error('Failed to save project. Please try again.', {
        id: savingToast,
        style: {
          background: '#222',
          color: '#fff',
        },
      });
      setPublished(false);
      isPublishing = false;
      store.dispatch(setIsPublishing(false));
    });

  // 11. Run scene reload in the background so the caller (UI) can finish early
  (async () => {
    const endHistorySuppress = suppressGridHistory();
    try {
      await onAfterPublish(projectId, setName, completeObject, {
        preserveCamera: true,
        setCategory,
        setRedirectionCode,
      });

      if (savedCamera && currentCamera) {
        currentCamera.position.copy(savedCamera.position);
        currentCamera.quaternion.copy(savedCamera.quaternion);
        currentCamera.zoom = savedCamera.zoom;
        if (
          currentCamera.isOrthographicCamera &&
          savedCamera.left !== undefined
        ) {
          currentCamera.left = savedCamera.left;
          currentCamera.right = savedCamera.right;
          currentCamera.top = savedCamera.top;
          currentCamera.bottom = savedCamera.bottom;
        }
        currentCamera.updateProjectionMatrix();

        if (controlsOrbit && savedCamera.target) {
          controlsOrbit.target.copy(savedCamera.target);
          controlsOrbit.update();
        }
        syncHdriBackgroundForCamera(scene, currentCamera);
        rendererRef.current?.render(scene, currentCamera);
      }
    } catch (err) {
      console.error('Background reload failed:', err);
    } finally {
      endHistorySuppress();
      // Reload can dispatch Redux updates — wipe history so undo starts fresh.
      clearGridHistoryAfterSaveOrPublish();
      isPublishing = false;
      store.dispatch(setIsPublishing(false));
    }
  })();
}

function ChangeTransformControl(value) {
  transformControls.setMode(value);
}

function focusOnObject(object, camera, controls) {
  if (!object || !camera) return;

  if (camera.isOrthographicCamera) {
    const box = new Three.Box3().setFromObject(object);
    if (box.isEmpty()) {
      object.getWorldPosition(new Three.Vector3());
      return;
    }
    const center = new Three.Vector3();
    box.getCenter(center);
    camera.zoom = computeOrthographicFitZoom(camera, box, 1.5);
    camera.updateProjectionMatrix();
    if (controls) {
      controls.target.copy(center);
      controls.update?.();
    }
    camera.lookAt(center);
    return;
  }

  const center = new Three.Vector3();
  object.getWorldPosition(center);
  const cameraPosition = center.clone().add(new Three.Vector3(0, 0, -7.5));
  camera.position.set(cameraPosition.x, cameraPosition.y, cameraPosition.z);
  camera.lookAt(center);
  if (controls) {
    controls.target.copy(center);
    controls.update?.();
  }
}

export function GridPage({
  nobars = false,
  enterPreviewOnMount = false,
  onEnterPreview,
}) {
  const isPublishingState = useSelector(
    (state) => state.global_state.isPublishing
  );
  const cameraHelperRef = useRef(null);
  // Store reference to the demo camera for selection
  const demoCameraRef = useRef(null);
  // Add ref to track original visibility states
  const originalVisibilityStates = useRef(new Map());
  const previewEventAnimationRefs = useRef(new Map());
  const previewModeAnimationsRef = useRef(new Map());
  const previewTimelineRafRef = useRef(null);
  const appLeftSectionRef = useRef(null);

  useEffect(() => {
    registerPreviewAnimationRefs(previewModeAnimationsRef, previewTimelineRafRef);
  }, []);
  const [isAnimationMinimized, setIsAnimationMinimized] = useState(true);
  const [animationHeight, setAnimationHeight] = useState(250);
  const [isAnimationResizing, setIsAnimationResizing] = useState(false);
  // Used to force-open the bottom animation system from external triggers (e.g. Add Component -> Animation)
  const [animationForceShowSignal, setAnimationForceShowSignal] = useState(0);
  // Key to force remount of AppLeftSection when a full refresh is required
  const [leftPanelKey, setLeftPanelKey] = useState(0);
  const [redirectionCode, setRedirectionCode] = useState('');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [objectToDelete, setObjectToDelete] = useState(null);
  const [deleteModalConfig, setDeleteModalConfig] = useState({
    title: 'Confirmation delete?',
    message: 'Are you sure you want to delete this item?',
  });

  useEffect(() => {
    // Start a clean history session as soon as the grid opens.
    startFreshGridHistory({ ready: false });
    setGridHistoryScene(scene);
    setGridHistorySelectionHandler((obj) => {
      if (!obj) {
        if (transformControls?.detach) {
          transformControls.detach();
        }
        selectedObject = null;
        store.dispatch(selected_object(null));
        store.dispatch(setSelectedLightId(null));
        setSelectedObjectState(null);
        clearSelectionOutline();
        return;
      }
      if (isApplyingGridHistorySelection()) {
        setChildSelectionMode(null, { silent: true });
      }
      selectObjectInScene(obj);
    });

    const handleHistoryRestored = () => {
      if (rendererRef.current && currentCamera) {
        renderViewportWithSelectionOutline(
          rendererRef.current,
          scene,
          currentCamera
        );
      }
      // Respect per-camera helperVisible in design (like lights).
      if (
        store.getState()?.window?.window_type === 'design' &&
        globalSyncCameraHelperVisibility
      ) {
        const selectedCameraId = resolveDesignCameraHelperSelectionId();
        // Never hideAll here — cameras with helperVisible must stay visible.
        globalSyncCameraHelperVisibility(selectedCameraId || null, false);
      }
    };
    window.addEventListener('gridHistoryRestored', handleHistoryRestored);

    return () => {
      startFreshGridHistory({ ready: false });
      setGridHistoryScene(null);
      setGridHistorySelectionHandler(null);
      window.removeEventListener('gridHistoryRestored', handleHistoryRestored);
    };
  }, []);

  const handleAnimationPanelChange = useCallback(
    (minimized, height = 250, isResizing = false) => {
      setIsAnimationMinimized(minimized);
      setIsAnimationResizing(isResizing);
      window.currentHelperScale = minimized;
      // Update helper scale if it exists
      if (helper && window.updateViewHelperScale) {
        window.updateViewHelperScale(helper, minimized);
      }
      setAnimationHeight(height);
    },
    [setIsAnimationMinimized, setAnimationHeight]
  );

  // Listen for remount event (dispatched by onAfterPublish) and bump key
  useEffect(() => {
    const handleRemount = (e) => {
      setLeftPanelKey((k) => k + 1);
    };
    globalThis.addEventListener('remountAppLeftSection', handleRemount);
    return () =>
      globalThis.removeEventListener('remountAppLeftSection', handleRemount);
  }, []);

  useEffect(() => {
    const handleOpenDeleteModal = () => {
      if (store.getState()?.window?.window_type === 'preview') return;

      const activeElement = document.activeElement;
      const isTyping =
        activeElement?.tagName === 'INPUT' ||
        activeElement?.tagName === 'TEXTAREA' ||
        activeElement?.isContentEditable;
      if (isTyping) return;

      // Close top toolbar menus so delete does not re-activate a selected toolbar button.
      setActiveTab('');
      setSubmenuOpen('');
      if (activeElement instanceof HTMLElement) {
        activeElement.blur();
      }

      const multi = getMultiSelection();
      if (multi.length > 1) {
        setDeleteModalConfig({
          title: 'Delete selected objects?',
          message: `Are you sure you want to delete ${multi.length} selected objects?`,
        });
        setIsDeleteModalOpen(true);
        return;
      }

      if (selectedObject) {
        setDeleteModalConfig({
          title: 'Confirmation delete?',
          message: 'Are you sure you want to delete this item?',
        });
        setObjectToDelete(selectedObject);
        setIsDeleteModalOpen(true);
      } else {
        toast.error('Please select an object to delete.');
      }
    };

    window.addEventListener('openDeleteModal', handleOpenDeleteModal);
    return () =>
      window.removeEventListener('openDeleteModal', handleOpenDeleteModal);
  }, []);

  useEffect(() => {
    return () => {
      console.log('Cleaning up scene...');

      scene.traverse((obj) => {
        // Stop Three.js audio
        if (obj.type === 'Audio' || obj.type === 'PositionalAudio') {
          if (obj.isPlaying) {
            obj.stop();
          }
        }

        // Stop video textures (VERY IMPORTANT)
        if (obj.material) {
          const materials = Array.isArray(obj.material)
            ? obj.material
            : [obj.material];

          materials.forEach((mat) => {
            if (mat.map && mat.map.image instanceof HTMLVideoElement) {
              const video = mat.map.image;
              video.pause();
              video.src = '';
              video.load();
            }
          });
        }
      });

      // Dispose renderer (optional but recommended)
      renderer.dispose();
    };
  }, []);

  // Allow other UI pieces (like AppRightSection) to open the bottom animation system
  useEffect(() => {
    const handleOpenAnimationSystem = () => {
      // Immediately adjust layout (the animation component will also notify via onMinimizeChange)
      setIsAnimationMinimized(false);
      window.currentHelperScale = false;
      // Update helper scale if it exists
      if (helper && window.updateViewHelperScale) {
        window.updateViewHelperScale(helper, false);
      }
      setAnimationHeight((h) => (h && h > 40 ? h : 250));
      setAnimationForceShowSignal((s) => s + 1);

      // Ensure "Animation" doesn't get added to the right-side component list
      try {
        store.dispatch(
          updateActiveComponent({ option: 'Animation', type: 'remove' })
        );
      } catch (e) {
        // no-op
      }
    };

    globalThis.addEventListener(
      'openAnimationSystem',
      handleOpenAnimationSystem
    );
    return () =>
      globalThis.removeEventListener(
        'openAnimationSystem',
        handleOpenAnimationSystem
      );
  }, []);

  const disposeCameraHelperObject = (obj) => {
    if (!obj) return;
    detachObjectFromSceneGraph(obj);
    if (obj.name && obj.name.endsWith('Point')) {
      store.dispatch(removeIntersectedObject(obj));
    }
    if (typeof obj.dispose === 'function') {
      try {
        obj.dispose();
      } catch (_) {
        /* ignore double-dispose */
      }
    } else {
      obj.geometry?.dispose?.();
      const mats = Array.isArray(obj.material)
        ? obj.material
        : obj.material
          ? [obj.material]
          : [];
      mats.forEach((m) => m?.dispose?.());
    }
  };

  const removeCameraHelperForId = (cameraId) => {
    if (!scene || !cameraId) return;
    const helper =
      scene.getObjectByName(`${cameraId}Helper`) ||
      scene.children.find(
        (child) =>
          (child?.type === 'CameraHelper' || child?.isCameraHelper) &&
          child?.camera?.name === cameraId
      );
    const point = scene.getObjectByName(`${cameraId}Point`);
    if (helper) disposeCameraHelperObject(helper);
    if (point) disposeCameraHelperObject(point);
    if (cameraHelperRef.current?.name === `${cameraId}Helper`) {
      cameraHelperRef.current = null;
    }
  };

  const removeAllCameraHelpers = () => {
    if (!scene) return;
    const toRemove = scene.children.filter((child) => {
      if (!child) return false;
      if (child.type === 'CameraHelper' || child.isCameraHelper) return true;
      return isSceneCameraPoint(child);
    });
    toRemove.forEach(disposeCameraHelperObject);
    cameraHelperRef.current = null;
  };

  /**
   * Per-camera helpers (same idea as light helpers):
   * - showCameraHelper(true, cam, id) → ensure that camera's helper exists
   * - showCameraHelper(false, cam, id) → remove only that camera's helper
   * - showCameraHelper(false) → remove all camera helpers (preview / hide-all)
   */
  const showCameraHelper = (
    show = true,
    cameraObj = null,
    cameraName = 'DemoCamera'
  ) => {
    if (!scene || !store) return;

    const windowType = store.getState()?.window?.window_type;
    if (windowType === 'preview' && show) {
      return;
    }

    const lookupId =
      cameraName ||
      cameraObj?.name ||
      cameraObj?.userData?.id ||
      'DemoCamera';

    if (nobars || !show) {
      if (cameraObj || (cameraName && cameraName !== 'DemoCamera')) {
        removeCameraHelperForId(lookupId);
      } else if (!cameraObj && (!cameraName || cameraName === 'DemoCamera')) {
        // Legacy hide-all call: showCameraHelper(false)
        removeAllCameraHelpers();
      } else {
        removeCameraHelperForId(lookupId);
      }
      return;
    }

    let targetCamera = cameraObj;
    if (!targetCamera) {
      targetCamera = scene.getObjectByName(lookupId);

      if (!targetCamera) {
        targetCamera = new Three.PerspectiveCamera(
          50,
          window.innerWidth / window.innerHeight,
          0.1,
          100
        );
        targetCamera.position.set(0, 2, 5);
        targetCamera.lookAt(0, 0, 0);
        targetCamera.name = lookupId;
        scene.add(targetCamera);
      }
    }

    if (!isSceneCamera(targetCamera) && !targetCamera?.isCamera) {
      return;
    }

    const stableName = targetCamera.name || lookupId;
    targetCamera.updateProjectionMatrix?.();
    targetCamera.updateMatrixWorld?.(true);

    // Keep other cameras' helpers; only refresh this camera's helper/point.
    const existingHelper = scene.getObjectByName(`${stableName}Helper`);
    if (existingHelper?.camera === targetCamera) {
      existingHelper.visible = true;
      // Always refresh frustum lines from current camera matrices.
      if (typeof existingHelper.update === 'function') {
        existingHelper.update();
      }
      const existingPoint = scene.getObjectByName(`${stableName}Point`);
      if (existingPoint) existingPoint.position.copy(targetCamera.position);
      cameraHelperRef.current = existingHelper;
      demoCameraRef.current = targetCamera;
      return {
        helper: existingHelper,
        point: existingPoint || null,
        camera: targetCamera,
      };
    }

    removeCameraHelperForId(stableName);

    const sphereGeometry = new Three.SphereGeometry(0.1, 16, 16);
    const sphereMaterial = new Three.MeshBasicMaterial({
      color: 0xff0000,
      visible: false,
      opacity: 1,
    });
    sphereMaterial.castShadow = false;
    sphereMaterial.receiveShadow = false;
    const cameraPoint = new Three.Mesh(sphereGeometry, sphereMaterial);
    cameraPoint.name = `${stableName}Point`;
    cameraPoint.position.copy(targetCamera.position);
    scene.add(cameraPoint);

    const cameraHelper = new Three.CameraHelper(targetCamera);
    cameraHelper.name = `${stableName}Helper`;
    cameraHelper.scale.set(0.5, 0.5, 0.5);
    cameraHelper.castShadow = false;
    cameraHelper.receiveShadow = false;

    if (cameraHelper.material) {
      if (Array.isArray(cameraHelper.material)) {
        cameraHelper.material.forEach((mat) => {
          if (mat.color) mat.color.set('red');
        });
      } else if (cameraHelper.material.color) {
        cameraHelper.material.color.set('red');
      }
    }

    scene.add(cameraHelper);

    cameraHelperRef.current = cameraHelper;
    demoCameraRef.current = targetCamera;

    const allObjs = store.getState().assets_object.allIntersectedObjects;
    if (!allObjs.includes(cameraPoint)) {
      store.dispatch(setPushIntersectedObject(cameraPoint));
    }

    return {
      helper: cameraHelper,
      point: cameraPoint,
      camera: targetCamera,
    };
  };

  const syncCameraHelperVisibilityFromStore = (
    selectedCameraId = null,
    hideAll = false
  ) => {
    const camera_properties =
      store.getState()?.assets_object?.camera_properties || [];
    syncCameraHelperVisibility(scene, camera_properties, showCameraHelper, {
      selectedCameraId,
      hideAll,
    });
  };

  const resolveDesignCameraHelperSelectionId = () => {
    const selected = store.getState()?.assets_object?.select_object;
    if (isSceneCamera(selected)) return selected.name;
    if (isSceneCameraPoint(selected)) {
      return resolveSceneCameraFromPoint(scene, selected)?.name ?? null;
    }
    return null;
  };

  const restoreCameraHelpersForDesign = () => {
    if (!scene || store.getState()?.window?.window_type !== 'design') return;

    // Drop any stale helpers left from before/during preview so frustum
    // lines are rebuilt from the restored design camera matrices.
    removeAllCameraHelpers();

    const selectedCameraId = resolveDesignCameraHelperSelectionId();
    const cameraProps =
      store.getState()?.assets_object?.camera_properties || [];

    cameraProps.forEach((camProp) => {
      const sceneCam = resolveSceneCameraObject(scene, camProp);
      if (!isSceneCamera(sceneCam)) return;

      sceneCam.updateMatrix?.();
      sceneCam.updateMatrixWorld?.(true);
      sceneCam.updateProjectionMatrix?.();

      const shouldShow =
        getCameraHelperVisible(camProp) ||
        sceneCam.name === selectedCameraId ||
        getCameraStableId(camProp) === selectedCameraId;

      if (!shouldShow) return;

      // Fresh helper + pick point (previous helpers were cleared above).
      showCameraHelper(true, sceneCam, sceneCam.name);
    });

    if (rendererRef?.current && (currentCamera || camera)) {
      try {
        rendererRef.current.render(scene, currentCamera || camera);
      } catch (_) {
        /* ignore render errors during mode switch */
      }
    }
  };

  // Set global reference to showCameraHelper
  globalShowCameraHelper = showCameraHelper;
  globalSyncCameraHelperVisibility = syncCameraHelperVisibilityFromStore;

  // Function to show/hide light helpers
  const showLightHelpers = (hideAll = false) => {
    if (!scene) return;
    const currentLightData = store.getState().assets_object.light_data || [];
    syncAllLightHelpersVisibility(scene, currentLightData, { hideAll });
  };

  // Set global reference to showLightHelpers
  globalShowLightHelpers = showLightHelpers;
  const [lastSavedSceneSnapshot, setLastSavedSceneSnapshot] = useState(null);
  const { isConfirmationOpen, loading, sceneScreenshot } = useSelector(
    (state) => state.global_state
  );
  const {
    camera_properties,
    cameraType,
    sceneHotspots = [],
    select_object,
    selectedMeshesForGrouping = [],
    materialHighlightMeshes = [],
  } = useSelector((state) => state.assets_object);
  const { window_type, preview_type, window_size } = useSelector(
    (state) => state.window
  );
  const prevWindowTypeRef = useRef(window_type);
  const lastDesignSelectedCameraIdRef = useRef(null);
  // Expose animationObjects from Redux
  const { animationObjects } = useSelector((state) => state.animation);

  const [published, setPublished] = useState(false);
  const [name, setName] = useState('');
  const [polyCounttoshow, setPolyCounttoshow] = useState(0);
  const [polyCount, setPolyCount] = useState(0);
  const [rendererState, setRendererState] = useState(null);
  const [previewAutoRotateCamera, setPreviewAutoRotateCamera] = useState(false);
  const [isPreviewControlsOpen, setIsPreviewControlsOpen] = useState(false);
  /** null = default viewport camera; otherwise scene camera asset id */
  const [previewCameraId, setPreviewCameraId] = useState(null);
  const previewCameraIdRef = useRef(null);
  previewCameraIdRef.current = previewCameraId;
  /** Saved viewport camera pose so scene camera assets are never mutated in preview. */
  const previewViewportPoseRef = useRef(null);
  /** Scene camera asset transforms at preview enter — restored on exit. */
  const previewSceneCameraTransformsRef = useRef(null);

  const previewSceneCameras = useMemo(() => {
    return (camera_properties || [])
      .map((cam) => {
        const id = getCameraStableId(cam);
        if (!id) return null;
        const sceneCam = resolveSceneCameraObject(scene, cam);
        if (!isSceneCamera(sceneCam)) return null;
        const typeRaw = String(cam.type || '').toLowerCase();
        const isOrtho =
          typeRaw === 'orthographic' ||
          typeRaw === 'ortho' ||
          (!typeRaw && !!sceneCam.isOrthographicCamera);
        return {
          id,
          label: cam.file_name || cam.name || id,
          camera: sceneCam,
          camProp: cam,
          isOrtho,
          typeLabel: isOrtho ? 'Orthographic' : 'Perspective',
        };
      })
      .filter(Boolean);
  }, [camera_properties, scene, window_type]);

  // Keep each camera helper visible in design when helperVisible is true
  // (same pattern as light helpers via syncAllLightHelpersVisibility).
  useEffect(() => {
    if (!scene || window_type !== 'design') return;
    if (typeof syncCameraHelperVisibilityFromStore !== 'function') return;

    const selectedCameraId = resolveDesignCameraHelperSelectionId();
    syncCameraHelperVisibilityFromStore(selectedCameraId || null, false);
  }, [
    camera_properties,
    scene,
    window_type,
    select_object?.name,
    select_object?.uuid,
  ]);

  const captureViewportCameraPose = useCallback((cam) => {
    if (!cam) return null;
    return {
      camera: cam,
      position: cam.position.clone(),
      quaternion: cam.quaternion.clone(),
      zoom: cam.zoom,
      near: cam.near,
      far: cam.far,
      fov: cam.isPerspectiveCamera ? cam.fov : undefined,
      left: cam.isOrthographicCamera ? cam.left : undefined,
      right: cam.isOrthographicCamera ? cam.right : undefined,
      top: cam.isOrthographicCamera ? cam.top : undefined,
      bottom: cam.isOrthographicCamera ? cam.bottom : undefined,
    };
  }, []);

  const restoreViewportCameraPose = useCallback((pose) => {
    if (!pose?.camera) return;
    const cam = pose.camera;
    cam.position.copy(pose.position);
    cam.quaternion.copy(pose.quaternion);
    cam.zoom = pose.zoom;
    cam.near = pose.near;
    cam.far = pose.far;
    if (cam.isPerspectiveCamera && pose.fov != null) {
      cam.fov = pose.fov;
    }
    if (cam.isOrthographicCamera) {
      if (pose.left != null) cam.left = pose.left;
      if (pose.right != null) cam.right = pose.right;
      if (pose.top != null) cam.top = pose.top;
      if (pose.bottom != null) cam.bottom = pose.bottom;
    }
    cam.updateProjectionMatrix?.();
  }, []);

  /**
   * Preview "look through" copies a scene camera's pose onto the matching
   * viewport camera (Perspective → perspectiveCamera, Orthographic →
   * orthographicCamera). Never attach OrbitControls to scene camera assets.
   */
  const applyPreviewViewCamera = useCallback(
    (cameraId) => {
      if (!controlsOrbit || !perspectiveCamera || !orthographicCamera) return;

      const width = window.innerWidth;
      const height = window.innerHeight;
      const aspect = width / Math.max(height, 1);
      const designViewType = cameraType || 'perspective';
      const designViewportCam =
        designViewType === 'orthographic'
          ? orthographicCamera
          : perspectiveCamera;

      // Default View: restore design viewport camera type + saved pose.
      if (!cameraId) {
        controlsOrbit.enabled = true;
        setCurrentCamera(designViewportCam);

        if (previewViewportPoseRef.current) {
          restoreViewportCameraPose(previewViewportPoseRef.current);
          if (
            previewViewportPoseRef.current.camera &&
            previewViewportPoseRef.current.camera !== designViewportCam
          ) {
            syncViewportCameraSwitch(
              previewViewportPoseRef.current.camera,
              designViewportCam,
              controlsOrbit.target,
              width,
              height
            );
            setCurrentCamera(designViewportCam);
          }
          previewViewportPoseRef.current = null;
        }

        controlsOrbit.autoRotate =
          window_type === 'preview' && previewAutoRotateCamera;
        controlsOrbit.update();
        syncHdriBackgroundForCamera(scene, designViewportCam);
        if (rendererRef.current) {
          rendererRef.current.render(scene, designViewportCam);
        }
        return;
      }

      const entry = previewSceneCameras.find((c) => c.id === cameraId);
      const camProp =
        entry?.camProp ||
        (camera_properties || []).find(
          (c) =>
            getCameraStableId(c) === cameraId ||
            c._id === cameraId ||
            c.id === cameraId ||
            c.temp_file_name === cameraId
        );
      const sceneCam =
        entry?.camera ||
        resolveSceneCameraObject(scene, camProp || { _id: cameraId, id: cameraId });
      if (!isSceneCamera(sceneCam)) return;

      // Prefer authored Redux type — Three object can lag after type changes.
      const typeRaw = String(camProp?.type || entry?.typeLabel || '').toLowerCase();
      const wantOrtho =
        typeRaw === 'orthographic' ||
        typeRaw === 'ortho' ||
        entry?.isOrtho === true ||
        (!typeRaw && !!sceneCam.isOrthographicCamera);

      const viewportCam = wantOrtho ? orthographicCamera : perspectiveCamera;

      // Save design viewport pose once before first scene-camera preview switch.
      if (!previewViewportPoseRef.current) {
        previewViewportPoseRef.current =
          captureViewportCameraPose(designViewportCam);
      }

      // Lock orbit before swapping cameras so update() cannot push a perspective pose.
      controlsOrbit.enabled = false;
      controlsOrbit.autoRotate = false;

      // Copy authored pose onto the matching viewport cam — leave sceneCam untouched.
      sceneCam.updateMatrixWorld?.(true);
      sceneCam.matrixWorld.decompose(
        viewportCam.position,
        viewportCam.quaternion,
        viewportCam.scale
      );
      viewportCam.scale.set(1, 1, 1);
      viewportCam.rotation.setFromQuaternion(
        viewportCam.quaternion,
        viewportCam.rotation.order
      );
      viewportCam.near = sceneCam.near;
      viewportCam.far = sceneCam.far;

      if (wantOrtho) {
        if (sceneCam.isOrthographicCamera) {
          viewportCam.left = sceneCam.left;
          viewportCam.right = sceneCam.right;
          viewportCam.top = sceneCam.top;
          viewportCam.bottom = sceneCam.bottom;
          viewportCam.zoom = sceneCam.zoom ?? 1;
        } else {
          // Redux says Ortho but scene object is still Perspective — build frustum from size.
          const size = Math.max(Number(camProp?.size) || 5, 0.01);
          viewportCam.left = (-size * aspect) / 2;
          viewportCam.right = (size * aspect) / 2;
          viewportCam.top = size / 2;
          viewportCam.bottom = -size / 2;
          viewportCam.zoom = 1;
        }
        viewportCam.far = getOrthoFarForHdriBackground(viewportCam);
      } else if (viewportCam.isPerspectiveCamera) {
        if (sceneCam.isPerspectiveCamera) {
          viewportCam.fov = sceneCam.fov;
        } else if (typeof camProp?.fov === 'number') {
          viewportCam.fov = camProp.fov;
        }
        viewportCam.aspect = aspect;
      }

      viewportCam.updateProjectionMatrix?.();

      // Assign active viewport camera after pose/projection are ready.
      currentCamera = viewportCam;
      camera = viewportCam;
      window.currentCamera = viewportCam;
      window.camera = viewportCam;
      controlsOrbit.object = viewportCam;
      if (transformControls) {
        transformControls.camera = viewportCam;
      }

      syncHdriBackgroundForCamera(scene, viewportCam);

      // Preview look-through bypasses setCurrentCamera — sync particle sizes here.
      {
        const h =
          rendererRef.current?.domElement?.clientHeight ||
          rendererRef.current?.domElement?.height ||
          window.innerHeight;
        syncParticlePointSizesForCamera(scene, viewportCam, h);
      }

      if (rendererRef.current) {
        rendererRef.current.render(scene, viewportCam);
      }
    },
    [
      controlsOrbit,
      perspectiveCamera,
      orthographicCamera,
      cameraType,
      window_type,
      previewAutoRotateCamera,
      previewSceneCameras,
      camera_properties,
      scene,
      captureViewportCameraPose,
      restoreViewportCameraPose,
      transformControls,
    ]
  );

  const raycaster = useRef(new Three.Raycaster());
  const mouse = useRef(new Three.Vector2());
  // const localRendererRef = useRef();
  const directionalLightRef = useRef();

  const { id } = useParams();
  const location = useLocation();
  projectId = id;
  currentProjectName = name;

  const [materialComponentKey, setMaterialComponentKey] = useState(0);
  const [selectedObjectState, setSelectedObjectState] = useState(null);
  const [viewportContextMenu, setViewportContextMenu] = useState(null);
  const [isPivotEditing, setIsPivotEditing] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const [submenuOpen, setSubmenuOpen] = useState('');
  const autoPublishFromTraining = localStorage.getItem(
    'autoPublishFromTraining'
  );

  useEffect(() => {
    if (autoPublishFromTraining) {
      localStorage.removeItem('autoPublishFromTraining');
      Publish(
        setPublished,
        true,
        setName,
        completeObject,
        animationObjects,
        null,
        setCategory,
        setRedirectionCode
      ).finally(() => {
        store.dispatch(setLoadingMessage(false));
        store.dispatch(setLoading(false));
      });
    }
  }, [autoPublishFromTraining]);

  // Enable real-time particle updates when properties change
  useParticleSync(scene, window_type);

  // Enable physics system (only in preview mode)
  const isPreviewMode = window_type === 'preview';
  usePhysics(scene, isPreviewMode);

  useEffect(() => {
    if (!controlsOrbit) return;
    // Scene-camera preview locks orbit; only auto-rotate on the default viewport cam.
    if (previewCameraId) {
      controlsOrbit.autoRotate = false;
      return;
    }
    controlsOrbit.autoRotate =
      window_type === 'preview' && previewAutoRotateCamera;
    controlsOrbit.autoRotateSpeed = 0.5;
  }, [window_type, previewAutoRotateCamera, previewCameraId, controlsOrbit]);

  useEffect(() => {
    if (window_type === 'preview') {
      // Freeze authored camera poses before look-through / matrix locking.
      if (!previewSceneCameraTransformsRef.current) {
        previewSceneCameraTransformsRef.current =
          snapshotSceneCameraTransforms(scene);
      }
      return;
    }

    // Leaving preview: clear framed layout so design is not stretched.
    syncDesignViewportSize();

    setIsPreviewControlsOpen(false);
    if (previewCameraId) {
      setPreviewCameraId(null);
    }
    // Restore viewport pose without touching scene camera assets.
    if (previewViewportPoseRef.current) {
      restoreViewportCameraPose(previewViewportPoseRef.current);
      previewViewportPoseRef.current = null;
    }
    // Re-apply scene camera transforms from enter-preview snapshot.
    // Prefer snapshot over Redux so a stale camera_properties rotation cannot
    // overwrite the authored live pose after look-through.
    if (previewSceneCameraTransformsRef.current) {
      restoreSceneCameraTransforms(
        scene,
        previewSceneCameraTransformsRef.current
      );
      previewSceneCameraTransformsRef.current = null;
    } else {
      syncSceneCamerasFromReduxProperties(scene, camera_properties);
    }
    if (controlsOrbit && perspectiveCamera && orthographicCamera) {
      const viewType = cameraType || 'perspective';
      const viewportCam =
        viewType === 'orthographic' ? orthographicCamera : perspectiveCamera;
      setCurrentCamera(viewportCam);
      controlsOrbit.object = viewportCam;
      controlsOrbit.enabled = true;
      controlsOrbit.autoRotate = false;
    }

    // Helpers must refresh AFTER transforms + viewport size are restored.
    requestAnimationFrame(() => {
      restoreCameraHelpersForDesign();
    });
  }, [window_type]);

  useEffect(() => {
    if (window_type !== 'preview') return;
    applyPreviewViewCamera(previewCameraId);
  }, [previewCameraId, window_type, applyPreviewViewCamera]);

  useEffect(() => {
    // Force re-render of MaterialComponent when selectedObject changes
    setMaterialComponentKey((prevKey) => prevKey + 1);
  }, [selectedObjectState]);

  useEffect(() => {
    setSelectionOutlineEnabled(window_type !== 'preview');
  }, [window_type]);

  useEffect(() => {
    if (window_type === 'preview') {
      clearSelectionOutline();
      return;
    }
    syncSelectionOutlineFromStore();
    transformControls?.refreshSelectionBounds?.();
  }, [
    window_type,
    select_object,
    selectedMeshesForGrouping,
    materialHighlightMeshes,
  ]);

  // Undo/redo: remount property UI so checkboxes, sliders, inputs, dropdowns match restored state.
  useEffect(() => {
    const handleHistoryUiRefresh = () => {
      const selected = store.getState()?.assets_object?.select_object ?? null;
      setSelectedObjectState(selected);
      // Bump twice-safe: always change key even if selection reference is unchanged.
      setMaterialComponentKey((prev) => prev + 1);
    };
    window.addEventListener('gridHistoryUiRefresh', handleHistoryUiRefresh);
    window.addEventListener('gridHistoryRestored', handleHistoryUiRefresh);
    return () => {
      window.removeEventListener(
        'gridHistoryUiRefresh',
        handleHistoryUiRefresh
      );
      window.removeEventListener('gridHistoryRestored', handleHistoryUiRefresh);
    };
  }, []);

  function saveSceneSnapshot() {
    const snapshot = serializeSceneState();
    setLastSavedSceneSnapshot(snapshot);
  }

  let renderer;

  useEffect(() => {
    try {
      // First try with antialias
      renderer = new Three.WebGLRenderer({
        antialias: true,
        powerPreference: 'high-performance',
        failIfMajorPerformanceCaveat: true,
        preserveDrawingBuffer: true,
      });
      rendererRef.current = renderer;
      setRendererState(renderer);
      // Initialize cannon debug renderer attached to the scene
      try {
        cannonDebugRenderer = new CannonDebugRenderer(scene);
      } catch (e) {
        console.warn('Failed to init CannonDebugRenderer', e);
      }
    } catch (error) {
      console.warn('Failed to create WebGL renderer with antialias:', error);
      try {
        // Fallback without antialias
        renderer = new Three.WebGLRenderer({
          antialias: false,
          powerPreference: 'high-performance',
          preserveDrawingBuffer: true,
        });
        rendererRef.current = renderer;
        setRendererState(renderer);
        try {
          cannonDebugRenderer = new CannonDebugRenderer(scene);
        } catch (e) {
          console.warn('Failed to init CannonDebugRenderer', e);
        }
      } catch (fallbackError) {
        console.error('WebGL initialization failed:', fallbackError);
        // Create a div to show error message
        const errorDiv = document.createElement('div');
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '50%';
        errorDiv.style.left = '50%';
        errorDiv.style.transform = 'translate(-50%, -50%)';
        errorDiv.style.padding = '20px';
        errorDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
        errorDiv.style.color = 'white';
        errorDiv.style.borderRadius = '5px';
        errorDiv.style.zIndex = '1000';
        errorDiv.innerHTML = `
        <h2>WebGL Error</h2>
        <p>Unable to initialize WebGL. This may be due to:</p>
        <ul>
          <li>Your browser does not support WebGL</li>
          <li>Your graphics drivers need to be updated</li>
          <li>Hardware acceleration is disabled</li>
        </ul>
        <p>Please try:</p>
        <ul>
          <li>Updating your browser</li>
          <li>Enabling hardware acceleration</li>
          <li>Using a different browser</li>
        </ul>
      `;
        document.body.appendChild(errorDiv);
        return; // Exit the effect if WebGL initialization fails
      }
    }
  }, []);

  const cleanupDebouncedFunctions = () => {
    if (debouncedLightUpdate.cancel) debouncedLightUpdate.cancel();
    if (debouncedParticleUpdate.cancel) debouncedParticleUpdate.cancel();
    if (debouncedGridTransformUpdate.cancel)
      debouncedGridTransformUpdate.cancel();
    // if (debouncedUIUpdate.cancel) debouncedUIUpdate.cancel();
  };

  useEffect(() => {
    console.time('myFunctionTime');
    store.dispatch(setLoading(true));
    scene.background = new Three.Color(0x2d2e32);

    // === Camera Setup ===
    perspectiveCamera = new Three.PerspectiveCamera(
      VIEWPORT_CAMERA_FOV,
      window.innerWidth / window.innerHeight,
      0.01,
      5000
    );
    perspectiveCamera.position.set(0, 2.5, 12);
    perspectiveCamera.lookAt(0, 0, 0);

    orthographicCamera = new Three.OrthographicCamera(
      window.innerWidth / -2,
      window.innerWidth / 2,
      window.innerHeight / 2,
      window.innerHeight / -2,
      0.01,
      5000
    );

    applyViewportCameraDefaults(perspectiveCamera, orthographicCamera);
    orthographicCamera.position.copy(perspectiveCamera.position);
    orthographicCamera.quaternion.copy(perspectiveCamera.quaternion);
    orthographicCamera.zoom = perspectiveToOrthographicZoom(
      perspectiveCamera,
      new Three.Vector3(0, 0, 0),
      window.innerWidth,
      window.innerHeight
    );
    orthographicCamera.updateProjectionMatrix();

    const initialViewType =
      store.getState().assets_object?.cameraType || 'perspective';
    if (initialViewType === 'orthographic') {
      setCurrentCamera(orthographicCamera);
    } else {
      setCurrentCamera(perspectiveCamera);
    }

    // === Renderer Setup ===
    // localRendererRef.current = renderer;
    rendererRef.current = renderer;
    renderer.gammaOutput = true;
    renderer.gammaFactor = 2.2;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = Three.PCFSoftShadowMap;
    renderer.shadowMapSoft = true;
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.autoClear = false;

    initSelectionOutline(rendererRef.current || renderer, scene, currentCamera);

    const gridContainer = document.getElementById('gridContainer');
    if (!gridContainer) return;
    gridContainer.appendChild(renderer.domElement);

    // === Grid + Ground Plane ===
    const gridHelper = new Three.GridHelper(70, 70, 0x4a4a4a, 0x4a4a4a);
    gridHelper.name = 'gridHelper';
    scene.add(gridHelper);
    // === Controls ===
    controlsOrbit = new OrbitControls(currentCamera, renderer.domElement);
    controlsOrbit.enableRotate = true;
    controlsOrbit.enablePan = false;
    controlsOrbit.enableZoom = true;
    controlsOrbit.enableDamping = true;
    controlsOrbit.autoRotate = false;
    controlsOrbit.autoRotateSpeed = 1;
    // controlsOrbit.minPolarAngle = 0.8;
    // controlsOrbit.maxPolarAngle = 2.4;
    controlsOrbit.dampingFactor = 0.07;
    controlsOrbit.rotateSpeed = 0.5;
    controlsOrbit.target.set(0, 0, 0);
    controlsOrbit.update();
    window.controls = controlsOrbit;

    const cameraFreeMotion = createCameraFreeMotion({
      getCamera: () => currentCamera,
      getControls: () => controlsOrbit,
      getDomElement: () => renderer.domElement,
      getScene: () => scene,
      syncViewportCameras: (active) => {
        const sibling =
          active === perspectiveCamera ? orthographicCamera : perspectiveCamera;
        if (sibling && active) {
          sibling.position.copy(active.position);
          sibling.quaternion.copy(active.quaternion);
        }
      },
      getEnabled: () => {
        if (isPublishing) return false;
        if (transformControls?.dragging) return false;
        const windowType = store.getState()?.window?.window_type;
        return windowType !== 'preview';
      },
      moveSpeed: 3.5,
      acceleration: 3.2,
      deceleration: 8,
      lookRotateSpeed: 3.2,
    });

    transformControls = new TransformControls(
      currentCamera,
      renderer.domElement
    );
    disableTransformControlsShadows(transformControls);
    registerOutlineUiLayerObjects(transformControls);
    registerOutlineTransformControls(transformControls);
    setMultiSelectionContext({ scene, transformControls });
    if (window_type == 'design') {
      transformControls.name = 'transformControls';
      scene.add(transformControls);
      // Ensure transform controls camera is properly set
      transformControls.camera = currentCamera;
      transformControls.addEventListener('mouseDown', () => {
        controlsOrbit.enabled = false;
      });
      transformControls.addEventListener('mouseUp', () => {
        controlsOrbit.enabled = true;
      });
      transformControls.draggingDampingFactor = 1;

      // Debounced UI update with error handling
      const debouncedUIUpdate = debounce((object) => {
        try {
          UpdateUI(object, cachedUIElements);
          if (renderer && scene && currentCamera) {
            renderViewportWithSelectionOutline(renderer, scene, currentCamera);
          }
        } catch (error) {
          console.error('UI update error:', error);
        }
      }, 16); // ~60fps

      // Cleanup function for debounced functions

      // Add error handling to transform controls events
      transformControls.addEventListener('objectChange', () => {
        if (store.getState()?.window?.window_type === 'preview') return;
        if (selectedObject) {
          try {
            // Use requestAnimationFrame for smooth UI updates
            requestAnimationFrame(() => {
              debouncedUIUpdate(selectedObject);
            });

            // --- Redux sync for lights ---
            const isLight =
              selectedObject.type === 'DirectionalLight' ||
              selectedObject.type === 'PointLight' ||
              selectedObject.type === 'SpotLight' ||
              selectedObject.type === 'AmbientLight' ||
              selectedObject.type === 'RectAreaLight';

            const isLightHelper =
              selectedObject.type === 'DirectionalLightHelper' ||
              selectedObject.type === 'PointLightHelper' ||
              selectedObject.type === 'SpotLightHelper' ||
              selectedObject.type === 'AreaLightHelper' ||
              selectedObject.type === 'AmbientLightHelper';

            if (isLight || isLightHelper) {
              // For light helpers, find the actual light object to get properties
              let actualLight = selectedObject;
              if (isLightHelper) {
                // Extract light ID from helper name (format: "lightId-helper")
                const lightId = selectedObject.name.replace('-helper', '');
                actualLight = scene.getObjectByName(lightId);
                if (!actualLight) {
                  console.warn(
                    'Could not find actual light for helper:',
                    selectedObject.name
                  );
                  return;
                }

                // Sync the helper's transform to the actual light
                actualLight.position.copy(selectedObject.position);
                actualLight.rotation.copy(selectedObject.rotation);
                // actualLight.scale.copy(selectedObject.scale);

                // Update the helper to reflect the light's current state
                if (typeof selectedObject.update === 'function') {
                  selectedObject.update();
                }
              }

              // Find the light in Redux by id (usually name)
              const lightId = actualLight.name;
              // Build updated light data
              // when an area light or its helper is scaled, treat the scale factor as
              // a direct adjustment to width/height and then reset the scale to avoid
              // exponential growth. The transform control may act on the helper or the
              // light itself depending on what the user clicked.
              if (actualLight.type === 'RectAreaLight') {
                const mode =
                  transformControls.getMode && transformControls.getMode();
                if (mode === 'scale') {
                  // scale may be on helper or light; check selectedObject
                  const factorX = selectedObject.scale.x;
                  const factorY = selectedObject.scale.y;
                  if (
                    (factorX && factorX !== 1) ||
                    (factorY && factorY !== 1)
                  ) {
                    const newWidth = (actualLight.width || 1) * factorX;
                    const newHeight = (actualLight.height || 1) * factorY;
                    actualLight.width = newWidth;
                    actualLight.height = newHeight;
                    // also adjust helper geometry immediately if it's a mesh
                    if (actualLight.helper) {
                      actualLight.helper.geometry.dispose();
                      actualLight.helper.geometry = new THREE.PlaneGeometry(
                        newWidth,
                        newHeight
                      );
                      actualLight.helper.userData.width = newWidth;
                      actualLight.helper.userData.height = newHeight;
                    }
                    // reset scales so further transforms are relative to new dims
                    actualLight.scale.set(1, 1, 1);
                    selectedObject.scale.set(1, 1, 1);
                  }
                }
              }

              const updatedLight = {
                id: lightId,
                type: actualLight.type,
                position: {
                  x: actualLight.position.x,
                  y: actualLight.position.y,
                  z: actualLight.position.z,
                },
                rotation: {
                  x: actualLight.rotation.x,
                  y: actualLight.rotation.y,
                  z: actualLight.rotation.z,
                },
                // scale: {
                //   x: actualLight.scale.x,
                //   y: actualLight.scale.y,
                //   z: actualLight.scale.z,
                // },
                color: actualLight.color
                  ? typeof actualLight.color.getHexString === 'function'
                    ? '#' + actualLight.color.getHexString()
                    : actualLight.color
                  : undefined,
                intensity: actualLight.intensity,
                // include dims for area lights
                ...(actualLight.type === 'RectAreaLight'
                  ? {
                      width: actualLight.width,
                      height: actualLight.height,
                    }
                  : {}),
                // Add other properties as needed
              };
              debouncedLightUpdate(updatedLight);
              syncLightHelperForSceneObject(scene, actualLight);
            }

            // --- Redux sync for particles - use debounced version ---
            if (
              selectedObject.deleteType === 'particle' &&
              selectedObject.name
            ) {
              debouncedParticleUpdate(
                {
                  position: {
                    x: selectedObject.position.x,
                    y: selectedObject.position.y,
                    z: selectedObject.position.z,
                  },
                  rotation: {
                    x: selectedObject.rotation.x,
                    y: selectedObject.rotation.y,
                    z: selectedObject.rotation.z,
                  },
                  scale: {
                    x: selectedObject.scale.x,
                    y: selectedObject.scale.y,
                    z: selectedObject.scale.z,
                  },
                },
                selectedObject
              );
            } else if (
              ['hotspot', 'mesh', 'image', 'video', 'audio', 'text'].includes(
                selectedObject.deleteType
              )
            ) {
              debouncedGridTransformUpdate(selectedObject);
            }

            // Child lights inherit parent transform; helpers/icons stay on scene root.
            if (!isLight && !isLightHelper) {
              syncDescendantLightHelpers(selectedObject, scene);
            }

            // --- Update camera point + Redux when a scene camera is moved ---
            if (isSceneCamera(selectedObject)) {
              const cameraId = getCameraLookupId(selectedObject);
              const cameraPoint = scene.getObjectByName(
                `${selectedObject.name}Point`
              );
              if (cameraPoint) {
                cameraPoint.position.copy(selectedObject.position);
              }
              if (cameraId) {
                store.dispatch(
                  cameraPropertiesUpdate({
                    _id: cameraId,
                    id: cameraId,
                    position: {
                      x: selectedObject.position.x,
                      y: selectedObject.position.y,
                      z: selectedObject.position.z,
                    },
                    rotation: {
                      x: selectedObject.rotation.x,
                      y: selectedObject.rotation.y,
                      z: selectedObject.rotation.z,
                    },
                  })
                );
              }
            } else if (selectedObject.name === 'DemoCamera') {
              const cameraPoint = scene.getObjectByName('DemoCameraPoint');
              if (cameraPoint) {
                cameraPoint.position.copy(selectedObject.position);
              }
            }
          } catch (error) {
            console.error('Transform controls objectChange error:', error);
          }
        }
      });

      // Add error handling to mouse events
      transformControls.addEventListener('mouseDown', () => {
        try {
          controlsOrbit.enabled = false;
        } catch (error) {
          console.error('Transform controls mouseDown error:', error);
        }
      });

      transformControls.addEventListener('mouseUp', () => {
        try {
          controlsOrbit.enabled = true;
        } catch (error) {
          console.error('Transform controls mouseUp error:', error);
        }
      });
    }

    transformControls.setMode('rotate');

    // Key handler: press 'F' to focus on selected object
    const keyDownHandler = (e) => {
      if (isPublishing) return;
      try {
        // Disable all shortcuts in preview mode
        const currentWindowType = store.getState()?.window?.window_type;
        if (currentWindowType === 'preview') return;

        // ═══════ ESCAPE KEY: exit child-selection mode → only parents selectable again ═══════
        if (e.key === 'Escape') {
          if (activeParentForChildSelection) {
            const parent = activeParentForChildSelection;
            setChildSelectionMode(null);
            if (parent && scene.getObjectByName(parent.name)) {
              selectedObject = parent;
              setSelectedObjectState(parent);
              store.dispatch(selected_object(parent));
              if (transformControls) {
                transformControls.attach(parent);
              }
              UpdateUI(parent, cachedUIElements);
            }
          }
          return;
        }

        if (
          (e.key === 'f' || e.key === 'F') &&
          !e.ctrlKey &&
          !e.shiftKey &&
          !e.altKey &&
          !e.metaKey
        ) {
          if (selectedObject) {
            focusCameraOnObject(selectedObject);
          } else {
            notify('No object selected.');
          }
        } else if (
          (e.key === 'r' || e.key === 'R') &&
          !e.shiftKey &&
          !e.ctrlKey &&
          !e.altKey &&
          !e.metaKey
        ) {
          try {
            if (controlsOrbit) {
              controlsOrbit.target.set(0, 0, 0);
              if (currentCamera && typeof currentCamera.lookAt === 'function') {
                currentCamera.lookAt(0, 0, 0);
                currentCamera.position.set(0, 2.5, 12);
              }
              controlsOrbit.update && controlsOrbit.update();
              rendererRef.current &&
                rendererRef.current.render(scene, currentCamera);
            }
          } catch (ee) {
            console.warn('Escape key handler error', ee);
          }
        }
      } catch (err) {
        console.warn('keydown handler error', err);
      }
    };
    window.addEventListener('keydown', keyDownHandler);

    // Suppose you pass isAnimationMinimized as prop
    helperRenderer = new Three.WebGLRenderer({ alpha: true });
    helperRenderer.outputColorSpace = Three.LinearSRGBColorSpace;

    // 👇 conditional size
    if (isAnimationMinimized) {
      helperRenderer.setSize(80, 80); // big version
    } else {
      helperRenderer.setSize(50, 50); // smaller version
    }

    document
      .getElementById('viewHelper')
      ?.appendChild(helperRenderer.domElement);

    helper = new ViewHelper(camera, helperRenderer.domElement);
    helper.controls = controlsOrbit;
    helper.controls.center = controlsOrbit.target;
    helper.position.set(0.6, -0.6, 0);

    // 👇 conditional scale
    if (isAnimationMinimized) {
      helper.scale.set(0.6, 0.6, 0.6); // bigger
      // helper.position.set(0.48, -0.48, 0);
    } else {
      helper.scale.set(0.35, 0.35, 0.35); // smaller
    }

    function getSpriteMaterial(colorHex) {
      return getSpriteMaterialForViewHelper(colorHex);
    }

    let prevTransform = null;

    transformControls.addEventListener('dragging-changed', (event) => {
      if (event.value) {
        beginGridHistoryEdit();
        if (selectedObject) {
          prevTransform = {
            position: selectedObject.position.clone(),
            rotation: selectedObject.rotation.clone(),
            scale: selectedObject.scale.clone(),
          };
        }
      } else {
        if (selectedObject && prevTransform) {
          const moved =
            !prevTransform.position.equals(selectedObject.position) ||
            prevTransform.rotation.x !== selectedObject.rotation.x ||
            prevTransform.rotation.y !== selectedObject.rotation.y ||
            prevTransform.rotation.z !== selectedObject.rotation.z ||
            !prevTransform.scale.equals(selectedObject.scale);

          if (moved) {
            applyGridTransformUpdate(selectedObject);
            flushGridHistoryEdit('transform');
          } else {
            cancelPendingGridHistoryCommit();
          }

          prevTransform = null;
        }
      }
    });

    const spriteMaterials = {
      posX: getSpriteMaterial('#f9535d'), // red
      posY: getSpriteMaterial('#29ffcd'), // green
      posZ: getSpriteMaterial('#348ccb'), // blue
      default: getSpriteMaterial('#404040'), // gray
    };

    // Update ViewHelper visuals using the global styling function
    window.applyViewHelperStyling(helper);

    document
      .getElementById('viewHelper')
      ?.addEventListener('pointerup', (e) => helper.handleClick(e));

    // === Raycaster Mouse Events ===
    const handleMouseDown = createGridViewportMouseDownHandler({
      getIsPublishing: () => isPublishing,
      getIsTransformActive: () => isTransformActive,
      renderer,
      mouse,
      raycaster,
      camera,
      scene,
      transformControls,
      getSelectedObject: () => selectedObject,
      setSelectedObject: (obj) => {
        selectedObject = obj;
      },
      setSelectedObjectState,
      selectObjectInScene,
      UpdateUI,
      cachedUIElements,
      showCameraHelper,
      syncCameraHelperVisibility: syncCameraHelperVisibilityFromStore,
      currentCamera,
      globalShowLightHelpers,
      getActiveParentForChildSelection: () => activeParentForChildSelection,
      getVideoPlaying: () => videoPlaying,
      setVideoPlaying: (value) => {
        videoPlaying = value;
      },
      video,
    });

    renderer.domElement.addEventListener('pointerdown', handleMouseDown, false);
    renderer.domElement.addEventListener('pointerup', () => {
      isTransformActive = false;
    });

    const handleViewportContextMenu = (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (store.getState()?.window?.window_type === 'preview') return;
      if (isPublishing) return;
      if (hasActivePivotSession()) return;

      const rect = renderer.domElement.getBoundingClientRect();
      mouse.current.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      mouse.current.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

      const allObjects = [
        ...store.getState().assets_object.allIntersectedObjects,
      ];
      const picked = pickViewportObject({
        mouse: mouse.current,
        raycaster: raycaster.current,
        camera: currentCamera || camera,
        allObjects,
        scene,
      });

      let resolved = picked
        ? resolveEditorSelectableObject(
            picked,
            scene,
            activeParentForChildSelection
          ) || picked
        : null;

      // Right-click with a selection: allow Edit Pivot even if the ray misses.
      if (!resolved && selectedObject && canEditPivot(selectedObject)) {
        resolved = selectedObject;
      }

      if (!resolved || !canEditPivot(resolved)) {
        setViewportContextMenu(null);
        return;
      }

      selectedObject = resolved;
      setSelectedObjectState(resolved);
      selectObjectInScene?.(resolved);
      UpdateUI?.(resolved, cachedUIElements);
      try {
        transformControls?.attach?.(resolved);
      } catch (_) {
        /* ignore */
      }

      setViewportContextMenu({
        x: event.clientX,
        y: event.clientY,
        object: resolved,
      });
    };

    renderer.domElement.addEventListener(
      'contextmenu',
      handleViewportContextMenu,
      false
    );

    try {
      renderer.domElement.style.touchAction = 'none';
    } catch (_) {
      /* ignore */
    }

    enableDragDrop(
      scene,
      camera,
      renderer,
      transformControls,
      store,
      DRACOLoader,
      GLTFLoader
    );

    // Expose selectObjectInScene to window for scene-to-panel sync
    // This allows Drag-Drop.js to call it when objects are clicked in the scene
    window.__selectObjectInScene = selectObjectInScene;
    onPrimarySelectionChanged = setSelectedObjectState;
    window.__selectAllObjects = () =>
      selectAllObjects({
        scene,
        transformControls,
        onPrimarySelected: setSelectedObjectState,
        syncLocalSelection: (primary) => {
          selectedObject = primary;
          UpdateUI(primary, cachedUIElements);
        },
      });

    // === Resize Handler ===
    const handleResize = () => {
      try {
        const winState = store.getState()?.window;
        const isPreview = winState?.window_type === 'preview';
        const container = document.getElementById('gridContainer');
        let width = window.innerWidth;
        let height = window.innerHeight;

        if (isPreview) {
          if (winState.preview_type === 'default') {
            width = window.innerWidth;
            height = window.innerHeight;
            try {
              updatePreviewDimention({ width, height });
            } catch (_) {}
            store.dispatch(update_full_window_size({ width, height }));
          } else if (container?.clientWidth && container?.clientHeight) {
            // Framed Mobile/Tab: match the visible preview frame
            width = container.clientWidth;
            height = container.clientHeight;
          } else if (
            winState.window_size?.width &&
            winState.window_size?.height
          ) {
            width = Number(winState.window_size.width) || width;
            height = Number(winState.window_size.height) || height;
          }
        }

        if (!currentCamera || !width || !height) return;

        try {
          if (currentCamera instanceof Three.PerspectiveCamera) {
            currentCamera.aspect = width / height;
          } else if (currentCamera instanceof Three.OrthographicCamera) {
            // During scene-camera look-through, keep the asset frustum — do not
            // replace it with canvas-pixel bounds (that looks like perspective).
            if (!previewCameraIdRef.current) {
              updateOrthographicFrustum(currentCamera, width, height);
            }
          }

          if (typeof currentCamera.updateProjectionMatrix === 'function') {
            currentCamera.updateProjectionMatrix();
          }
        } catch (cameraError) {
          console.warn('Camera update error on resize:', cameraError);
        }

        // Update transform controls camera reference on resize
        try {
          if (transformControls && currentCamera) {
            transformControls.camera = currentCamera;
          }
        } catch (controlsError) {
          console.warn(
            'Transform controls update error on resize:',
            controlsError
          );
        }

        // Keep drawing-buffer size and CSS size in sync — never stretch via 100%.
        try {
          if (renderer && typeof renderer.setSize === 'function') {
            renderer.setSize(width, height);
          }
          resizeSelectionOutline(width, height);
        } catch (rendererSizeError) {
          console.warn('Renderer setSize error:', rendererSizeError);
        }

        // Re-render scene
        try {
          if (renderer && scene && currentCamera) {
            renderViewportWithSelectionOutline(renderer, scene, currentCamera);
          }
        } catch (renderError) {
          console.warn('Render error on resize:', renderError);
        }

        if (isPreview) {
          try {
            const hotspots =
              store.getState()?.assets_object?.sceneHotspots || [];
            refreshHotspotMessageLayouts(hotspots, renderer);
          } catch (_) {}
        }
      } catch (error) {
        console.error('Resize handler error:', error);
      }
    };

    window.addEventListener('resize', handleResize);
    // === Animation Loop ===
    const clock = new Three.Clock();
    let animationId = null; // Track animation frame ID
    let isAnimating = true; // Flag to control animation loop
    let frameCount = 0; // Track frames for periodic cleanup
    let errorCount = 0; // Track consecutive errors
    const MAX_ERRORS = 10; // Stop after 10 consecutive errors
    let lastMixerWarnTime = 0;
    let lastLoopWarnTime = 0;
    let lastParticleOrthoZoom = null;
    const MIXER_WARN_THROTTLE_MS = 5000;
    const LOOP_WARN_THROTTLE_MS = 3000;

    // // Initialize Stats for FPS display
    // const stats = new Stats();
    // // Position stats on the left side of AppRightSection
    // stats.dom.style.position = 'fixed';
    // stats.dom.style.left = '80%';
    // stats.dom.style.top = '1%';
    // stats.dom.style.zIndex = '9999';
    // document.body.appendChild(stats.dom);

    const animate = () => {
      // Stop animation if flag is false or too many errors
      if (!isAnimating || errorCount >= MAX_ERRORS) {
        if (errorCount >= MAX_ERRORS) {
          console.error('Animation stopped due to too many errors');
        }
        return;
      }

      // Request next frame
      animationId = requestAnimationFrame(animate);

      try {
        const delta = clock.getDelta();

        // // Update stats
        // stats.update();

        // animationId = requestAnimationFrame(animate);

        if (helper?.animating) helper.update(delta);
        if (mixer) mixer.update(delta);
        cameraFreeMotion?.apply(delta);
        if (controlsOrbit && !previewCameraIdRef.current) {
          controlsOrbit.update();
        }

        // Keep particle point sizes correct while orthographic zoom/frustum changes
        // and after particle create/update marks materials dirty.
        if (scene && currentCamera) {
          const h =
            renderer?.domElement?.clientHeight ||
            renderer?.domElement?.height ||
            1;
          const zoomKey = currentCamera.isOrthographicCamera
            ? `${currentCamera.zoom}:${currentCamera.top}:${currentCamera.bottom}:${h}`
            : 'persp';
          const dirty = !!window.__particleOrthoSyncDirty;
          if (zoomKey !== lastParticleOrthoZoom || dirty) {
            lastParticleOrthoZoom = zoomKey;
            window.__particleOrthoSyncDirty = false;
            syncParticlePointSizesForCamera(scene, currentCamera, h);
          }
        }

        // Update cannon debug visuals if present
        try {
          if (cannonDebugRenderer) cannonDebugRenderer.update();
        } catch (e) {
          /* ignore */
        }

        // Update Gaussian splats viewer
        // updateSplatViewer();

        // Only update raycaster if mouse position is valid
        if (mouse.current && camera) {
          raycaster.current.setFromCamera(mouse.current, camera);
        }

        // Removed per-frame raycaster update to reduce CPU load

        // Update helper safely
        try {
          if (
            helper &&
            typeof helper.animating !== 'undefined' &&
            helper.animating &&
            typeof helper.update === 'function'
          ) {
            helper.update(delta);
          }
        } catch (e) {
          if (Date.now() - lastLoopWarnTime > LOOP_WARN_THROTTLE_MS) {
            lastLoopWarnTime = Date.now();
            console.warn('Helper update error:', e);
          }
        }

        // Update mixer safely
        try {
          if (mixer && typeof mixer.update === 'function') {
            mixer.update(delta);
          }
        } catch (e) {
          if (Date.now() - lastLoopWarnTime > LOOP_WARN_THROTTLE_MS) {
            lastLoopWarnTime = Date.now();
            console.warn('Mixer update error:', e);
          }
        }

        // Update orbit controls safely
        try {
          if (
            controlsOrbit &&
            typeof controlsOrbit.update === 'function' &&
            // Freeze camera during scene-camera look-through.
            !previewCameraIdRef.current
          ) {
            controlsOrbit.update();
          }
        } catch (e) {
          if (Date.now() - lastLoopWarnTime > LOOP_WARN_THROTTLE_MS) {
            lastLoopWarnTime = Date.now();
            console.warn('Controls update error:', e);
          }
        }

        // Apply Redux animations safely (skip in preview — event-driven playback handles GLB)
        try {
          const currentWindowType = store.getState()?.window?.window_type;
          const timelinePlaybackActive =
            window.__timelinePlaybackActive === true;
          if (
            currentWindowType !== 'preview' &&
            !timelinePlaybackActive &&
            scene &&
            animationObjects &&
            typeof applyAnimationsToSceneObjects === 'function'
          ) {
            applyAnimationsToSceneObjects(
              scene,
              animationObjects,
              clock?.getElapsedTime() || 0
            );

            animationObjects.forEach((animObj) => {
              const sceneObj = scene.getObjectByName(
                animObj.name || animObj.id
              );
              if (sceneObj?.isLight) {
                syncLightHelperForSceneObject(scene, sceneObj);
              }
            });
          }
        } catch (e) {
          if (Date.now() - lastLoopWarnTime > LOOP_WARN_THROTTLE_MS) {
            lastLoopWarnTime = Date.now();
            console.warn('Animation objects update error:', e);
          }
        }

        // Ensure transform controls gizmo follows animated objects
        try {
          if (transformControls && transformControls.object) {
            transformControls.updateMatrixWorld();
          }
        } catch (e) {
          /* ignore */
        }

        // Update raycaster safely
        try {
          if (
            mouse?.current &&
            camera &&
            raycaster?.current &&
            typeof raycaster.current.setFromCamera === 'function'
          ) {
            raycaster.current.setFromCamera(mouse.current, camera);
          }
        } catch (e) {
          if (Date.now() - lastLoopWarnTime > LOOP_WARN_THROTTLE_MS) {
            lastLoopWarnTime = Date.now();
            console.warn('Raycaster update error:', e);
          }
        }

        // Update GLB mixers only when timeline/event playback marked them active
        try {
          scene.traverse((obj) => {
            if (
              obj &&
              obj.userData &&
              obj.userData.isGlbPlaying &&
              obj.userData.mixer &&
              typeof obj.userData.mixer.update === 'function'
            ) {
              try {
                obj.userData.mixer.update(delta);
              } catch (mErr) {
                const now = Date.now();
                if (now - lastMixerWarnTime > MIXER_WARN_THROTTLE_MS) {
                  lastMixerWarnTime = now;
                  console.warn(
                    'Per-object mixer update failed for',
                    obj.name,
                    mErr
                  );
                }
              }
            }
          });
        } catch (e) {
          const now = Date.now();
          if (now - lastMixerWarnTime > MIXER_WARN_THROTTLE_MS) {
            lastMixerWarnTime = now;
            console.warn('Failed to update per-object mixers', e);
          }
        }

        // Periodic cleanup of invalid materials
        try {
          frameCount++;
          if (
            frameCount % 300 === 0 &&
            scene &&
            typeof cleanupInvalidMaterials === 'function'
          ) {
            const cleaned = cleanupInvalidMaterials(scene);
          }
        } catch (e) {
          if (Date.now() - lastLoopWarnTime > LOOP_WARN_THROTTLE_MS) {
            lastLoopWarnTime = Date.now();
            console.warn('Periodic cleanup error:', e);
          }
        }

        // Render scene safely
        try {
          if (renderer && scene && currentCamera) {
            renderViewportWithSelectionOutline(renderer, scene, currentCamera);

            // Ensure transform controls camera is updated
            if (
              transformControls &&
              transformControls.camera !== currentCamera
            ) {
              transformControls.camera = currentCamera;
            }
          }
        } catch (e) {
          console.error('Renderer error:', e);
          // Emergency cleanup on render error
          try {
            if (scene && typeof cleanupInvalidMaterials === 'function') {
              const cleaned = cleanupInvalidMaterials(scene);
            }
          } catch (cleanupError) {
            console.error('Emergency cleanup failed:', cleanupError);
          }
        }

        // Render helper safely
        try {
          if (helper && helperRenderer && typeof helper.render === 'function') {
            helper.render(helperRenderer);
          }
        } catch (e) {
          if (Date.now() - lastLoopWarnTime > LOOP_WARN_THROTTLE_MS) {
            lastLoopWarnTime = Date.now();
            console.warn('Helper render error:', e);
          }
        }

        // Reset error count on successful frame
        errorCount = 0;
      } catch (error) {
        errorCount++;
        console.error(
          `Animation loop error (${errorCount}/${MAX_ERRORS}):`,
          error
        );

        // Try emergency cleanup on critical error
        try {
          if (scene && typeof cleanupInvalidMaterials === 'function') {
            const cleaned = cleanupInvalidMaterials(scene);
          }
        } catch (cleanupError) {
          console.error('Cleanup failed:', cleanupError);
        }
      }
    };

    // Start animation loop
    animate();

    // Function to stop animation loop
    const stopAnimation = () => {
      isAnimating = false;
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
    };

    // Function to restart animation loop

    CancelBtnImage();
    CancelBtnVideo();
    CancelBtnModel();

    return () => {
      // Stop animation loop first
      stopAnimation();

      // // Cleanup Stats DOM
      // try {
      //   if (stats && stats.dom && stats.dom.parentNode) {
      //     stats.dom.parentNode.removeChild(stats.dom);
      //   }
      // } catch (error) {
      //   console.error('Stats cleanup error:', error);
      // }

      // Cleanup debounced functions
      try {
        cleanupDebouncedFunctions();
      } catch (error) {
        console.error('Debounced functions cleanup error:', error);
      }

      // === Cleanup ===
      disposeSelectionOutline();
      try {
        cancelPivotEdit();
      } catch (_) {
        /* ignore */
      }
      if (renderer?.domElement) {
        try {
          renderer.domElement.removeEventListener(
            'pointerdown',
            handleMouseDown,
            false
          );
          renderer.domElement.removeEventListener(
            'contextmenu',
            handleViewportContextMenu,
            false
          );
        } catch (_) {
          /* ignore */
        }
      }
      if (renderer) {
        try {
          renderer.dispose(); // Dispose of the renderer
          renderer.forceContextLoss(); // Force context loss
          renderer.domElement.remove(); // Remove the canvas
          renderer = null; // Clear the reference
        } catch (error) {
          console.error('Renderer cleanup error:', error);
        }
      }

      // Cleanup transform controls
      if (transformControls) {
        try {
          transformControls?.dispose();
          transformControls = null;
        } catch (error) {
          console.error('Transform controls cleanup error:', error);
        }
      }

      // Cleanup orbit controls
      if (controlsOrbit) {
        try {
          controlsOrbit.dispose();
          controlsOrbit = null;
        } catch (error) {
          console.error('Orbit controls cleanup error:', error);
        }
      }

      globalShowCameraHelper = null;
      globalShowLightHelpers = null;
      onPrimarySelectionChanged = null;

      // Cleanup scene objects
      if (scene) {
        try {
          scene.traverse((obj) => {
            if (obj.geometry) obj.geometry.dispose();
            if (obj.material) {
              if (Array.isArray(obj.material))
                obj.material.forEach((m) => m.dispose());
              else obj.material.dispose();
            }
          });
        } catch (error) {
          console.error('Scene cleanup error:', error);
        }
      }

      // Clear any remaining WebGL contexts
      try {
        const canvas = document.querySelector('canvas');
        if (canvas) {
          const gl =
            canvas.getContext('webgl') ||
            canvas.getContext('experimental-webgl');
          if (gl) {
            gl.getExtension('WEBGL_lose_context')?.loseContext();
          }
        }
      } catch (error) {
        console.error('WebGL context cleanup error:', error);
      }

      // Remove key handler added for focusing
      try {
        window.removeEventListener('keydown', keyDownHandler);
      } catch (e) {
        // ignore if handler not present
      }

      try {
        cameraFreeMotion?.dispose();
      } catch (e) {
        // ignore
      }

      window.removeEventListener('resize', () => {});
    };
  }, []);

  useEffect(() => {
    // Viewport camera only — scene camera type lives in camera_properties per _id
    if (!perspectiveCamera || !orthographicCamera || !controlsOrbit) return;
    // Don't override an active preview scene-camera view.
    if (window_type === 'preview' && previewCameraId) return;

    const viewType = cameraType || 'perspective';
    const toCamera =
      viewType === 'orthographic' ? orthographicCamera : perspectiveCamera;
    const fromCamera = currentCamera;

    if (fromCamera && fromCamera !== toCamera) {
      syncViewportCameraSwitch(
        fromCamera,
        toCamera,
        controlsOrbit.target,
        window.innerWidth,
        window.innerHeight
      );
    }
    setCurrentCamera(toCamera);
  }, [
    cameraType,
    perspectiveCamera,
    orthographicCamera,
    window_type,
    previewCameraId,
  ]);

  // Hide all light helpers and clear transform controls when window type changes to preview
  useEffect(() => {
    if (window_type === 'design' && globalShowLightHelpers) {
      // --- Synchronize scene lights with Redux light_data ---
      const state = store.getState();
      const { light_data } = state.assets_object;

      if (Array.isArray(light_data)) {
        light_data.forEach((light) => {
          const sceneLight = scene.getObjectByName(light.name);

          if (sceneLight) {
            // Update position, rotation, scale, color, intensity, etc.
            if (light.position)
              sceneLight.position.set(
                light.position.x,
                light.position.y,
                light.position.z
              );
            if (light.rotation)
              sceneLight.rotation.set(
                light.rotation.x,
                light.rotation.y,
                light.rotation.z
              );
            // if (light.scale)
            //   sceneLight.scale.set(light.scale.x, light.scale.y, light.scale.z);
            if (sceneLight.color && light.color)
              sceneLight.color.set(light.color);
            if (typeof light.intensity !== 'undefined')
              sceneLight.intensity = light.intensity;
            // Add more properties as needed
          }
          // Update the helper as well
          const helper = scene.getObjectByName(light.id + '-helper');
          if (helper && typeof helper.update === 'function') {
            helper.update();
          }
        });
      }
      globalShowLightHelpers();
    }

    if (window_type === 'design') {
      restoreCameraHelpersForDesign();
    }

    // Re-add transform controls to scene when switching back to design (always, so picker is available)
    if (
      window_type === 'design' &&
      transformControls &&
      scene &&
      !scene.children.includes(transformControls)
    ) {
      transformControls.detach();
      transformControls.name = 'transformControls';
      scene.add(transformControls);
    }

    // When switching to preview: always clear transform controls and selection so picker/gizmo is hidden
    if (window_type !== 'design') {
      const selected = store.getState()?.assets_object?.select_object;
      if (isSceneCamera(selected)) {
        lastDesignSelectedCameraIdRef.current = selected.name;
      } else if (isSceneCameraPoint(selected)) {
        const sceneCam = resolveSceneCameraFromPoint(scene, selected);
        lastDesignSelectedCameraIdRef.current = sceneCam?.name ?? null;
      } else {
        lastDesignSelectedCameraIdRef.current = null;
      }

      if (globalShowCameraHelper) {
        globalShowCameraHelper(false);
      }
      if (transformControls && typeof transformControls.detach === 'function') {
        transformControls.detach();
        if (scene && transformControls.parent === scene) {
          scene.remove(transformControls);
        }
      }
      selectedObject = null;
      store.dispatch(selected_object(null));
      setSelectedObjectState(null);
    } else if (transformControls) {
      transformControls.enabled = true;
    }

    if (window_type !== 'design' && globalShowLightHelpers) {
      globalShowLightHelpers(true);

      // Also remove all light helpers from scene when switching to preview
      if (scene) {
        const state = store.getState();
        const { light_data } = state.assets_object;

        if (Array.isArray(light_data)) {
          light_data.forEach((light) => {
            const helper = scene.getObjectByName(light.id + '-helper');
            if (helper) {
              scene.remove(helper);
            }
          });
        }
      }
    }
  }, [window_type]);

  // Hotspot billboard: always on for scale; face camera only in preview
  useEffect(() => {
    const renderer = rendererRef?.current ?? null;
    const isPreview = window_type === 'preview';
    if (isPreview) {
      try {
        syncHotspotsForPreviewMode(
          sceneHotspots || [],
          currentCamera || camera,
          renderer
        );
      } catch (_) {}
      return;
    }
    (sceneHotspots || []).forEach((hp) => {
      try {
        setHotspotBillboardEnabled(hp, true, renderer, false);
      } catch (_) {}
    });
  }, [window_type, sceneHotspots, preview_type, window_size]);

  // Rebuild message cards when preview frame size / mode changes (and restore on design)
  useEffect(() => {
    const renderer = rendererRef?.current ?? null;
    try {
      refreshHotspotMessageLayouts(sceneHotspots || [], renderer);
    } catch (_) {}
  }, [
    window_type,
    preview_type,
    window_size?.width,
    window_size?.height,
    sceneHotspots,
  ]);

  // Browser responsive: keep Default Preview + hotspot cards in sync with the window.
  useEffect(() => {
    if (window_type !== 'preview') return undefined;

    let resizeTimer = null;
    const syncBrowserPreviewAndHotspots = () => {
      const renderer = rendererRef?.current ?? null;
      const winState = store.getState()?.window;
      const previewType = winState?.preview_type || 'default';

      if (previewType === 'default') {
        const data = {
          width: window.innerWidth,
          height: window.innerHeight,
        };
        try {
          updatePreviewDimention(data);
        } catch (_) {}
        store.dispatch(update_full_window_size(data));
      }

      try {
        refreshHotspotMessageLayouts(sceneHotspots || [], renderer);
      } catch (_) {}
      (sceneHotspots || []).forEach((hp) => {
        try {
          setHotspotBillboardEnabled(hp, true, renderer, true);
        } catch (_) {}
      });
    };

    const onWindowResize = () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncBrowserPreviewAndHotspots, 100);
    };

    window.addEventListener('resize', onWindowResize);

    const container = document.getElementById('gridContainer');
    let observer = null;
    if (container && typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(() => {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const renderer = rendererRef?.current ?? null;
          try {
            refreshHotspotMessageLayouts(sceneHotspots || [], renderer);
          } catch (_) {}
          (sceneHotspots || []).forEach((hp) => {
            try {
              setHotspotBillboardEnabled(hp, true, renderer, true);
            } catch (_) {}
          });
        }, 80);
      });
      observer.observe(container);
    }

    return () => {
      window.removeEventListener('resize', onWindowResize);
      if (resizeTimer) clearTimeout(resizeTimer);
      observer?.disconnect?.();
    };
  }, [window_type, preview_type, sceneHotspots]);

  useEffect(() => {
    setPolyCounttoshow(getPolyCount(scene));
  }, [polyCount, scene]);

  useEffect(() => {
    const canvas = document.querySelector('canvas');
    // canvas.style.height = (!isAnimationMinimized&&window_type==='design') ? `724px` : '100%';
  }, [isAnimationMinimized, window_type]);

  useEffect(() => {
    if (!loading) {
      saveSceneSnapshot();
    }
  }, [loading]);
  const updateCurrentCamera = (newCamera) => {
    setCurrentCamera(newCamera);
  };

  // const state = store.getState();
  useEffect(() => {
    if (!scene) return;
    const physicsState = store.getState().physics;
    const physicsObjects = physicsState?.physicsObjects || [];

    // Helper: true if this object is in the animation panel (or child of one / has GLB mixer).
    // Include inactive (event-triggered) objects so Play Animation clicks can drive skinned meshes.
    const isAnimatedObjectOrDescendant = (obj) => {
      const matchesAnimPanel = (node) =>
        animationObjects.some(
          (anim) =>
            anim.id === node.name ||
            anim.objectId === node.name ||
            anim.name === node.name ||
            anim.temp_file_name === node.name
        );

      if (matchesAnimPanel(obj)) return true;
      if (obj.userData?.mixer) return true;

      let parent = obj.parent;
      while (parent && parent !== scene) {
        if (matchesAnimPanel(parent) || parent.userData?.mixer) return true;
        parent = parent.parent;
      }
      return false;
    };

    scene.traverse((child) => {
      // Hotspots must keep matrixAutoUpdate so billboard (face camera) works in preview
      if (child.userData?.isHotspot || child.deleteType === 'hotspot') {
        child.matrixAutoUpdate = true;
        return;
      }

      // Scene camera assets must keep live transforms — locking them desyncs
      // rotation Euler vs quaternion and breaks design after preview look-through.
      if (child.isCamera && isSceneCamera(child)) {
        child.matrixAutoUpdate = true;
        return;
      }

      // Foliage, clouds, and other particle systems animate transforms every frame in preview
      if (isUnderParticleAnimationSystem(child, scene)) {
        child.matrixAutoUpdate = true;
        return;
      }

      // Animated: direct match OR descendant of an animated object (playModel/GLB animates hierarchy)
      const hasAnimations = isAnimatedObjectOrDescendant(child);

      // Check if this object has physics
      const hasPhysics = physicsObjects.some(
        (physObj) => physObj.objectId === child.name
      );

      // In preview mode, only disable matrixAutoUpdate for non-animated, non-physics objects
      if (window_type === 'design') {
        child.matrixAutoUpdate = true;
      } else {
        // In preview mode, keep matrixAutoUpdate enabled for animated objects and physics objects
        // Physics objects need matrixAutoUpdate to be handled by physics sync, but we'll update manually
        // Animated objects (and their descendants) need it for playModel/GLB and other effects
        child.matrixAutoUpdate = hasAnimations || hasPhysics ? true : false;
        if (!hasAnimations && !hasPhysics) {
          child.updateMatrix(); // Lock the object's current transform only for non-animated, non-physics objects
        }
      }
    });
  }, [window_type, animationObjects, scene]);

  // Monitor camera changes and update transform controls (design mode only)
  useEffect(() => {
    if (!transformControls || !currentCamera) return;
    transformControls.camera = currentCamera;
    if (window_type === 'preview') {
      transformControls.enabled = false;
      transformControls.detach();
      return;
    }
    transformControls.enabled = true;
    const multi = getMultiSelection();
    // Multi-select pivot is managed by multiSelectionTransform — do not override.
    if (multi.length > 1) return;
    if (selectedObject) {
      transformControls.attach(selectedObject);
    }
  }, [
    currentCamera,
    transformControls,
    selectedObject,
    selectedObjectState,
    window_type,
  ]);

  const stopPreviewAnimations = () => {
    appLeftSectionRef.current?.stopAllAnimations?.();
    stopAllSceneAnimations(previewModeAnimationsRef, previewTimelineRafRef);
  };

  const startPreviewAnimations = () => {
    if (appLeftSectionRef.current?.startAllAnimations) {
      appLeftSectionRef.current.startAllAnimations();
      return;
    }
    startAllSceneAnimations(scene, animationObjects, previewModeAnimationsRef, {
      previewTimelineRafRef,
    });
  };

  const beginEditPivotPoint = (object) => {
    const target =
      object ||
      selectedObjectState ||
      selectedObject ||
      transformControls?.object;
    if (!canEditPivot(target)) {
      toast.error('Select an asset to edit its pivot point.');
      return false;
    }
    setViewportContextMenu(null);
    const session = startPivotEdit({
      scene,
      object: target,
      transformControls,
      camera: currentCamera || camera,
      domElement: renderer?.domElement || rendererRef.current?.domElement,
      orbitControls: controlsOrbit,
    });
    if (!session) {
      toast.error('Could not start pivot editing.');
      return false;
    }
    setIsPivotEditing(true);
    toast('Drag the red pivot, then press Enter to apply (Esc to cancel)', {
      duration: 4500,
    });
    return true;
  };

  const beginMovePivotToMeshCenter = (object) => {
    const target =
      object ||
      selectedObjectState ||
      selectedObject ||
      transformControls?.object;
    if (!canEditPivot(target)) {
      toast.error('Select an asset to move its pivot to the mesh center.');
      return false;
    }
    setViewportContextMenu(null);
    if (hasActivePivotSession()) {
      cancelPivotEdit();
      setIsPivotEditing(false);
    }
    const ok = movePivotToMeshCenter(target, { projectId });
    if (!ok) {
      toast.error('Could not move pivot to mesh center.');
      return false;
    }
    toast.success('Pivot moved to mesh center');
    selectedObject = target;
    setSelectedObjectState(target);
    try {
      transformControls?.attach?.(target);
    } catch (_) {
      /* ignore */
    }
    try {
      applyGridTransformUpdate?.(target);
    } catch (_) {
      /* optional history helper */
    }
    return true;
  };

  const finishPivotEdit = (apply) => {
    if (!hasActivePivotSession()) {
      setIsPivotEditing(false);
      return;
    }
    if (apply) {
      const ok = confirmPivotEdit({ projectId });
      setIsPivotEditing(false);
      if (ok) {
        toast.success('Pivot point updated');
        const obj =
          transformControls?.object ||
          selectedObjectState ||
          selectedObject;
        if (obj) {
          selectedObject = obj;
          setSelectedObjectState(obj);
          try {
            applyGridTransformUpdate?.(obj);
          } catch (_) {
            /* optional history helper */
          }
        }
      }
    } else {
      cancelPivotEdit();
      setIsPivotEditing(false);
      toast('Pivot edit cancelled');
    }
  };

  // Enter confirms / Esc cancels while the pivot marker is active.
  useEffect(() => {
    if (!isPivotEditing) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        finishPivotEdit(true);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        finishPivotEdit(false);
      }
    };
    window.addEventListener('keydown', onKeyDown, true);
    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, [isPivotEditing]);

  const completeObject = {
    GLTFLoader,
    DRACOLoader,
    // PLYLoader,
    SplatLoader,
    Three,
    scene,
    selectedObject,
    setPolyCount,
    polyCount,
    projectId,
    gridAssets,
    transformControls,
    camera, // optional, used for audio
    video, // optional, used for video
    audio, // optional, used for audio
    orthographicCamera,
    perspectiveCamera,
    currentCamera,
    controlsOrbit,
    renderer: renderer || rendererRef.current,
    update: updateCurrentCamera,
    showCameraHelper, // <-- add this
    showLightHelpers, // <-- add this
    animationObjects,
    stopAllAnimations: stopPreviewAnimations,
    restartAnimations: startPreviewAnimations,
    startAllAnimations: startPreviewAnimations,
    Publish,
    setPublished,
    setName,
    setSelectedObjectState,
    syncSelectAll: (primary) => {
      selectedObject = primary;
      UpdateUI(primary, cachedUIElements);
    },
    beginEditPivotPoint,
    beginMovePivotToMeshCenter,
    finishPivotEdit,
    isPivotEditing,
  };

  // Expose scene objects globally for LibrarySection to access
  useEffect(() => {
    window.gridPageSceneObjects = {
      scene,
      transformControls,
      setPolyCount,
    };
    return () => {
      window.gridPageSceneObjects = null;
    };
  }, [scene, transformControls, setPolyCount]);

  useEffect(() => {
    setGridHistoryEditorContext(completeObject);
    return () => setGridHistoryEditorContext(null);
  }, [scene, polyCount, projectId]);

  useEffect(() => {
    if (!nobars) {
      // Flush any stale scene/Redux state from a previous unsaved session before
      // loading fresh content. This prevents unsaved shapes/assets from persisting
      // when the user navigates back to the same project without saving.
      try {
        clearSceneAssets(scene, transformControls);
      } catch (_) {}
      store.dispatch(lightDataUpdate([]));
      store.dispatch(
        clearAssets([
          'sceneMeshes',
          'sceneHotspots',
          'sceneImages',
          'sceneVideos',
          'sceneAudios',
          'sceneText',
          'imageScales',
          'videoScales',
          'audioScales',
          'events',
          'allIntersectedObjects',
          'select_object',
          'openModals',
        ])
      );
      store.dispatch(clearParticles());
      store.dispatch(cleanAllAnimationObjects());

      LoadContent(id, setName, completeObject, {
        setCategory,
        setRedirectionCode,
      });
    } else {
      LoadContentPreview(id, setName, completeObject, nobars);
    }

    // Clean up invalid materials after content loads
    const cleanupTimer = setTimeout(() => {
      const cleaned = cleanupInvalidMaterials(scene);
    }, 2000); // Wait 2 seconds for content to load
    



     // If navigated from Library page with a pending asset, import it after scene loads
    const pendingAsset = location?.state?.pendingLibraryAsset;
    if (pendingAsset) {
      // Wait for LoadContent to finish (scene ready) then import
      const importTimer = setTimeout(async () => {
        try {
          await handleLibraryAssetImport(pendingAsset, {
            scene: completeObject.scene,
            transformControls: completeObject.transformControls,
            setPolyCount: completeObject.setPolyCount,
          });
        } catch (err) {
          console.error('Failed to import pending library asset:', err);
        }
        // Clear state so refresh doesn't re-import
        window.history.replaceState({}, '', window.location.pathname);
      }, 3000); // 3s — enough for LoadContent to finish

      return () => {
        clearTimeout(cleanupTimer);
        clearTimeout(importTimer);
        if (globalShowCameraHelper) globalShowCameraHelper(false);
        if (globalShowLightHelpers) globalShowLightHelpers(true);
      };
    }
    // Cleanup function to hide all helpers when component unmounts
    return () => {
      clearTimeout(cleanupTimer);
      if (globalShowCameraHelper) {
        globalShowCameraHelper(false);
      }
      if (globalShowLightHelpers) {
        globalShowLightHelpers(true);
      }
    };
  }, [id]);

  useTransformControlsHotkeys(completeObject);

  const { startResize, handleReplay } = usePreviewResize({
    completeObject,
    functionCall: () => {
      setActiveTab('');
      setSubmenuOpen('');
    },
  });

  const gridContainerRef = useRef(null);
  const previewEnterScheduledRef = useRef(false);

  useEffect(() => {
    if (!nobars || !enterPreviewOnMount || !onEnterPreview) return;
    if (!scene || loading || !name) return;
    if (previewEnterScheduledRef.current) return;
    previewEnterScheduledRef.current = true;

    onEnterPreview({
      scene,
      completeObject,
      handleReplay,
      startAllAnimations: () =>
        startAllSceneAnimations(
          scene,
          animationObjects,
          previewModeAnimationsRef,
          { previewTimelineRafRef }
        ),
    });
  }, [
    nobars,
    enterPreviewOnMount,
    onEnterPreview,
    scene,
    loading,
    name,
    handleReplay,
    animationObjects,
  ]);

  // // Stop audio on mode switch; in preview, auto-play assets with Play On Awake enabled
  // useEffect(() => {
  //   if (!scene) return;
  //   stopAllSceneAudio(scene);
  //   if (window_type === 'preview') {
  //     resumeAudioContext();
  //     playPreviewAudioOnAwake(scene);
  // // Snapshot before preview when not already saved (e.g. nobars preview); TabContainer saves on tab click
  // useEffect(() => {
  //   if (!scene || window_type !== 'preview') return;
  //   if (!sceneStateHelper.hasSavedStates()) {
  //     sceneStateHelper.saveStates(scene);
  //   }
  // }, [window_type, scene]);

  useEffect(() => {
    if (!scene) return;

    // Stop existing audio
    stopAllSceneAudio(scene);

    if (window_type === 'preview') {
      // Resume audio context
      resumeAudioContext();

      // Auto-play Play On Awake audio
      playPreviewAudioOnAwake(scene);

      // Save snapshot if not already saved
      if (!sceneStateHelper.hasSavedStates()) {
        (sceneHotspots || []).forEach((hp) => {
          try {
            syncHotspotDesignQuaternion(hp);
          } catch (_) {}
        });
        sceneStateHelper.saveStates(scene);
      }

      syncSceneVisibilityFromStore(scene);
      clearSceneParticleLifeTimeouts(scene);
      resumeSceneParticleAnimations(scene);
      syncPreviewAssetEvents(scene);
    }
  }, [window_type, scene]);

  // Pause all media when the browser tab becomes hidden; resume when it becomes visible again.
  // Only resumes audio/video in preview mode — design-mode playback is user-initiated.
  useEffect(() => {
    if (!scene) return;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Tab hidden — pause everything regardless of mode
        stopAllSceneMedia(scene);
      } else if (window_type === 'preview') {
        // Tab visible again and we're in preview — resume audio context and
        // re-trigger Play On Awake audio so the experience continues naturally.
        resumeAudioContext();
        playPreviewAudioOnAwake(scene);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [scene, window_type]);

  // Reset animations only when leaving preview (not on every timeline Redux update in design)
  useEffect(() => {
    const previousMode = prevWindowTypeRef.current;
    prevWindowTypeRef.current = window_type;

    if (previousMode !== 'preview' || window_type !== 'design' || !scene) {
      return;
    }

    // Coming back from preview: clear selection; helpers refresh after
    // scene state restore (below) so frustums match design transforms.
    selectedObject = null;
    store.dispatch(selected_object(null));
    setSelectedObjectState(null);
    const rememberedCameraId = lastDesignSelectedCameraIdRef.current;

    const animationObjectsList =
      store.getState().animation?.animationObjects || animationObjects || [];

    if (appLeftSectionRef.current) {
      appLeftSectionRef.current.stopAllAnimations();
    }

    resetAnimationsToOriginalState(scene, animationObjectsList, {
      restoreTransforms: false,
      restoreMaterials: true,
    });

    prepareHotspotsForDesignMode(sceneHotspots || []);

    if (sceneStateHelper.hasSavedStates()) {
      sceneStateHelper.restoreStates(scene);
      sceneStateHelper.clear();
    }

    (sceneHotspots || []).forEach((hp) => {
      try {
        syncHotspotDesignQuaternion(hp);
      } catch (_) {}
    });

    syncSceneVisibilityFromStore(scene);
    // Design mode: stop lifecycle timers so particles keep playing visibly.
    clearSceneParticleLifeTimeouts(scene);
    resumeSceneParticleAnimations(scene);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Recreate helpers after all preview→design restores have settled.
        restoreCameraHelpersForDesign();
        if (rememberedCameraId && globalSyncCameraHelperVisibility) {
          globalSyncCameraHelperVisibility(rememberedCameraId, false);
        }
        if (rendererRef?.current && camera) {
          rendererRef.current.render(scene, camera);
        }
        lastDesignSelectedCameraIdRef.current = null;
      });
    });
  }, [window_type, scene]);

  // --- Preview mode asset event handler ---
  useEffect(() => {
    if (!rendererRef.current || !scene || !camera) return;
    if (window_type !== 'preview') {
      setHotspotRegistryPreviewMode(false);
      return;
    }
    setHotspotRegistryPreviewMode(true);
    syncHotspotsForPreviewMode(
      store.getState().assets_object?.sceneHotspots || [],
      currentCamera || camera,
      rendererRef.current
    );

    const getPreviewCamera = () => currentCamera || camera;

    const findHotspotAssetData = (hotspotGroup) => {
      const hotspotId =
        hotspotGroup?.name || hotspotGroup?._id || hotspotGroup?.url;
      const hotspotAssets =
        store.getState().assets_object?.assets_data?.hotspot || [];
      return (
        hotspotAssets.find(
          (asset) =>
            asset._id === hotspotId ||
            asset.id === hotspotId ||
            asset.url === hotspotId
        ) || null
      );
    };

    const respondToHotspotPreview = (hotspotGroup) => {
      if (!hotspotGroup?.userData?.isHotspot) return;
      const hotspotData = findHotspotAssetData(hotspotGroup);
      const focusDistance = hotspotData?.focusDistance ?? 10;
      focusCameraOnObject(hotspotGroup, focusDistance);

      if (hotspotGroup.userData.interactionType === 'Hover') {
        const msg =
          hotspotGroup.userData._messageMesh ??
          hotspotGroup.getObjectByName(`${hotspotGroup.name}-message`);
        const isVisible = msg && msg.visible && msg.material?.opacity > 0;
        handleHotspotHover(hotspotGroup, !isVisible);
      } else {
        handleHotspotClick(hotspotGroup, null, focusDistance);
      }
    };
    const findObjectByAffectedAsset = (affectedAsset) => {
      const assetsData = store.getState().assets_object?.assets_data || {};
      return findSceneObjectByEventAssetId(scene, affectedAsset, assetsData);
    };

    // Resolve media URL from target
    const getMediaUrl = (target) => {
      if (!target) return null;
      const fromMesh =
        target.asset_file_path || target.userData?.asset_file_path;
      if (fromMesh) return fromMesh;
      const v =
        target.userData?.video_settings?.video_clip ||
        target.userData?.video_settings?.video_source;
      if (v) return v;
      const a =
        target.userData?.audio_settings?.audio_source ||
        target.userData?.audio_settings?.audio_clip;
      if (a) return a;
      const fromEl =
        target.videoElement?.currentSrc ||
        target.videoElement?.src ||
        target.audioElement?.currentSrc ||
        target.audioElement?.src;
      if (fromEl) return fromEl;
      return null;
    };

    const executeEventAction = (event, clickedObject) => {
      let affectedObject = findObjectByAffectedAsset(event.affectedAsset);
      if (
        !affectedObject &&
        clickedObject &&
        (event.affectedAsset === clickedObject.name ||
          event.affectedAsset === clickedObject._id ||
          event.affectedAsset === clickedObject.url ||
          event.affectedAsset === clickedObject.file_name)
      ) {
        affectedObject = clickedObject;
      }
      if (!affectedObject && event.action !== 'Redirect to URL') {
        return;
      }
      switch (event.action) {
        case 'Disable':
          if (affectedObject) {
            if (!originalVisibilityStates.current.has(affectedObject.uuid)) {
              originalVisibilityStates.current.set(
                affectedObject.uuid,
                affectedObject.visible
              );
            }
            affectedObject.visible = false;
            if (rendererRef.current && camera)
              rendererRef.current.render(scene, camera);
          }
          break;
        case 'Enable':
          if (affectedObject) {
            if (!originalVisibilityStates.current.has(affectedObject.uuid)) {
              originalVisibilityStates.current.set(
                affectedObject.uuid,
                affectedObject.visible
              );
            }
            const assetsData =
              store.getState().assets_object?.assets_data || {};
            if (getPublishVisibleForAsset(scene, affectedObject, assetsData)) {
              affectedObject.visible = true;
            }
            if (rendererRef.current && camera)
              rendererRef.current.render(scene, camera);
          }
          break;
        case 'Play':
          {
            const target =
              clickedObject &&
              (clickedObject === affectedObject ||
                clickedObject.uuid === affectedObject?.uuid)
                ? clickedObject
                : affectedObject;
            if (isAudioMesh(target)) {
              playMeshAudio(target);
              break;
            }
            let media =
              target?.userData?.domElement ||
              target?.videoElement ||
              target?.audioElement;
            if (
              !media &&
              target?.material?.map &&
              target.material.map instanceof Three.VideoTexture
            ) {
              media = target.material.map.image;
            }
            if (media && typeof media.play === 'function') {
              const hasSource = media.currentSrc || media.src;
              const url = getMediaUrl(target);
              if (
                !hasSource ||
                (typeof hasSource === 'string' && hasSource.trim() === '') ||
                (url && url !== media.src)
              ) {
                if (url) {
                  media.src = url;
                  media.load();
                }
              } else if (
                media.readyState !== undefined &&
                media.readyState === 0 &&
                hasSource
              ) {
                media.load();
              }
              const p = media.play();
              if (p && typeof p.catch === 'function') p.catch(() => {});
            }
          }
          break;
        case 'Pause':
          {
            const target =
              clickedObject &&
              (clickedObject === affectedObject ||
                clickedObject.uuid === affectedObject?.uuid)
                ? clickedObject
                : affectedObject;
            if (isAudioMesh(target)) {
              pauseMeshAudio(target);
              break;
            }
            let media =
              target?.userData?.domElement ||
              target?.videoElement ||
              target?.audioElement;
            if (
              !media &&
              target?.material?.map &&
              target.material.map instanceof Three.VideoTexture
            ) {
              media = target.material.map.image;
            }
            if (media && typeof media.pause === 'function') {
              media.pause();
            }
          }
          break;
        case 'Stop':
          {
            const target =
              clickedObject &&
              (clickedObject === affectedObject ||
                clickedObject.uuid === affectedObject?.uuid)
                ? clickedObject
                : affectedObject;
            if (isAudioMesh(target)) {
              stopMeshAudio(target);
              break;
            }
            let media =
              target?.userData?.domElement ||
              target?.videoElement ||
              target?.audioElement;
            if (
              !media &&
              target?.material?.map &&
              target.material.map instanceof Three.VideoTexture
            ) {
              media = target.material.map.image;
            }
            if (media && typeof media.pause === 'function') {
              media.pause();
              media.currentTime = 0;
            }
          }
          break;
        case 'Play Animation':
          {
            let target =
              clickedObject &&
              (clickedObject === affectedObject ||
                clickedObject.uuid === affectedObject?.uuid)
                ? clickedObject
                : affectedObject;
            if (!target && affectedObject) target = affectedObject;

            if (!target) break;

            const eventAssetId = String(event.affectedAsset ?? '');
            const animationConfig = (animationObjects || []).find((animObj) => {
              const candidates = [
                animObj.id,
                animObj.objectId,
                animObj.name,
                animObj.temp_file_name,
                animObj._id,
              ]
                .filter(Boolean)
                .map(String);
              return (
                candidates.includes(eventAssetId) ||
                candidates.includes(String(target.name ?? '')) ||
                candidates.includes(String(target.url ?? ''))
              );
            });
            const effects =
              animationConfig?.timelineEffects ||
              animationConfig?.timeline ||
              [];
            if (!Array.isArray(effects) || effects.length === 0) break;

            const minStart = Math.min(
              ...effects.map((e) => Number(e.startTime || 0))
            );
            const normalizedEffects = effects.map((effect) => ({
              ...effect,
              startTime: Math.max(0, Number(effect.startTime || 0) - minStart),
              endTime: Math.max(0, Number(effect.endTime || 0) - minStart),
            }));

            const existingRef = previewEventAnimationRefs.current.get(
              target.uuid
            );
            if (existingRef?.current) {
              cancelAnimationFrame(existingRef.current);
            }

            // Allow skinned GLB updates for event-triggered playback (isActive may be false)
            target.traverse((child) => {
              child.matrixAutoUpdate = true;
            });

            if (target.userData?.originalPosition) {
              target.position.copy(target.userData.originalPosition);
            }
            if (target.userData?.originalRotation) {
              target.rotation.copy(target.userData.originalRotation);
            }
            if (target.userData?.originalScale) {
              target.scale.copy(target.userData.originalScale);
            }

            const animationIdRef = { current: null };
            previewEventAnimationRefs.current.set(target.uuid, animationIdRef);

            const animatable = getAnimatableObject(target);
            if (animatable?.userData?.animationActions) {
              animatable.userData.animationActions.forEach((action) => {
                action.paused = false;
                if (!action.isRunning()) {
                  action.reset();
                  action.play();
                }
              });
            }

            applyAnimationsToObject(
              target,
              normalizedEffects,
              animationIdRef,
              0
            );
          }
          break;
        case 'Redirect to URL':
          if (event.url) {
            window.open(event.url, '_blank');
          }
          break;
        default:
          break;
      }
    };

    const processEvents = (asset, trigger, inputType) => {
      const events = asset?.events ?? asset?.Events ?? asset?.userData?.events;
      if (!asset || !events || !Array.isArray(events)) return;
      const normalizedTrigger = normalizeEventTrigger(trigger);
      // Mouse, trackpad clicks, and touch taps all drive the same pointer
      // interactions — accept either authored inputType so events work everywhere.
      const pointerInputs = new Set(['Mouse', 'Touch']);
      const isPointerInput = pointerInputs.has(inputType);

      events.forEach((event) => {
        if (normalizeEventTrigger(event.trigger) !== normalizedTrigger) return;
        const eventInput = event.inputType || 'Mouse';
        const matches =
          eventInput === inputType ||
          (isPointerInput && pointerInputs.has(eventInput));
        if (matches) {
          executeEventAction(event, asset);
        }
      });
    };

    let previewSingleClickTimer = null;
    const PREVIEW_SINGLE_CLICK_DELAY_MS = 280;
    const PREVIEW_TAP_MOVE_CANCEL_PX = 12;
    /** After a real touch, browsers also synthesize click/dblclick — ignore those. */
    let ignoreSyntheticClickUntil = 0;
    let lastTouchTapAt = 0;
    let lastTouchClientX = 0;
    let lastTouchClientY = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMovedTooFar = false;

    const clearPreviewSingleClickTimer = () => {
      if (previewSingleClickTimer) {
        clearTimeout(previewSingleClickTimer);
        previewSingleClickTimer = null;
      }
    };

    const markTouchInteraction = () => {
      // Cover the delayed single-click window + synthetic click latency.
      ignoreSyntheticClickUntil =
        Date.now() + PREVIEW_SINGLE_CLICK_DELAY_MS + 400;
    };

    const isSyntheticClickFromTouch = () =>
      Date.now() < ignoreSyntheticClickUntil;

    const runPreviewHitTest = (event, onParent) => {
      if (isPublishing) return;
      const rect = rendererRef.current.domElement.getBoundingClientRect();
      const mouseX = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      const mouseY = -((event.clientY - rect.top) / rect.height) * 2 + 1;
      const previewRaycaster = new Three.Raycaster();
      previewRaycaster.setFromCamera(
        { x: mouseX, y: mouseY },
        getPreviewCamera()
      );
      const state = store.getState();
      const sceneObjects = getPreviewInteractableObjects(
        scene,
        state.assets_object || {}
      );
      const intersects = previewRaycaster.intersectObjects(sceneObjects, true);
      if (intersects.length > 0) {
        let clickedObject = intersects[0].object;
        let parent = clickedObject;
        while (parent.parent && parent.parent !== scene) parent = parent.parent;

        const hotspotButtonHit = intersects.find((hit) => {
          const obj = hit.object;
          if (!obj.userData?.isbutton) return false;
          let p = obj;
          while (p && p !== scene) {
            if (p.userData?.isHotspot || p.deleteType === 'hotspot')
              return true;
            p = p.parent;
          }
          return false;
        });
        if (hotspotButtonHit) {
          let p = hotspotButtonHit.object;
          while (p && p !== scene) {
            if (p.userData?.isHotspot || p.deleteType === 'hotspot') {
              parent = p;
              respondToHotspotPreview(parent);
              break;
            }
            p = p.parent;
          }
        } else if (parent) {
          const isHotspot =
            parent.userData?.isHotspot || parent.deleteType === 'hotspot';
          const clickedButton = clickedObject.userData?.isbutton === true;
          if (isHotspot && clickedButton) {
            respondToHotspotPreview(parent);
          }
        }
        if (parent) {
          onParent(parent);
        }
      }
    };

    const handlePreviewClick = (event) => {
      // One finger tap also emits a synthetic Mouse click — skip the duplicate.
      if (isSyntheticClickFromTouch()) return;
      runPreviewHitTest(event, (parent) => {
        clearPreviewSingleClickTimer();
        previewSingleClickTimer = setTimeout(() => {
          previewSingleClickTimer = null;
          processEvents(parent, 'Single Click', 'Mouse');
        }, PREVIEW_SINGLE_CLICK_DELAY_MS);
      });
    };

    const handlePreviewDoubleClick = (event) => {
      if (isSyntheticClickFromTouch()) return;
      clearPreviewSingleClickTimer();
      runPreviewHitTest(event, (parent) => {
        processEvents(parent, 'Double Click', 'Mouse');
      });
    };

    // Touch: single tap / double tap (do not also process touchstart — that
    // plus the browser's synthetic click was firing interactions twice).
    const handlePreviewTouchEnd = (event) => {
      if (isPublishing) return;
      const touch = event.changedTouches?.[0];
      if (!touch) return;

      markTouchInteraction();

      // Ignore if this was an orbit/pan drag, not a tap.
      if (
        touchMovedTooFar ||
        Math.hypot(touch.clientX - touchStartX, touch.clientY - touchStartY) >=
          PREVIEW_TAP_MOVE_CANCEL_PX
      ) {
        touchMovedTooFar = false;
        return;
      }

      const clientX = touch.clientX;
      const clientY = touch.clientY;
      const now = Date.now();
      const isDoubleTap =
        now - lastTouchTapAt < 300 &&
        Math.hypot(clientX - lastTouchClientX, clientY - lastTouchClientY) < 30;

      lastTouchTapAt = now;
      lastTouchClientX = clientX;
      lastTouchClientY = clientY;

      const touchEvent = { clientX, clientY };

      if (isDoubleTap) {
        clearPreviewSingleClickTimer();
        lastTouchTapAt = 0;
        runPreviewHitTest(touchEvent, (parent) => {
          processEvents(parent, 'Double Click', 'Touch');
        });
        return;
      }

      // Same as mouse: hit-test now (hotspot once), delay only the Single Click event.
      runPreviewHitTest(touchEvent, (parent) => {
        clearPreviewSingleClickTimer();
        previewSingleClickTimer = setTimeout(() => {
          previewSingleClickTimer = null;
          processEvents(parent, 'Single Click', 'Touch');
        }, PREVIEW_SINGLE_CLICK_DELAY_MS);
      });
    };

    const handlePreviewTouchStart = (event) => {
      // Mark early so any immediate synthetic click is suppressed.
      markTouchInteraction();
      const touch = event.touches?.[0];
      if (!touch) return;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchMovedTooFar = false;
    };

    const handlePreviewTouchMove = (event) => {
      const touch = event.touches?.[0];
      if (!touch) return;
      if (
        Math.hypot(touch.clientX - touchStartX, touch.clientY - touchStartY) >=
        PREVIEW_TAP_MOVE_CANCEL_PX
      ) {
        touchMovedTooFar = true;
        clearPreviewSingleClickTimer();
      }
    };

    const domEl = rendererRef.current.domElement;
    try {
      domEl.style.touchAction = 'none';
    } catch (_) {
      /* ignore */
    }
    domEl.addEventListener('click', handlePreviewClick);
    domEl.addEventListener('dblclick', handlePreviewDoubleClick);
    domEl.addEventListener('touchstart', handlePreviewTouchStart, {
      passive: true,
    });
    domEl.addEventListener('touchmove', handlePreviewTouchMove, {
      passive: true,
    });
    domEl.addEventListener('touchend', handlePreviewTouchEnd, {
      passive: true,
    });
    return () => {
      setHotspotRegistryPreviewMode(false);
      stopAllSceneAudio(scene);
      previewEventAnimationRefs.current.forEach((ref) => {
        if (ref?.current) cancelAnimationFrame(ref.current);
      });
      previewEventAnimationRefs.current.clear();
      clearPreviewSingleClickTimer();
      domEl.removeEventListener('click', handlePreviewClick);
      domEl.removeEventListener('dblclick', handlePreviewDoubleClick);
      domEl.removeEventListener('touchstart', handlePreviewTouchStart);
      domEl.removeEventListener('touchmove', handlePreviewTouchMove);
      domEl.removeEventListener('touchend', handlePreviewTouchEnd);
    };
  }, [window_type, rendererRef.current, scene, camera, animationObjects]);

  // Function to reset all media elements (videos and audio) in the scene to initial state
  const resetAllMedia = () => {
    if (!scene) return;

    // Reset the global videoPlaying state
    videoPlaying = false;

    // Traverse all objects in the scene to find videos and audio
    scene.traverse((object) => {
      // Check if object has a video material
      if (
        object.material &&
        object.material.map &&
        object.material.map instanceof Three.VideoTexture
      ) {
        const videoElement = object.material.map.image;
        if (videoElement && typeof videoElement.pause === 'function') {
          videoElement.pause();
          videoElement.currentTime = 0;
        }
      }

      // Check if object has userData with domElement (for video and audio objects)
      if (object.userData && object.userData.domElement) {
        const domElement = object.userData.domElement;
        if (domElement && typeof domElement.pause === 'function') {
          domElement.pause();
          domElement.currentTime = 0;
        }
      }
    });
  };

  // Add effect to restore visibility states when switching back to design mode
  useEffect(() => {
    if (window_type === 'design' && originalVisibilityStates.current.size > 0) {
      // Restore original visibility states for all tracked objects
      originalVisibilityStates.current.forEach(
        (originalVisible, objectUuid) => {
          const object = scene.getObjectByProperty('uuid', objectUuid);
          if (object) {
            object.visible = originalVisible;
          } else {
            console.warn(
              `Object with UUID ${objectUuid} not found in scene during restoration`
            );
          }
        }
      );

      // Clear the stored states after restoring
      originalVisibilityStates.current.clear();
      // Re-render the scene
      if (rendererRef.current && camera) {
        rendererRef.current.render(scene, camera);
      }
    }
  }, [window_type, scene, camera]);

  // Clear visibility states when component unmounts or scene changes
  useEffect(() => {
    return () => {
      if (originalVisibilityStates.current.size > 0) {
        originalVisibilityStates.current.clear();
      }
    };
  }, []);

  useLightHook({
    scene,
    directionalLightRef,
    renderer: rendererState || rendererRef.current,
    selectedObject,
    camera,
    transformControls,
    window_type, // <-- pass window_type here
  });

  const [category, setCategory] = useState(null);

  // Handler to load HDRI file into the scene

  return (
    <div className="select-none ">
      <ReferenceObject scene={scene} category={category} />
      {isPublishingState && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 999999,
            backgroundColor: 'transparent',
            pointerEvents: 'auto',
          }}
        />
      )}
      {/* {(loading || loadingMessage) && (
        <Loader bgColor={loadingMessage ? 'bg-[rgba(0,0,0,0.5)]' : ''} />
      )} */}

      <div className="grid_body p-0 m-0 relative w-full h-full  ">
        {/* left Section */}

        <div
          className={`left_section  l-section bg-f8 p-2  shadow-h ${window_type == 'design' ? 'h-full' : '!h-fit'}`}
        >
          {!loading && !nobars && (
            <AppLeftSection
              ref={appLeftSectionRef}
              key={leftPanelKey}
              setSelectedObjectState={setSelectedObjectState}
              name={name}
              published={published}
              setName={setName}
              objectt={completeObject}
              setPublished={setPublished}
              lastSavedSceneSnapshot={lastSavedSceneSnapshot}
              isAnimationMinimized={isAnimationMinimized}
              animationHeight={animationHeight}
              isAnimationResizing={isAnimationResizing}
            />
          )}
        </div>

        {window_type == 'preview' && !nobars && (
          <PreviewControls
            isOpen={isPreviewControlsOpen}
            onToggle={() => setIsPreviewControlsOpen((prevOpen) => !prevOpen)}
            previewAutoRotateCamera={previewAutoRotateCamera}
            setPreviewAutoRotateCamera={setPreviewAutoRotateCamera}
            previewCameraId={previewCameraId}
            setPreviewCameraId={setPreviewCameraId}
            previewSceneCameras={previewSceneCameras}
          />
        )}

        {/* Top Section */}

        {window_type == 'design' ? (
          <>
            {!nobars && (
              <div className="top_section_new !fixed ">
                <AppTopNew
                  activeTab={activeTab}
                  setLeftPanelKey={setLeftPanelKey}
                  leftPanelKey={leftPanelKey}
                  setSelectedObjectState={setSelectedObjectState}
                  setActiveTab={setActiveTab}
                  submenuOpen={submenuOpen}
                  setSubmenuOpen={setSubmenuOpen}
                  objectt={completeObject}
                  experienceId={projectId}
                />
              </div>
            )}

            {/* AR/VR Experience Dropdown - positioned at top right */}
            <div className="!absolute lg:top-[18px] md:left-[245px] xl:left-[290px] z-[9] md:top-[100px] ">
              <ArVrExperience
                objectt={completeObject}
                setPublished={setPublished}
                setName={setName}
                category={category}
                projectName={name}
                setCategory={setCategory}
                setRedirectionCode={setRedirectionCode}
              />
            </div>

            {/* upload popups starts */}
            <div className="additional_uploads">
              {uploadOptions.map((option) => (
                <div
                  key={option.id}
                  id={option.id}
                  className="popupasset shadow-h"
                >
                  <h2 className="fs-20 fw-700">{option.title}</h2>
                  <input
                    type="file"
                    id={option.inputId}
                    className="centered-file w-100 fs-15"
                    accept={option.accept}
                  />
                  <button
                    className="cancel_up fs-6 fs-16 fw-600"
                    id={option.cancelId}
                    onClick={option.cancelHandler}
                  >
                    Cancel
                  </button>
                </div>
              ))}
            </div>

            {/* object controls starts */}
            <div className="control_buttons rounded">
              <AppSubRightSection
                ChangeTransformControl={ChangeTransformControl}
              />
            </div>
            {/* object controls ends */}

            {isPivotEditing && (
              <div
                className="fixed top-16 left-1/2 -translate-x-1/2 z-[1000001] pointer-events-none select-none"
                style={{
                  background: 'rgba(20,20,22,0.92)',
                  color: '#fff',
                  padding: '8px 14px',
                  borderRadius: 8,
                  fontSize: 13,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.35)',
                }}
              >
                Edit pivot — drag the red marker, then{' '}
                <strong>Enter</strong> to apply or <strong>Esc</strong> to
                cancel
              </div>
            )}

            {viewportContextMenu && (
              <div
                className="fixed inset-0 z-[1000000]"
                onClick={() => setViewportContextMenu(null)}
                onContextMenu={(e) => {
                  e.preventDefault();
                  setViewportContextMenu(null);
                }}
              >
                <div
                  className="absolute bg-[#1d1e21] text-white text-[12px] rounded shadow-lg py-1 min-w-[150px]"
                  style={{
                    left: viewportContextMenu.x,
                    top: viewportContextMenu.y,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    type="button"
                    className="w-full text-left px-3 py-2 hover:bg-[#2a2a2a]"
                    onClick={() => {
                      beginEditPivotPoint(viewportContextMenu.object);
                    }}
                  >
                    Edit Pivot Point
                  </button>
                  <button
                    type="button"
                    className="w-full text-left px-3 py-2 hover:bg-[#2a2a2a]"
                    onClick={() => {
                      beginMovePivotToMeshCenter(viewportContextMenu.object);
                    }}
                  >
                    Move to Mesh Center
                  </button>
                </div>
              </div>
            )}

            {/* App Right Section */}
            {!nobars && !loading && (
              <div className="right_section bg-f8 p-2 shadow-h">
                <AppRightSection
                  key={materialComponentKey} // Force re-render when selectedObject changes
                  setPublished={setPublished}
                  completeImageObject={completeObject}
                  setName={setName}
                  onMinimizeChange={handleAnimationPanelChange}
                  completeObject={completeObject}
                  selectedObject={selectedObject}
                  setSelectedObjectState={setSelectedObjectState}
                  showLightHelpers={showLightHelpers}
                  // isAnimationMinimized={isAnimationMinimized}
                  transformControls={transformControls}
                  isAnimationMinimized={isAnimationMinimized}
                  animationHeight={animationHeight}
                  isAnimationResizing={isAnimationResizing}
                  onHdriSelected={handleHdriSelected}
                  scene={scene}
                  camera={camera}
                  renderer={rendererRef.current}
                  setCategory={setCategory}
                  setRedirectionCode={setRedirectionCode}
                />
              </div>
            )}

            <ConfirmationModel
              isOpen={isDeleteModalOpen}
              title={deleteModalConfig.title}
              message={deleteModalConfig.message}
              onClose={() => {
                setIsDeleteModalOpen(false);
                setObjectToDelete(null);
              }}
              onConfirm={() => {
                const multi = getMultiSelection();
                if (multi.length > 1) {
                  const toDelete = [...multi];
                  clearMultiSelection();
                  toDelete.forEach((obj) => {
                    selectedObject = obj;
                    store.dispatch(selected_object(obj));
                    DeleteMesh(setPolyCount, polyCount, completeObject, {
                      bulkMode: true,
                    });
                  });
                  clearSelectionAfterDelete();
                  setSelectedObjectState(null);
                } else {
                  DeleteMesh(setPolyCount, polyCount, completeObject);
                }
                setIsDeleteModalOpen(false);
                setObjectToDelete(null);
              }}
            />
          </>
        ) : (
          ''
        )}
        {/* Main grid starts */}
        <div className="h-full w-full justify-center items-center ">
          <div
            className="relative"
            id="gridContainer"
            onClick={() => {
              setActiveTab('');
              setSubmenuOpen('');
            }}
            ref={gridContainerRef}
          >
            {sceneScreenshot && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: 50,
                  pointerEvents: 'auto',
                }}
              >
                <img
                  src={sceneScreenshot}
                  alt="Refreshing..."
                  draggable={false}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            )}
            {window_type == 'preview' && !nobars && (
              <>
                {/* Top Center – NS Resize */}
                <div
                  className="z-[1000000] w-[100px] h-2 rounded-full cursor-ns-resize bg-white absolute top-1 left-1/2 -translate-x-1/2"
                  onMouseDown={startResize('height', 'top')}
                />

                {/* Bottom Center – NS Resize */}
                <div
                  className="z-[1000000] w-[100px] h-2 rounded-full cursor-ns-resize bg-white absolute bottom-1 left-1/2 -translate-x-1/2"
                  onMouseDown={startResize('height', 'bottom')}
                />

                {/* Left Center – EW Resize */}
                <div
                  className="z-[1000000] w-2 h-[100px] rounded-full cursor-ew-resize bg-white absolute left-1 top-1/2 -translate-y-1/2"
                  onMouseDown={startResize('width', 'left')}
                />

                {/* Right Center – EW Resize */}
                <div
                  className="z-[1000000] w-2 h-[100px] rounded-full cursor-ew-resize bg-white absolute right-1 top-1/2 -translate-y-1/2"
                  onMouseDown={startResize('width', 'right')}
                />
              </>
            )}
          </div>
        </div>
        {/* right section starts */}
        {!nobars && window_type === 'design' && (
          <CameraSwitcher
            object={completeObject}
            orthographicCamera={orthographicCamera}
            perspectiveCamera={perspectiveCamera}
            currentCamera={currentCamera}
            controlsOrbit={controlsOrbit}
            renderer={renderer}
            scene={scene}
            update={updateCurrentCamera}
            // isAnimationMinimized={isAnimationMinimized}

            isAnimationMinimized={isAnimationMinimized}
            animationHeight={animationHeight}
          />
        )}
        {!nobars && (
          <ViewHelperComponent
            isAnimationMinimized={isAnimationMinimized}
            animationHeight={animationHeight}
          />
        )}

        {published && (
          <PublishData
            projectId={projectId}
            published={published}
            setPublished={setPublished}
            redirectionCode={redirectionCode}
            category={category}
            onAfterPublish={() => {
              const hotspotList =
                store.getState().assets_object?.sceneHotspots || [];
              hotspotList.forEach((hp) => {
                try {
                  removeHotspot(scene, hp);
                } catch (_) {}
              });
              clearSceneAssets(scene, transformControls);
              store.dispatch(
                clearAssets([
                  'sceneMeshes',
                  'sceneHotspots',
                  'sceneImages',
                  'sceneVideos',
                  'sceneAudios',
                  'sceneText',
                  'imageScales',
                  'videoScales',
                  'audioScales',
                  'events',
                  'allIntersectedObjects',
                ])
              );
              store.dispatch(clearParticles());
              LoadContent(id, setName, completeObject, {
                setCategory,
                setRedirectionCode,
              });
            }}
          />
        )}

        <ConfirmationModel
          onConfirm={async () => {
            store.dispatch(setIsConfirmationOpen(false));
            await DeleteMesh(setPolyCount, polyCount, completeObject);
          }}
          isOpen={isConfirmationOpen}
          onClose={() => store.dispatch(setIsConfirmationOpen(false))}
        />
      </div>
      <UploadSection objectt={completeObject} />
      <LibrarySection objectt={completeObject} />
      {!nobars && window_type === 'design' && (
        <AnimationComponentNew
          window_type={window_type}
          completeImageObject={completeObject}
          onMinimizeChange={handleAnimationPanelChange}
          forceShowSignal={animationForceShowSignal}
          onPlayGlbAnimations={(objectId) => {
            // Play default GLB animations for the given object id
            try {
              if (!objectId) {
                toast.error('No object selected');
                return false;
              }

              const target =
                scene.getObjectByName(objectId) ||
                (scene.getObjectByProperty &&
                  scene.getObjectByProperty('url', objectId));

              if (!target) {
                toast.error('Selected object not found in scene');
                return false;
              }

              const animatable = getAnimatableObject(target) || target;
              const clips =
                animatable.userData?.animationClips ||
                animatable.userData?.animations ||
                animatable.animations;

              if (!clips || !clips.length) {
                toast.error('No animations found on the selected model');
                return false;
              }

              animatable.userData = animatable.userData || {};
              if (!animatable.userData.animationClips?.length) {
                animatable.userData.animationClips = clips;
              }

              const targetMixer = ensureGlbMixer(animatable);
              if (!targetMixer) {
                toast.error('Failed to initialize animations');
                return false;
              }

              animatable.userData.animationActions.forEach((a) => {
                try {
                  a.paused = false;
                  if (!a.isRunning()) a.play();
                } catch (err) {
                  console.warn('Action play failed', err);
                }
              });

              animatable.userData.isGlbPlaying = true;
              if (target.userData) target.userData.isGlbPlaying = true;
              toast.success('Playing model animations');
              return true;
            } catch (err) {
              console.error('playGlbAnimations error', err);
              toast.error('Failed to play animations');
              return false;
            }
          }}
        />
      )}
    </div>
  );
}

export default GridPage;

export {
  LoadPly,
  makerGlb,
  DeleteMesh,
  selectObjectInScene,
  selectAllObjects,
  Publish,
  ChangeTransformControl,
  serializeSceneState,
  focusOnObject,
  clearSceneAssets,
  handleHdriSelected,
};
async function onAfterPublish(id, setName, completeObject, options = {}) {
  const { setCategory, setRedirectionCode } = options;
  // Capture screenshot of current scene to prevent blink
  try {
    const canvas = document.querySelector('canvas');
    if (canvas) {
      store.dispatch(setSceneScreenshot(canvas.toDataURL()));
    }
  } catch (err) {
    console.warn('Failed to capture scene screenshot:', err);
  }

  // 1. Unregister hotspots then clear Three.js scene
  const hotspotList = store.getState().assets_object?.sceneHotspots || [];
  hotspotList.forEach((hp) => {
    try {
      removeHotspot(scene, hp);
    } catch (_) {}
  });
  clearSceneLightsAndHelpers(scene);
  try {
    globalThis.dispatchEvent(new CustomEvent(SCENE_LIGHTS_CLEARED_EVENT));
  } catch (_) {}
  store.dispatch(lightDataUpdate([]));
  clearSceneAssets(scene, transformControls);

  // 2. Complete Redux state clearing (Keep metadata like assets_data until LoadContent replaces it to prevent UI jumping)
  store.dispatch(
    clearAssets([
      'sceneMeshes',
      'sceneHotspots',
      'sceneImages',
      'sceneVideos',
      'sceneAudios',
      'sceneText',
      'imageScales',
      'videoScales',
      'audioScales',
      'events',
      'allIntersectedObjects',
      'select_object',
      'openModals',
    ])
  );

  // 3. Clear other Redux slices
  store.dispatch(cleanAllAnimationObjects());

  // 4. Reset global states
  store.dispatch(setIdToDelete(''));
  store.dispatch(setIsConfirmationOpen(false));
  store.dispatch(setLoading(false));
  store.dispatch(setPolyCount(0));
  store.dispatch(updateActiveComponent({}));

  // 5. Reset camera to default
  if (!options.preserveCamera) {
    if (perspectiveCamera && currentCamera !== perspectiveCamera) {
      setCurrentCamera(perspectiveCamera);
    }
  }

  // 6. Reset transform controls
  if (transformControls) {
    transformControls.detach();
    transformControls.setMode('translate');
  }

  // 7. Reset orbit controls
  if (!options.preserveCamera && controlsOrbit) {
    controlsOrbit.reset();
  }

  // 8. Reset animation system state
  resetAnimationSystemState();

  // 9. Reload content - wait for it to complete before refreshing AppLeftSection
  await LoadContent(id, setName, completeObject, {
    silent: true,
    setCategory,
    setRedirectionCode,
  });

  // 10. Notify parent to remount AppLeftSection so it refreshes completely after publish
  // This happens after all publish operations and LoadContent have completed
  try {
    globalThis.dispatchEvent(
      new CustomEvent('remountAppLeftSection', { detail: { projectId: id } })
    );
  } catch (e) {
    console.warn('Could not dispatch remountAppLeftSection event', e);
  }
  store.dispatch(setSceneScreenshot(null));
}

// New function to reset animation system state
function resetAnimationSystemState() {
  // Reset global animation variables
  selectedObject = null;

  // Clear any running animations
  if (mixer) {
    mixer.stopAllAction();
    mixer = null;
  }

  // Reset animation timeline state by dispatching a custom event
  // This will trigger the animation components to reset their local state
  globalThis.dispatchEvent(new CustomEvent('resetAnimationState'));
}
